import * as n from "react";
import { Component as br, useState as A, useRef as B, useEffect as U, useLayoutEffect as $e, isValidElement as un, cloneElement as fa, forwardRef as oo, useContext as qn, createContext as Bn, useMemo as ke, useCallback as re, Fragment as so, Children as ta, createRef as lo } from "react";
import { createPortal as _a } from "react-dom";
import { a as co, t as Er, b as io, f as uo } from "./format-DVsMuX33.js";
const mo = "_page_1l6cf_5", fo = "_inner_1l6cf_25", _o = "_pageScroll_1l6cf_38", po = "_innerScroll_1l6cf_39", bn = {
  page: mo,
  inner: fo,
  pageScroll: _o,
  innerScroll: po
};
function yo({
  gnbHeight: e = 64,
  minWidth: t = 1024,
  scroll: a = "grid",
  className: r = "",
  style: o,
  children: s
}) {
  const l = a === "page";
  return /* @__PURE__ */ n.createElement(
    "main",
    {
      className: [bn.page, l && bn.pageScroll, "axe-page", r].filter(Boolean).join(" "),
      style: { height: `calc(100vh - ${e}px)`, ...o }
    },
    /* @__PURE__ */ n.createElement("div", { className: [bn.inner, l && bn.innerScroll].filter(Boolean).join(" "), style: { minWidth: t } }, s)
  );
}
const bo = "_body_1wgsn_4", Eo = {
  body: bo
};
function Hv({ className: e = "", style: t, children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Eo.body, "axe-page-body", e].filter(Boolean).join(" "), style: t }, a);
}
const ho = "_orbitPortalRoot_177qv_2", go = {
  orbitPortalRoot: ho
};
class Vt extends br {
  constructor() {
    super(...arguments), this.getPortalRoot = () => {
      const t = this.props.portalClassName || go.orbitPortalRoot, a = Array.from(document.body.childNodes).find((r) => r.className === t);
      if (!a) {
        const r = document.createElement("div");
        return r.className = t, document.body.appendChild(r), r;
      }
      return a;
    };
  }
  render() {
    return _a(this.props.children, this.getPortalRoot());
  }
}
const vo = "_anchor_7h2m7_2", ko = "_tip_7h2m7_5", Na = {
  anchor: vo,
  tip: ko
};
let wo = 0;
function jt({
  content: e,
  children: t,
  placement: a = "bottom",
  delay: r = 250,
  focusable: o,
  describe: s = !0,
  className: l = "",
  keepWrapper: c
}) {
  const [i, u] = A(!1), [m, _] = A({ top: 0, left: 0 }), f = B(null), p = B(null), y = B(null), d = B("");
  d.current || (d.current = `axe-tip-${++wo}`);
  const b = () => {
    y.current && (clearTimeout(y.current), y.current = null);
  }, N = (h) => {
    b(), h <= 0 ? u(!0) : y.current = setTimeout(() => u(!0), h);
  }, $ = () => {
    b(), u(!1);
  };
  U(() => b, []), $e(() => {
    if (!i) return;
    const h = () => {
      const w = f.current, E = p.current;
      if (!w || !E) return;
      const D = w.getBoundingClientRect(), C = E.offsetHeight, T = E.offsetWidth;
      let M = a === "top" ? D.top - C - 6 : D.bottom + 6;
      a === "bottom" && M + C > window.innerHeight - 4 && D.top - C - 6 > 4 && (M = D.top - C - 6), a === "top" && M < 4 && D.bottom + 6 + C < window.innerHeight - 4 && (M = D.bottom + 6);
      const R = Math.max(4, Math.min(D.left + D.width / 2 - T / 2, window.innerWidth - T - 4));
      _((q) => q.top === M && q.left === R ? q : { top: M, left: R });
    };
    return h(), window.addEventListener("resize", h), window.addEventListener("scroll", h, !0), () => {
      window.removeEventListener("resize", h), window.removeEventListener("scroll", h, !0);
    };
  }, [i, a, e]), U(() => {
    if (!i) return;
    const h = (w) => {
      w.key !== "Escape" || w.isComposing || (w.preventDefault(), w.stopPropagation(), $());
    };
    return document.addEventListener("keydown", h, !0), () => document.removeEventListener("keydown", h, !0);
  }, [i]);
  const g = e != null && e !== !1 && e !== "";
  if (!g && !c) return t;
  const x = g && un(t) ? fa(t, i && s ? { "aria-describedby": d.current } : {}) : t;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      ref: f,
      className: [Na.anchor, l].filter(Boolean).join(" "),
      tabIndex: o ? 0 : void 0,
      onMouseEnter: () => {
        g && N(r);
      },
      onMouseLeave: $,
      onFocus: () => {
        g && N(0);
      },
      onBlur: $
    },
    x,
    g && i && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: p,
        id: d.current,
        role: "tooltip",
        className: Na.tip,
        style: { top: m.top, left: m.left },
        onMouseEnter: b,
        onMouseLeave: $
      },
      e
    ))
  );
}
const No = "_bar_gkpv7_1", $o = "_menu_gkpv7_17", xo = "_title_gkpv7_27", Do = "_info_gkpv7_29", Ao = "_badge_gkpv7_37", Co = "_badge_muted_gkpv7_38", So = "_badge_ok_gkpv7_39", Mo = "_badge_warn_gkpv7_40", To = "_meta_gkpv7_42", qo = "_actions_gkpv7_26", Bo = "_notice_gkpv7_59", Lo = "_notice_info_gkpv7_65", jo = "_notice_ok_gkpv7_66", Ro = "_notice_err_gkpv7_67", Ue = {
  bar: No,
  menu: $o,
  title: xo,
  info: Do,
  badge: Ao,
  badge_muted: Co,
  badge_ok: So,
  badge_warn: Mo,
  meta: To,
  actions: qo,
  notice: Bo,
  notice_info: Lo,
  notice_ok: jo,
  notice_err: Ro
};
function Io({
  title: e,
  onMenu: t,
  info: a,
  badge: r,
  meta: o,
  notice: s,
  children: l
}) {
  var c;
  return /* @__PURE__ */ n.createElement("header", { className: Ue.bar }, t && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ue.menu, "aria-label": "메뉴", onClick: t }, "☰"), /* @__PURE__ */ n.createElement("h1", { className: Ue.title }, e), a && /* @__PURE__ */ n.createElement(jt, { content: a, focusable: !0, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: Ue.info, role: "img", "aria-label": `안내: ${typeof a == "string" ? a : "자세히"}` }, "i")), (Array.isArray(r) ? r : [r]).filter(Boolean).map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("span", { key: u, className: [Ue.badge, Ue[`badge_${(m = i.tone) != null ? m : "muted"}`]].join(" ") }, i.label);
  }), o && /* @__PURE__ */ n.createElement("span", { className: Ue.meta }, o), /* @__PURE__ */ n.createElement("span", { className: Ue.actions }, s && s.text && /* @__PURE__ */ n.createElement("span", { className: [Ue.notice, Ue[`notice_${(c = s.tone) != null ? c : "info"}`]].join(" "), role: s.tone === "err" ? "alert" : "status" }, s.text), l));
}
const Oo = {
  print: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M7 8V4h10v4" }), /* @__PURE__ */ n.createElement("path", { d: "M7 16H5.5A2.5 2.5 0 0 1 3 13.5v-3A2.5 2.5 0 0 1 5.5 8h13A2.5 2.5 0 0 1 21 10.5v3a2.5 2.5 0 0 1-2.5 2.5H17" }), /* @__PURE__ */ n.createElement("rect", { x: "7", y: "13", width: "10", height: "7", rx: "1" })),
  download: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M12 4v11" }), /* @__PURE__ */ n.createElement("path", { d: "M7.5 11l4.5 4.5 4.5-4.5" }), /* @__PURE__ */ n.createElement("path", { d: "M5 20h14" })),
  edit: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 20h4L19 9a2.1 2.1 0 0 0-3-3L5 17v3z" }), /* @__PURE__ */ n.createElement("path", { d: "M14.5 7.5l3 3" })),
  /* 코드도움·찾기 — 돋보기. 글꼴마다 모양이 다른 문자(⌕ ▦)를 쓰지 않는다 */
  search: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("circle", { cx: "10.5", cy: "10.5", r: "6" }), /* @__PURE__ */ n.createElement("path", { d: "M15 15l5.5 5.5" })),
  /* 날짜 선택 — 달력. 윗변 고리 두 개 + 머리줄 */
  calendar: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("rect", { x: "4", y: "5.5", width: "16", height: "14.5", rx: "2" }), /* @__PURE__ */ n.createElement("path", { d: "M4 10h16" }), /* @__PURE__ */ n.createElement("path", { d: "M8.5 3.5v4M15.5 3.5v4" })),
  trash: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("path", { d: "M4 7h16" }), /* @__PURE__ */ n.createElement("path", { d: "M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" }), /* @__PURE__ */ n.createElement("path", { d: "M6.2 7l.9 12.1A2 2 0 0 0 9.1 21h5.8a2 2 0 0 0 2-1.9L17.8 7" }), /* @__PURE__ */ n.createElement("path", { d: "M10 11v6M14 11v6" }))
}, Po = {
  panel: "▣",
  "chevron-open": "∨",
  "chevron-closed": "＞",
  collapse: "◀",
  expand: "▶",
  mail: "✉",
  chat: "💬",
  save: "💾",
  close: "✕"
};
function Xo({ name: e, className: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: t, "aria-hidden": "true" }, Po[e]);
}
function mn({ name: e, size: t = 15, className: a }) {
  return /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: a,
      width: t,
      height: t,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      style: { verticalAlign: "-2px" },
      "aria-hidden": "true"
    },
    Oo[e]
  );
}
const zo = "_btn_a0orf_1", Fo = "_sm_a0orf_18", Wo = "_primary_a0orf_21", Ho = "_dark_a0orf_23", Ko = "_danger_a0orf_25", Uo = "_soon_a0orf_29", Go = "_soonTag_a0orf_30", Yo = "_blocked_a0orf_39", Vo = "_kbd_a0orf_51", Qo = "_iconBtn_a0orf_54", Jo = "_link_a0orf_70", it = {
  btn: zo,
  sm: Fo,
  primary: Wo,
  dark: Ho,
  danger: Ko,
  soon: Uo,
  soonTag: Go,
  blocked: Yo,
  kbd: Vo,
  iconBtn: Qo,
  link: Jo
}, et = oo(function(t, a) {
  const {
    variant: r = "default",
    size: o = "md",
    icon: s,
    kbd: l,
    soon: c,
    blockedReason: i,
    children: u,
    className: m = "",
    type: _ = "button",
    onClick: f,
    title: p,
    disabled: y,
    ...d
  } = t, b = c || i || "", N = b !== "", $ = "blockedReason" in t, g = /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: a,
      type: _,
      className: [it.btn, it[r], o === "sm" ? it.sm : "", c ? it.soon : N ? it.blocked : "", m].filter(Boolean).join(" "),
      "aria-disabled": N ? !0 : void 0,
      disabled: N ? void 0 : y,
      title: N ? void 0 : p,
      onClick: N ? (x) => x.preventDefault() : f,
      ...d
    },
    s && /* @__PURE__ */ n.createElement(mn, { name: s, size: o === "sm" ? 12 : 14 }),
    u,
    l && /* @__PURE__ */ n.createElement("kbd", { className: it.kbd }, l),
    c && /* @__PURE__ */ n.createElement("em", { className: it.soonTag }, "준비 중")
  );
  return N || $ ? /* @__PURE__ */ n.createElement(jt, { content: b, keepWrapper: $ }, g) : g;
});
function na({ label: e, children: t, className: a = "", type: r = "button", ...o }) {
  return /* @__PURE__ */ n.createElement(jt, { content: e, describe: !1 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: r,
      className: [it.iconBtn, a].filter(Boolean).join(" "),
      "aria-label": e,
      ...o
    },
    t
  ));
}
function pa({ children: e, className: t = "", type: a = "button", ...r }) {
  return /* @__PURE__ */ n.createElement("button", { type: a, className: [it.link, t].filter(Boolean).join(" "), ...r }, e);
}
const Zo = "_wrap_10shm_1", es = "_btn_10shm_2", ts = "_on_10shm_6", ns = "_caret_10shm_8", as = "_pop_10shm_9", rs = "_sec_10shm_14", os = "_item_10shm_17", ss = "_danger_10shm_24", _t = {
  wrap: Zo,
  btn: es,
  on: ts,
  caret: ns,
  pop: as,
  sec: rs,
  item: os,
  danger: ss
}, ls = (e, t, a, r = {}) => ({ kind: "item", key: e, label: t, onClick: a, ...r }), Kv = (e, t, a) => ({ kind: "section", key: e, label: t, note: a });
function cs({ label: e, entries: t, disabled: a, title: r }) {
  const [o, s] = A(!1), l = B(null), c = B(null), i = B(null), u = () => {
    var _, f;
    return Array.from((f = (_ = i.current) == null ? void 0 : _.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? f : []);
  };
  U(() => {
    var _;
    o && ((_ = u()[0]) == null || _.focus());
  }, [o]), U(() => {
    if (!o) return;
    const _ = (p) => {
      l.current && !l.current.contains(p.target) && s(!1);
    }, f = (p) => {
      var y;
      p.key !== "Escape" || p.isComposing || (p.preventDefault(), p.stopPropagation(), s(!1), (y = c.current) == null || y.focus());
    };
    return document.addEventListener("mousedown", _), document.addEventListener("keydown", f, !0), () => {
      document.removeEventListener("mousedown", _), document.removeEventListener("keydown", f, !0);
    };
  }, [o]);
  const m = (_) => {
    const f = u();
    if (f.length === 0) return;
    const p = f.indexOf(document.activeElement);
    let y = -1;
    if (_.key === "ArrowDown") y = (p + 1) % f.length;
    else if (_.key === "ArrowUp") y = (p <= 0 ? f.length : p) - 1;
    else if (_.key === "Home") y = 0;
    else if (_.key === "End") y = f.length - 1;
    else if (_.key === "Tab") {
      s(!1);
      return;
    } else return;
    _.preventDefault(), f[y].focus();
  };
  return /* @__PURE__ */ n.createElement("span", { className: _t.wrap, ref: l }, /* @__PURE__ */ n.createElement(jt, { content: o ? void 0 : r, keepWrapper: !0 }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: [_t.btn, o ? _t.on : ""].join(" "),
      disabled: a,
      "aria-haspopup": "menu",
      "aria-expanded": o,
      onClick: () => s((_) => !_),
      onKeyDown: (_) => {
        _.key === "ArrowDown" && !o && (_.preventDefault(), s(!0));
      }
    },
    e,
    /* @__PURE__ */ n.createElement("span", { className: _t.caret, "aria-hidden": "true" }, "▾")
  )), o && /* @__PURE__ */ n.createElement("div", { ref: i, className: _t.pop, role: "menu", onKeyDown: m }, t.map((_) => _.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: _.key, className: _t.sec }, _.label, _.note && /* @__PURE__ */ n.createElement("small", null, _.note)) : /* @__PURE__ */ n.createElement(
    "button",
    {
      key: _.key,
      type: "button",
      role: "menuitem",
      disabled: _.disabled,
      className: [_t.item, _.danger ? _t.danger : ""].join(" "),
      onClick: () => {
        var f;
        s(!1), (f = c.current) == null || f.focus(), _.onClick();
      }
    },
    /* @__PURE__ */ n.createElement("span", null, _.label),
    _.disabled && _.reason && /* @__PURE__ */ n.createElement("small", null, _.reason)
  ))));
}
const is = "_pop_12uut_2", us = "_auto_12uut_12", ms = "_head_12uut_13", ds = "_title_12uut_18", fs = "_close_12uut_19", _s = "_body_12uut_21", ps = "_flush_12uut_22", ys = "_foot_12uut_23", pt = {
  pop: is,
  auto: us,
  head: ms,
  title: ds,
  close: fs,
  body: _s,
  flush: ps,
  foot: ys
}, En = 8;
function Uv({
  x: e,
  y: t,
  title: a,
  ariaLabel: r,
  onClose: o,
  children: s,
  footer: l,
  closeLabel: c = "닫기",
  width: i,
  closeOnScroll: u = !1,
  flush: m = !1,
  initialFocus: _,
  className: f
}) {
  const p = B(null), [y, d] = A({ left: e, top: t }), b = B(o);
  b.current = o;
  const N = () => {
    const g = p.current;
    if (!g) return;
    const x = g.offsetWidth, h = g.offsetHeight, w = Math.max(En, Math.min(e, window.innerWidth - x - En)), E = t + h > window.innerHeight - En ? Math.max(En, t - h - 32) : t;
    d((D) => D.left === w && D.top === E ? D : { left: w, top: E });
  };
  $e(N, [e, t]), U(() => {
    const g = p.current;
    if (!g || typeof ResizeObserver == "undefined") return;
    const x = new ResizeObserver(N);
    return x.observe(g), () => x.disconnect();
  }, [e, t]), U(() => {
    const g = (E) => {
      p.current && !p.current.contains(E.target) && b.current(!1);
    }, x = (E) => {
      E.key === "Escape" && (E.stopPropagation(), b.current(!0));
    }, h = (E) => {
      var D;
      (!(E.target instanceof Node) || !((D = p.current) != null && D.contains(E.target))) && b.current(!1);
    }, w = window.setTimeout(() => document.addEventListener("mousedown", g), 0);
    return document.addEventListener("keydown", x, !0), u && window.addEventListener("scroll", h, !0), () => {
      window.clearTimeout(w), document.removeEventListener("mousedown", g), document.removeEventListener("keydown", x, !0), window.removeEventListener("scroll", h, !0);
    };
  }, [u]), U(() => {
    var g, x;
    _ && ((x = (g = p.current) == null ? void 0 : g.querySelector(_)) == null || x.focus());
  }, [_]);
  const $ = /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: p,
      className: `${pt.pop}${i ? "" : ` ${pt.auto}`}${f ? ` ${f}` : ""}`,
      style: { left: y.left, top: y.top, ...i ? { width: i } : null },
      role: "dialog",
      "aria-label": r
    },
    /* @__PURE__ */ n.createElement("div", { className: pt.head }, /* @__PURE__ */ n.createElement("span", { className: pt.title }, a), /* @__PURE__ */ n.createElement("button", { type: "button", className: pt.close, onClick: () => b.current(!0), "aria-label": c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: `${pt.body}${m ? ` ${pt.flush}` : ""}` }, s),
    l != null && /* @__PURE__ */ n.createElement("div", { className: pt.foot }, l)
  );
  return typeof document == "undefined" ? $ : _a($, document.body);
}
const bs = "_panel_pg53c_2", Es = "_head_pg53c_3", hs = "_kicker_pg53c_4", gs = "_actions_pg53c_5", vs = "_link_pg53c_6", ks = "_menuHits_pg53c_8", ws = "_turns_pg53c_11", Ns = "_turn_pg53c_11", $s = "_q_pg53c_13", xs = "_a_pg53c_5", Ds = "_aText_pg53c_15", As = "_step_pg53c_16", Cs = "_caret_pg53c_17", Ss = "_err_pg53c_19", Me = {
  panel: bs,
  head: Es,
  kicker: hs,
  actions: gs,
  link: vs,
  menuHits: ks,
  turns: ws,
  turn: Ns,
  q: $s,
  a: xs,
  aText: Ds,
  step: As,
  caret: Cs,
  err: Ss
};
function Gv({ turns: e, busy: t, menuHits: a, onNavigate: r, onReset: o, onClose: s, labels: l }) {
  const c = B(null), i = e.length ? e[e.length - 1].answer.length : 0;
  return U(() => {
    var u;
    (u = c.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [e.length, i]), /* @__PURE__ */ n.createElement("section", { className: Me.panel, "aria-live": "polite" }, /* @__PURE__ */ n.createElement("header", { className: Me.head }, /* @__PURE__ */ n.createElement("span", { className: Me.kicker }, l.kicker), /* @__PURE__ */ n.createElement("span", { className: Me.actions }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: o, disabled: t }, l.reset), /* @__PURE__ */ n.createElement("button", { type: "button", className: Me.link, onClick: s, "aria-label": l.closePanel }, l.close))), a.length > 0 && /* @__PURE__ */ n.createElement("div", { className: Me.menuHits }, /* @__PURE__ */ n.createElement("span", null, l.relatedMenus), a.map((u) => /* @__PURE__ */ n.createElement("button", { type: "button", key: u.path, onClick: () => r(u.path) }, u.label, " ↗"))), /* @__PURE__ */ n.createElement("div", { className: Me.turns }, e.map((u) => {
    var m;
    return /* @__PURE__ */ n.createElement("article", { key: u.id, className: Me.turn }, /* @__PURE__ */ n.createElement("div", { className: Me.q }, u.question), /* @__PURE__ */ n.createElement("div", { className: Me.a }, u.answer && /* @__PURE__ */ n.createElement("div", { className: Me.aText }, u.answer), u.streaming && /* @__PURE__ */ n.createElement("div", { className: Me.step }, (m = u.step) != null ? m : u.answer ? "" : l.waiting, /* @__PURE__ */ n.createElement("span", { className: Me.caret })), u.error && /* @__PURE__ */ n.createElement("div", { className: Me.err }, u.error)));
  }), /* @__PURE__ */ n.createElement("div", { ref: c })));
}
function Yv(e, t, a = !0) {
  const r = B(t);
  r.current = t, U(() => {
    if (!a) return;
    const o = (s) => {
      if (s.key !== "Enter" || !(s.ctrlKey || s.metaKey) || s.isComposing || s.repeat || s.defaultPrevented) return;
      const l = e.current, c = document.activeElement;
      !l || !c || !l.contains(c) || (s.preventDefault(), r.current());
    };
    return document.addEventListener("keydown", o), () => document.removeEventListener("keydown", o);
  }, [e, a]);
}
function Ms() {
  const e = typeof navigator != "undefined" && (navigator.platform || navigator.userAgent) || "";
  return /Mac|iPhone|iPad/i.test(e) ? "⌘+Enter" : "Ctrl+Enter";
}
const Ts = "_bar_1g564_2", qs = "_sticky_1g564_12", Bs = "_start_1g564_19", Ls = "_end_1g564_20", js = "_status_1g564_22", Rs = "_dirty_1g564_23", Is = "_kbd_1g564_25", $t = {
  bar: Ts,
  sticky: qs,
  start: Bs,
  end: Ls,
  status: js,
  dirty: Rs,
  kbd: Is
};
function Vv({ start: e, children: t, status: a, dirty: r, inline: o, shortcutHint: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-save-bar", $t.bar, o ? "" : $t.sticky, l].filter(Boolean).join(" "), role: "group", "aria-label": "저장" }, /* @__PURE__ */ n.createElement("span", { className: $t.start }, e), /* @__PURE__ */ n.createElement("span", { className: $t.end }, a && /* @__PURE__ */ n.createElement("span", { className: [$t.status, r ? $t.dirty : ""].filter(Boolean).join(" "), "aria-live": "polite" }, a), t, s && /* @__PURE__ */ n.createElement("kbd", { className: $t.kbd }, Ms())));
}
const Os = "_root_j67qt_2", Ps = "_closed_j67qt_3", Xs = "_tab_j67qt_6", zs = "_collapse_j67qt_7", Fs = "_body_j67qt_16", Ws = "_card_j67qt_32", Hs = "_head_j67qt_37", Ks = "_cardOpen_j67qt_44", Us = "_headBtn_j67qt_47", Gs = "_icon_j67qt_56", Ys = "_badge_j67qt_57", Vs = "_trailing_j67qt_58", Qs = "_chev_j67qt_59", Js = "_panelWrap_j67qt_63", Zs = "_panelOpen_j67qt_67", el = "_panelBody_j67qt_68", tl = "_panelInner_j67qt_69", nl = "_panelSettled_j67qt_70", ge = {
  root: Os,
  closed: Ps,
  tab: Xs,
  collapse: zs,
  body: Fs,
  card: Ws,
  head: Hs,
  cardOpen: Ks,
  headBtn: Us,
  icon: Gs,
  badge: Ys,
  trailing: Vs,
  chev: Qs,
  panelWrap: Js,
  panelOpen: Zs,
  panelBody: el,
  panelInner: tl,
  panelSettled: nl
}, al = 1280, rl = 8, hr = "axe-side-bar:";
function ol(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(hr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function sl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(hr + e, t ? "1" : "0");
    } catch {
    }
}
function Qv({
  enabled: e = !0,
  defaultOpen: t = !0,
  width: a = 260,
  collapseBelow: r = al,
  storageKey: o,
  className: s = "",
  children: l
}) {
  var f;
  const c = B(ol(o)), [i, u] = A((f = c.current) != null ? f : t), m = B(c.current !== null);
  if (U(() => {
    if (!e || !r || typeof window.matchMedia != "function") return;
    const p = window.matchMedia(`(max-width: ${r - 1}px)`), y = () => {
      m.current || u(!p.matches && t);
    };
    return y(), p.addEventListener ? p.addEventListener("change", y) : p.addListener(y), () => {
      p.removeEventListener ? p.removeEventListener("change", y) : p.removeListener(y);
    };
  }, [e, r, t]), !e) return null;
  const _ = () => {
    m.current = !0, sl(o, !i), u(!i);
  };
  return /* @__PURE__ */ n.createElement(
    "aside",
    {
      className: ["axe-side-bar", ge.root, i ? "" : ge.closed, s].filter(Boolean).join(" "),
      style: { width: i ? a : rl }
    },
    /* @__PURE__ */ n.createElement("div", { className: ge.tab }, /* @__PURE__ */ n.createElement(jt, { content: i ? "정보 패널 접기" : "정보 패널 펼치기", describe: !1 }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: ge.collapse,
        onClick: _,
        "aria-label": i ? "정보 패널 접기" : "정보 패널 펼치기",
        "aria-expanded": i
      },
      /* @__PURE__ */ n.createElement(Xo, { name: i ? "collapse" : "expand" })
    ))),
    /* @__PURE__ */ n.createElement("div", { className: ge.body }, l)
  );
}
const gr = Bn(null);
function Jv({ children: e, defaultOpenId: t = null, exclusive: a = !0 }) {
  const [r, o] = A(t);
  return a ? /* @__PURE__ */ n.createElement(gr.Provider, { value: { openId: r, setOpenId: o } }, e) : /* @__PURE__ */ n.createElement(n.Fragment, null, e);
}
const vr = "axe-side-panel:";
function ll(e) {
  if (!e) return null;
  try {
    const t = window.localStorage.getItem(vr + e);
    return t === "1" ? !0 : t === "0" ? !1 : null;
  } catch {
    return null;
  }
}
function cl(e, t) {
  if (e)
    try {
      window.localStorage.setItem(vr + e, t ? "1" : "0");
    } catch {
    }
}
function Zv({
  title: e,
  enabled: t = !0,
  defaultOpen: a = !0,
  icon: r,
  badge: o,
  trailing: s,
  storageKey: l,
  panelId: c,
  className: i = "",
  children: u
}) {
  var h;
  const m = qn(gr), _ = !!m && c != null, f = B(ll(l)), [p, y] = A((h = f.current) != null ? h : a), d = _ ? m.openId === c : p, [b, N] = A(d), [$, g] = A(d);
  if (!t) return null;
  d && !b && N(!0);
  const x = () => {
    const w = !d;
    cl(l, w), N(!0), g(!1), _ ? m.setOpenId(w ? c : null) : y(w);
  };
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-side-card", ge.card, d ? ge.cardOpen : "", i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("header", { className: ge.head, onClick: x }, /* @__PURE__ */ n.createElement("button", { type: "button", className: ge.headBtn, "aria-expanded": d }, r && /* @__PURE__ */ n.createElement("span", { className: ge.icon, "aria-hidden": "true" }, r), /* @__PURE__ */ n.createElement("strong", null, e)), o && /* @__PURE__ */ n.createElement("span", { className: ge.badge }, o), s && /* @__PURE__ */ n.createElement("span", { className: ge.trailing, onClick: (w) => w.stopPropagation() }, s), /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: ge.chev,
      width: "14",
      height: "14",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2.2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      "aria-hidden": "true"
    },
    /* @__PURE__ */ n.createElement("path", { d: "M6 9l6 6 6-6" })
  )), b && /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ge.panelWrap, d ? ge.panelOpen : ""].filter(Boolean).join(" "),
      onTransitionEnd: (w) => {
        w.target === w.currentTarget && w.propertyName === "grid-template-rows" && g(!0);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: [ge.panelBody, d && $ ? ge.panelSettled : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ge.panelInner }, u))
  ));
}
const il = "_guide_qnh7l_1", ul = "_title_qnh7l_5", ml = "_desc_qnh7l_6", dl = "_act_qnh7l_7", fl = "_why_qnh7l_13", _l = "_steps_qnh7l_14", pl = "_no_qnh7l_20", yl = "_cur_qnh7l_24", bl = "_link_qnh7l_26", at = {
  guide: il,
  title: ul,
  desc: ml,
  act: dl,
  why: fl,
  steps: _l,
  no: pl,
  cur: yl,
  link: bl
};
function e0({ title: e, desc: t, action: a, steps: r }) {
  return /* @__PURE__ */ n.createElement("section", { className: at.guide, "aria-label": e }, /* @__PURE__ */ n.createElement("h2", { className: at.title }, e), t && /* @__PURE__ */ n.createElement("p", { className: at.desc }, t), a && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", className: at.act, disabled: a.disabled, onClick: a.onClick }, a.label), a.disabled && a.reason && /* @__PURE__ */ n.createElement("p", { className: at.why }, a.reason)), r && r.length > 0 && /* @__PURE__ */ n.createElement("ol", { className: at.steps }, r.map((o, s) => /* @__PURE__ */ n.createElement("li", { key: o.label, className: o.current ? at.cur : void 0 }, /* @__PURE__ */ n.createElement("span", { className: at.no }, s + 1), o.onClick && !o.current ? /* @__PURE__ */ n.createElement("button", { type: "button", className: at.link, onClick: o.onClick }, o.label) : /* @__PURE__ */ n.createElement("span", null, o.label), o.hint && /* @__PURE__ */ n.createElement("small", null, o.hint)))));
}
const El = "_list_1w2rs_1", hl = "_row_1w2rs_2", gl = "_label_1w2rs_6", vl = "_value_1w2rs_7", kl = "_emphasis_1w2rs_8", wl = "_changed_1w2rs_10", Pt = {
  list: El,
  row: hl,
  label: gl,
  value: vl,
  emphasis: kl,
  changed: wl
};
function t0({ items: e, className: t }) {
  return /* @__PURE__ */ n.createElement("dl", { className: [Pt.list, t != null ? t : ""].join(" ") }, e.map((a, r) => /* @__PURE__ */ n.createElement("div", { key: r, className: [Pt.row, a.emphasis ? Pt.emphasis : ""].join(" ") }, /* @__PURE__ */ n.createElement("dt", { className: Pt.label }, a.label), /* @__PURE__ */ n.createElement("dd", { className: [Pt.value, a.changed ? Pt.changed : ""].join(" ") }, a.value))));
}
const Nl = "_underline_xl221_2", $l = "_active_xl221_24", xl = "_segmented_xl221_33", zn = {
  underline: Nl,
  active: $l,
  segmented: xl
};
function kr({
  items: e,
  value: t,
  onChange: a,
  variant: r = "underline",
  className: o = "",
  "aria-label": s
}) {
  return /* @__PURE__ */ n.createElement(
    "nav",
    {
      className: [r === "segmented" ? zn.segmented : zn.underline, o].filter(Boolean).join(" "),
      role: "tablist",
      "aria-label": s
    },
    e.map((l) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: l.key,
        type: "button",
        role: "tab",
        "aria-selected": l.key === t,
        className: l.key === t ? zn.active : "",
        onClick: () => a(l.key)
      },
      l.label
    ))
  );
}
const Dl = "_bar_1adxf_1", Al = "_actions_1adxf_17", Cl = "_field_1adxf_24", Sl = "_fieldLabel_1adxf_25", Ml = "_readout_1adxf_33", Tl = "_search_1adxf_44", ql = "_detail_1adxf_58", Bl = "_pill_1adxf_71", Ll = "_hint_1adxf_82", Ve = {
  bar: Dl,
  actions: Al,
  field: Cl,
  fieldLabel: Sl,
  readout: Ml,
  search: Tl,
  detail: ql,
  pill: Bl,
  hint: Ll
}, jl = /* @__PURE__ */ new Set(["text", "search", "number", "tel", "email", "url", "password", ""]);
function Rl(e) {
  if (e.key !== "Enter" || e.defaultPrevented || e.nativeEvent.isComposing || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return !1;
  const t = e.target;
  return !(!(t instanceof HTMLInputElement) || !e.currentTarget.contains(t) || !jl.has(t.type) || t.readOnly || t.disabled || t.getAttribute("role") === "combobox" || t.getAttribute("aria-expanded") === "true");
}
function n0({
  children: e,
  onSearch: t,
  searchLabel: a = "조회",
  searchDisabled: r,
  searchTitle: o,
  detailSearch: s = !1,
  onDetailSearch: l,
  detailLabel: c = "상세검색",
  onReset: i,
  resetLabel: u = "초기화",
  resetDisabled: m,
  trailing: _,
  enterSearch: f = !0
}) {
  const p = (y) => {
    !f || !t || r || !Rl(y) || (y.preventDefault(), t());
  };
  return /* @__PURE__ */ n.createElement("section", { className: Ve.bar, onKeyDown: p }, e, /* @__PURE__ */ n.createElement("span", { className: Ve.actions }, _, i && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: i, disabled: m }, u), s && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.detail, onClick: l }, "⌕ ", c), t && /* @__PURE__ */ n.createElement(jt, { content: o, keepWrapper: !0 }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ve.search, onClick: t, disabled: r }, "⌕ ", a))));
}
function Il({ label: e, children: t }) {
  return /* @__PURE__ */ n.createElement("label", { className: Ve.field }, /* @__PURE__ */ n.createElement("span", { className: Ve.fieldLabel }, e), t);
}
function a0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.readout }, e);
}
function r0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.pill, role: "status" }, e);
}
function o0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ve.hint }, e);
}
function Ol(e) {
  return `${e.gisu}기 (${e.startDa} ~ ${e.endDa})${e.closeYn ? " · 마감" : ""}`;
}
function s0({ rows: e, value: t, onChange: a, disabled: r, label: o = "기수" }) {
  return /* @__PURE__ */ n.createElement(Il, { label: o }, /* @__PURE__ */ n.createElement(
    "select",
    {
      value: t != null ? t : "",
      "aria-label": o,
      disabled: r,
      style: { width: "var(--axe-field-w-lg, 240px)" },
      onChange: (s) => a(Number(s.target.value))
    },
    e.map((s) => /* @__PURE__ */ n.createElement("option", { key: s.gisu, value: s.gisu }, Ol(s)))
  ));
}
class wr {
  constructor(t, a) {
    this._resizeObserver = null, this.initializeResizeObserver = () => {
      this._resizeObserver = new ResizeObserver((r) => {
        try {
          for (const o of r) {
            const s = o.borderBoxSize[0];
            this._callback({ width: s.inlineSize, height: s.blockSize }, o);
          }
        } catch (o) {
          console.error(o);
        }
      }), this._resizeObserver.observe(this._element);
    }, this.refresh = () => {
    }, this.detach = () => {
      this._resizeObserver && this._resizeObserver.disconnect();
    }, this.reset = () => {
    }, this._element = t, this._callback = a, this.initializeResizeObserver();
  }
}
function Nr(e, t) {
  return !e || e.key !== t ? { key: t, dir: "asc" } : e.dir === "asc" ? { key: t, dir: "desc" } : null;
}
function $r(e, t) {
  return !e || e.key !== t ? "none" : e.dir === "asc" ? "ascending" : "descending";
}
function xr(e, t) {
  return e ? `${t(e.key)} ${e.dir === "asc" ? "오름차순" : "내림차순"} 정렬` : "정렬을 해제했습니다";
}
function Pl(e) {
  const t = e.replace(/\s+/g, " ").trim();
  if (!t || t === "-") return null;
  const a = /^([-+]?)\(?[₩$]?\s*([\d,]*\.?\d+)\)?\s*(%|원|개|건)?$/.exec(t);
  if (a && /^\d{1,3}(,\d{3})*(\.\d+)?$|^\d*\.?\d+$/.test(a[2])) {
    const r = parseFloat(a[2].replace(/,/g, ""));
    return a[1] === "-" || /^[-+]?\(/.test(t) ? -r : r;
  }
  return t;
}
function Dr(e, t, a) {
  if (e === null || t === null) return e === t ? 0 : e === null ? 1 : -1;
  let r;
  return typeof e == "number" && typeof t == "number" ? r = e - t : typeof e == "number" ? r = -1 : typeof t == "number" ? r = 1 : r = e.localeCompare(t, "ko", { numeric: !0, sensitivity: "base" }), a === "asc" ? r : -r;
}
function Xl(e, t) {
  const a = [], r = (l) => {
    l.sort((c, i) => Dr(e[c.i].value, e[i.i].value, t) || c.i - i.i), l.forEach((c) => {
      a.push(c.i), r(c.kids);
    });
  };
  let o = [], s = [];
  return e.forEach((l, c) => {
    if (l.level === null) {
      r(o), o = [], s = [], a.push(c);
      return;
    }
    for (; s.length && s[s.length - 1].level >= l.level; ) s.pop();
    const i = { i: c, kids: [] };
    (s.length ? s[s.length - 1].node.kids : o).push(i), s.push({ level: l.level, node: i });
  }), r(o), a;
}
function zl(e, t) {
  const a = new Set(t), r = e.filter((s) => a.has(s)), o = new Set(r);
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    if (o.has(l)) continue;
    const c = s + 1 < t.length ? r.indexOf(t[s + 1]) : -1;
    c < 0 ? r.push(l) : r.splice(c, 0, l), o.add(l);
  }
  return r;
}
function Fl(e, t) {
  const a = /* @__PURE__ */ new Map();
  t.forEach((c, i) => a.set(c, i));
  const r = e.map((c) => {
    var i;
    return (i = a.get(c)) != null ? i : -1;
  }), o = [], s = new Array(r.length).fill(-1);
  r.forEach((c, i) => {
    if (c < 0) return;
    let u = 0, m = o.length;
    for (; u < m; ) {
      const _ = u + m >> 1;
      r[o[_]] < c ? u = _ + 1 : m = _;
    }
    u > 0 && (s[i] = o[u - 1]), o[u] = i;
  });
  const l = /* @__PURE__ */ new Set();
  for (let c = o.length ? o[o.length - 1] : -1; c >= 0; c = s[c]) l.add(e[c]);
  return l;
}
const Wl = 'input, select, textarea, button, a[href], [role="checkbox"], [role="button"]', Hl = ".axe-group-row, .axe-input-row, .axe-total-row, [data-sort-fixed]";
function Kl(e) {
  const t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
  for (const r of e) {
    a.forEach((s, l) => {
      s <= 1 ? a.delete(l) : a.set(l, s - 1);
    });
    let o = 0;
    for (const s of Array.from(r.cells)) {
      for (; a.has(o); ) o += 1;
      const l = s.colSpan || 1;
      if (t.set(s, o), s.rowSpan > 1) for (let c = o; c < o + l; c += 1) a.set(c, s.rowSpan);
      o += l;
    }
  }
  return t;
}
function Ul(e) {
  const t = e.tHead;
  if (!t) return [];
  const a = Kl(Array.from(t.rows)), r = [];
  return a.forEach((o, s) => {
    var c, i;
    if (s.tagName !== "TH" || (s.colSpan || 1) !== 1 || s.dataset.sortable === "false" || s.hasAttribute("aria-sort") && s.dataset.axeSort === void 0 || s.querySelector(Wl)) return;
    const l = ((c = s.textContent) != null ? c : "").replace(/\s+/g, " ").trim();
    l && r.push({ th: s, col: o, key: (i = s.dataset.sortKey) != null ? i : String(o), label: l });
  }), r;
}
function $a(e, t) {
  var r;
  let a = 0;
  for (const o of Array.from(e.cells)) {
    const s = o.colSpan || 1;
    if (t < a + s) {
      const l = o.dataset.sortValue;
      if (l !== void 0) {
        const i = Number(l);
        return l === "" ? null : Number.isFinite(i) ? i : l;
      }
      const c = o.querySelector('input:not([type="checkbox"]):not([type="radio"]), select');
      return Pl(c ? c.value : (r = o.textContent) != null ? r : "");
    }
    a += s;
  }
  return null;
}
function Gl(e) {
  if (e.matches(Hl) || e.cells.length === 1 && (e.cells[0].colSpan || 1) > 1) return null;
  const t = Number(e.getAttribute("aria-level"));
  return Number.isFinite(t) && t >= 1 ? t : 1;
}
function Yl() {
  return { parent: null, base: [], shown: [], sig: "" };
}
function Vl(e) {
  const t = Array.from(e.tBodies);
  if (t.length > 1) return { parent: e, items: t, bodies: !0 };
  const a = t[0];
  if (!a) return null;
  const r = Array.from(a.rows);
  return r.some((o) => Array.from(o.cells).some((s) => s.rowSpan > 1)) ? null : { parent: a, items: r, bodies: !1 };
}
const Ar = (e, t) => e.length === t.length && e.every((a, r) => a === t[r]);
function Ql(e, t, a) {
  if (Ar(t, a)) return;
  const r = Fl(t, a);
  let o = a.length ? a[a.length - 1].nextElementSibling : null;
  for (let s = t.length - 1; s >= 0; s -= 1) {
    const l = t[s];
    r.has(l) || e.insertBefore(l, o), o = l;
  }
}
function Jl(e, t, a, r) {
  if (t) {
    const l = e.map((c, i) => ({ b: c, i, v: c.rows[0] ? $a(c.rows[0], a) : null }));
    return l.sort((c, i) => Dr(c.v, i.v, r) || c.i - i.i), l.map((c) => c.b);
  }
  const o = e, s = o.map((l) => {
    const c = Gl(l);
    return { level: c, value: c === null ? null : $a(l, a) };
  });
  return Xl(s, r).map((l) => o[l]);
}
function Zl(e, t, a) {
  const r = Vl(e);
  if ((!r || r.parent !== a.parent) && (a.parent = r ? r.parent : null, a.base = r ? r.items : [], a.shown = a.base, a.sig = "", !r))
    return;
  const o = r.items, s = t ? `${t.col}:${t.dir}` : "";
  if (s === a.sig && Ar(o, a.shown)) return;
  a.base = a.sig ? zl(a.base, o) : o;
  let l = t ? Jl(a.base, r.bodies, t.col, t.dir) : a.base;
  if (t && s === a.sig) {
    const c = new Set(a.shown), i = a.shown.filter((m) => m.parentElement === r.parent);
    let u = 0;
    l = l.map((m) => c.has(m) ? i[u++] : m);
  }
  Ql(r.parent, l, o), a.shown = l, a.sig = s;
}
const ec = "input, select, textarea, button";
function tc(e) {
  const t = e == null ? void 0 : e.tHead;
  if (!t) return [];
  const a = [];
  return t.querySelectorAll("th").forEach((r) => {
    var c;
    const o = ((c = r.textContent) != null ? c : "").replace(/\s+/g, " ").trim(), s = r.dataset.axeTitle !== void 0 && r.dataset.axeTitle === r.getAttribute("title");
    o !== "" && !r.querySelector(ec) && r.scrollWidth > r.clientWidth + 1 ? (a.push({ label: o, short: r.scrollWidth - r.clientWidth, sortMark: r.dataset.axeSort !== void 0 }), (!r.hasAttribute("title") || s) && (r.getAttribute("title") !== o && r.setAttribute("title", o), r.dataset.axeTitle !== o && (r.dataset.axeTitle = o))) : s && (r.removeAttribute("title"), delete r.dataset.axeTitle);
  }), a;
}
const Cr = Bn(null), nc = "_card_1j6er_2", ac = "_grow_1j6er_24", rc = "_head_1j6er_26", oc = "_title_1j6er_35", sc = "_trailing_1j6er_36", lc = "_scroll_1j6er_6", cc = "_foot_1j6er_54", ic = "_strip_1j6er_56", uc = "_pager_1j6er_58", mc = "_spacer_1j6er_60", dc = "_table_1j6er_62", fc = "_fixed_1j6er_63", _c = "_fz_1j6er_81", pc = "_fzEdge_1j6er_93", yc = "_frozen_1j6er_100", bc = "_sr_1j6er_162", Ec = "_statusCell_1j6er_43", hc = "_status_1j6er_43", gc = "_st_error_1j6er_244", vc = "_stIcon_1j6er_245", kc = "_spin_1j6er_251", wc = "_axeSpin_1j6er_1", Nc = "_busy_1j6er_261", $c = "_statusRow_1j6er_263", xc = "_busyBar_1j6er_264", Dc = "_axeBusy_1j6er_1", ce = {
  card: nc,
  grow: ac,
  head: rc,
  title: oc,
  trailing: sc,
  scroll: lc,
  foot: cc,
  strip: ic,
  pager: uc,
  spacer: mc,
  table: dc,
  fixed: fc,
  fz: _c,
  fzEdge: pc,
  frozen: yc,
  sr: bc,
  statusCell: Ec,
  status: hc,
  st_error: gc,
  stIcon: vc,
  spin: kc,
  axeSpin: wc,
  busy: Nc,
  statusRow: $c,
  busyBar: xc,
  axeBusy: Dc
}, Ac = 120;
function Cc(e) {
  if (!e || !e.length) return;
  let t = 0, a = 0;
  for (const r of e)
    if (r == null) a += 1;
    else if (typeof r == "number") t += r;
    else if (/^\d+(\.\d+)?px$/.test(r)) t += parseFloat(r);
    else return;
  return a > 0 ? t + a * Ac : void 0;
}
function xa({ cols: e }) {
  return !e || !e.length ? null : /* @__PURE__ */ n.createElement("colgroup", null, e.map((t, a) => /* @__PURE__ */ n.createElement("col", { key: a, style: t == null ? void 0 : { width: t } })));
}
const Ut = /* @__PURE__ */ new Set();
function ya() {
  var e;
  return typeof process != "undefined" && ((e = process.env) != null && e.NODE_ENV) ? process.env.NODE_ENV !== "production" : typeof location != "undefined" && /^(localhost|127.0.0.1|[::1])$/.test(location.hostname);
}
function Sc(e) {
  if (!ya() || !e || e.getAttribute("aria-label") || e.getAttribute("aria-labelledby")) return;
  const t = Array.from(e.querySelectorAll("thead th")).slice(0, 4).map((r) => {
    var o;
    return (o = r.textContent) == null ? void 0 : o.trim();
  }).filter(Boolean), a = `unnamed|${t.join("|")}`;
  Ut.has(a) || (Ut.add(a), console.warn(`[AXErpGrid] 표 이름이 없습니다 — aria-label(예 「전표 목록」)을 주세요. 머리글: ${t.join(" · ")}`));
}
function Mc(e) {
  if (!ya()) return;
  const t = [];
  if (e.querySelectorAll("td.axe-money").forEach((r) => {
    var o, s;
    r.scrollWidth > r.clientWidth + 1 && t.push((s = (o = r.textContent) == null ? void 0 : o.trim()) != null ? s : "");
  }), !t.length) return;
  const a = t.slice(0, 5).join("|");
  Ut.has(a) || (Ut.add(a), console.warn(
    `[AXErpGrid] 금액 셀 ${t.length}개가 컬럼 폭을 넘어 말줄임됩니다 — cols 를 moneyColWidth() 로 계산하세요.`,
    t.slice(0, 5)
  ));
}
function Tc(e) {
  if (!ya() || !e.length) return;
  const t = `head|${e.map((r) => r.label).join("|")}`;
  if (Ut.has(t)) return;
  Ut.add(t);
  const a = e.some((r) => r.sortMark) ? " (정렬 표시 ↕ 약 15px 포함)" : "";
  console.warn(
    `[AXErpGrid] 머리글 ${e.length}개가 열 폭보다 길어 잘립니다 — cols 를 넓히세요${a}:`,
    e.map((r) => `${r.label} +${Math.ceil(r.short)}px`).join(", ")
  );
}
function Da(e, t, a) {
  if (!e) return;
  const r = /* @__PURE__ */ new Map();
  for (const o of Array.from(e.rows)) {
    r.forEach((l, c) => {
      l <= 1 ? r.delete(c) : r.set(c, l - 1);
    });
    let s = 0;
    for (const l of Array.from(o.cells)) {
      for (; r.has(s); ) s += 1;
      const c = l.colSpan || 1, i = t > 0 && s + c <= t;
      if (l.classList.toggle(ce.fz, i), l.classList.toggle(ce.fzEdge, i && s + c === t), l.style.left = i ? `${a[s]}px` : "", l.rowSpan > 1) for (let u = s; u < s + c; u += 1) r.set(u, l.rowSpan);
      s += c;
    }
  }
}
function qc({
  cols: e,
  footer: t,
  pagination: a,
  title: r,
  trailing: o,
  grow: s,
  fixed: l,
  stickyCols: c = 0,
  busy: i,
  tableRole: u,
  "aria-label": m,
  sortable: _ = !0,
  sort: f,
  onSort: p,
  manualSort: y,
  className: d = "",
  children: b
}) {
  const N = l || e !== void 0 && e.length > 0, $ = N ? Cc(e) : void 0, { stick: g, offsets: x } = ke(() => {
    const I = Math.max(Math.trunc(c), 0), X = [];
    if (I === 0 || !e) return { stick: 0, offsets: X };
    let G = 0, z = 0;
    for (let H = 0; H < I; H += 1) {
      const ie = e[H];
      if (typeof ie != "number") break;
      X.push(G), G += ie, z += 1;
    }
    return { stick: z, offsets: X };
  }, [e, c]), h = [ce.table, N ? ce.fixed : "", g > 0 ? ce.frozen : ""].filter(Boolean).join(" "), w = B(null), E = B(null), D = B(null), C = B(null), T = B(0), M = B(0), R = ke(() => ({
    scrollRef: w,
    colCount: e == null ? void 0 : e.length,
    registerVirtual: () => (M.current += 1, () => {
      M.current -= 1;
    })
  }), [e == null ? void 0 : e.length]), [q, F] = A(null), Y = f !== void 0 ? f : q, [W, j] = A(""), ne = B(Yl()), te = () => {
    const I = w.current, X = D.current, G = C.current;
    if (!I || !X || !G) return;
    const z = I.scrollWidth;
    G.style.width = z + "px", X.style.display = z > I.clientWidth + 1 ? "" : "none";
    const H = I.offsetWidth - I.clientWidth;
    X.style.paddingRight = H + "px", E.current && (E.current.style.paddingRight = H + "px"), Mc(I), Tc(tc(I.querySelector("table")));
  };
  U(() => {
    const I = w.current;
    if (!I) return;
    const X = new wr(I, te);
    return Sc(I.querySelector("table")), () => X.detach();
  }, []), $e(() => {
    var I, X, G, z, H;
    (g > 0 || T.current > 0) && (Da((X = (I = w.current) == null ? void 0 : I.querySelector("table")) != null ? X : null, g, x), Da((z = (G = E.current) == null ? void 0 : G.querySelector("table")) != null ? z : null, g, x)), T.current = g, (H = w.current) == null || H.querySelectorAll("thead th:not([scope])").forEach((ie) => ie.setAttribute("scope", "col")), v(), te();
  });
  function v() {
    var z;
    const I = (z = w.current) == null ? void 0 : z.querySelector("table");
    if (!I) return;
    const X = _ ? Ul(I) : [];
    I.querySelectorAll("thead th[data-axe-sort]").forEach((H) => {
      X.some((ie) => ie.th === H) || (H.removeAttribute("data-axe-sort"), H.removeAttribute("aria-sort"), H.removeAttribute("tabindex"));
    }), X.forEach(({ th: H, key: ie }) => {
      H.dataset.axeSort !== ie && (H.dataset.axeSort = ie);
      const Ie = $r(Y, ie);
      H.getAttribute("aria-sort") !== Ie && H.setAttribute("aria-sort", Ie), H.hasAttribute("tabindex") || H.setAttribute("tabindex", "0");
    });
    const G = Y && X.find((H) => H.key === Y.key);
    Zl(I, Y && G && !y && M.current === 0 ? { col: G.col, dir: Y.dir } : null, ne.current);
  }
  const P = (I) => {
    var H;
    const X = I.dataset.axeSort;
    if (X === void 0) return;
    const G = Nr(Y, X), z = ((H = I.textContent) != null ? H : "").replace(/\s+/g, " ").trim();
    j(xr(G, () => z)), f === void 0 && F(G), p == null || p(G);
  }, V = (I) => {
    var z, H;
    const X = I, G = (z = X.closest) == null ? void 0 : z.call(X, "thead th[data-axe-sort]");
    return !G || !((H = w.current) != null && H.contains(G)) || X !== G && X.closest('input, select, textarea, button, a[href], [role="button"]') ? null : G;
  }, Q = (I) => {
    const X = V(I.target);
    X && P(X);
  }, se = (I) => {
    if (I.key !== "Enter" && I.key !== " ") return;
    const X = V(I.target);
    !X || I.target !== X || (I.preventDefault(), P(X));
  }, L = (I) => {
    const X = I.target.scrollLeft;
    w.current && (w.current.scrollLeft = X), E.current && (E.current.scrollLeft = X);
  }, Z = (I) => {
    const X = I.target.scrollLeft;
    E.current && (E.current.scrollLeft = X), D.current && (D.current.scrollLeft = X);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [ce.card, s ? ce.grow : "", i ? ce.busy : "", d].filter(Boolean).join(" ") }, i && /* @__PURE__ */ n.createElement("div", { className: ce.busyBar, "aria-hidden": "true" }), (r !== void 0 || o !== void 0) && /* @__PURE__ */ n.createElement("header", { className: ce.head }, /* @__PURE__ */ n.createElement("span", { className: ce.title }, r), o && /* @__PURE__ */ n.createElement("span", { className: ce.trailing }, o)), /* @__PURE__ */ n.createElement("div", { className: ce.scroll, ref: w, onScroll: Z }, /* @__PURE__ */ n.createElement(
    "table",
    {
      className: h,
      role: u && u !== "table" ? u : void 0,
      "aria-busy": i || void 0,
      "aria-label": m != null ? m : typeof r == "string" && r ? r : void 0,
      style: $ ? { minWidth: $ } : void 0,
      onClick: _ ? Q : void 0,
      onKeyDown: _ ? se : void 0
    },
    /* @__PURE__ */ n.createElement(xa, { cols: e }),
    /* @__PURE__ */ n.createElement(Cr.Provider, { value: R }, b)
  )), t && /* @__PURE__ */ n.createElement("div", { className: ce.foot, ref: E }, /* @__PURE__ */ n.createElement("table", { className: h, style: $ ? { minWidth: $ } : void 0 }, /* @__PURE__ */ n.createElement(xa, { cols: e }), /* @__PURE__ */ n.createElement("tbody", null, t))), /* @__PURE__ */ n.createElement("div", { className: ce.strip, ref: D, onScroll: L }, /* @__PURE__ */ n.createElement("div", { ref: C, className: ce.spacer })), a && /* @__PURE__ */ n.createElement("div", { className: ce.pager }, a), _ && /* @__PURE__ */ n.createElement("span", { className: ce.sr, role: "status", "aria-live": "polite" }, W));
}
const Bc = 600;
function Aa(e) {
  const { count: t, rowHeight: a, scrollTop: r, bodyTop: o } = e;
  if (!(t > 0) || !(a > 0)) return { start: 0, end: 0 };
  const s = e.viewport > 0 ? e.viewport : Bc, l = Math.max(0, Math.trunc(e.overscan)), c = Math.min(t - 1, Math.max(0, Math.floor((r - o) / a))), i = Math.ceil(s / a) + 1;
  return {
    start: Math.max(0, c - l),
    end: Math.min(t, c + i + l)
  };
}
function Lc(e, t, a) {
  return {
    top: a.start * t,
    bottom: Math.max(0, e - a.end) * t
  };
}
function jc(e, t) {
  return e.start === t.start && e.end === t.end;
}
const Ca = /* @__PURE__ */ new Set();
function Sa({ height: e, colSpan: t }) {
  return e <= 0 ? null : /* @__PURE__ */ n.createElement("tr", { "aria-hidden": "true", "data-sort-fixed": "", "data-virtual-spacer": "", style: { height: e } }, /* @__PURE__ */ n.createElement("td", { colSpan: t, style: { height: e, padding: 0, border: 0 } }));
}
function l0({
  rows: e,
  rowHeight: t,
  renderRow: a,
  getKey: r,
  overscan: o = 6,
  colSpan: s,
  headerRows: l = 1,
  className: c
}) {
  var h;
  const i = qn(Cr), u = B(null), [m, _] = A(() => Aa({
    count: e.length,
    rowHeight: t,
    scrollTop: 0,
    viewport: 0,
    bodyTop: 0,
    overscan: o
  })), f = e.length, [p, y] = A(null), d = p && p.of === t ? p.px : t;
  $e(() => i ? i.registerVirtual() : void 0, [i]), $e(() => {
    var E;
    const w = (E = u.current) == null ? void 0 : E.closest("table");
    if (w)
      return w.setAttribute("aria-rowcount", String(f + l)), () => w.removeAttribute("aria-rowcount");
  }, [f, l]), U(() => {
    const w = i == null ? void 0 : i.scrollRef.current, E = u.current;
    if (!w || !E) return;
    const D = () => {
      const T = E.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop, M = Aa({ count: f, rowHeight: d, scrollTop: w.scrollTop, viewport: w.clientHeight, bodyTop: T, overscan: o });
      _((R) => jc(R, M) ? R : M);
    };
    D(), w.addEventListener("scroll", D, { passive: !0 });
    const C = typeof ResizeObserver == "function" ? new ResizeObserver(D) : null;
    return C ? C.observe(w) : window.addEventListener("resize", D), () => {
      w.removeEventListener("scroll", D), C ? C.disconnect() : window.removeEventListener("resize", D);
    };
  }, [i, f, d, o]), $e(() => {
    var D, C, T;
    const w = (D = u.current) == null ? void 0 : D.querySelector("tr:not([data-virtual-spacer])"), E = (C = w == null ? void 0 : w.getBoundingClientRect().height) != null ? C : 0;
    !(E > 0) || Math.abs(E - d) <= 0.25 || (y({ of: t, px: E }), typeof process != "undefined" && ((T = process.env) == null ? void 0 : T.NODE_ENV) !== "production" && Math.abs(E - t) > 2 && !Ca.has(t) && (Ca.add(t), console.warn(`[AXErpVirtualBody] 실제 행 높이(${Math.round(E)}px)가 rowHeight(${t}px)와 많이 다릅니다 — 행마다 높이가 다르면 스크롤 위치가 어긋납니다. 셀 CSS 로 높이를 고정하세요.`)));
  }, [d, t, f]);
  const b = Math.min(m.end, f), N = Math.min(m.start, b), $ = Lc(f, d, { start: N, end: b }), g = (h = s != null ? s : i == null ? void 0 : i.colCount) != null ? h : 1, x = [];
  for (let w = N; w < b; w += 1) {
    const E = a(e[w], w), D = r ? r(e[w], w) : w;
    x.push(un(E) ? fa(E, { key: D, "aria-rowindex": w + 1 + l }) : E);
  }
  return /* @__PURE__ */ n.createElement("tbody", { ref: u, className: c, "data-virtual": "" }, /* @__PURE__ */ n.createElement(Sa, { height: $.top, colSpan: g }), x, /* @__PURE__ */ n.createElement(Sa, { height: $.bottom, colSpan: g }));
}
const Rc = 7.09, Ic = 3.88, Oc = 4.46, Pc = 16, Xc = 2;
function zc(e, t = {}) {
  var s;
  const a = Math.max(1, e), r = Math.floor((a - 1) / 3), o = a * Rc + r * Ic + (t.negative ? Oc : 0) + Pc + Xc;
  return Math.max(Math.ceil(o), (s = t.min) != null ? s : 0);
}
function c0(e, t = {}) {
  var o, s;
  let a = 0, r = (o = t.negative) != null ? o : !1;
  for (const l of e) {
    if (l == null || l === "") continue;
    const c = typeof l == "number" ? l : Number(String(l).replace(/[^\d.-]/g, ""));
    if (!Number.isFinite(c)) continue;
    c < 0 && (r = !0);
    const i = Math.floor(Math.abs(c)).toString().length;
    i > a && (a = i);
  }
  return a === 0 ? Math.max((s = t.min) != null ? s : 96, 96) : zc(a, { ...t, negative: r });
}
function i0(e) {
  const t = document.createElement("span");
  t.style.cssText = "position:absolute;visibility:hidden;white-space:nowrap", e.appendChild(t);
  const a = (l) => (t.textContent = l, t.getBoundingClientRect().width), r = a("000000000000"), o = a("000,000,000,000"), s = a("-000,000,000,000");
  return t.remove(), { digit: r / 12, comma: (o - r) / 3, minus: s - o };
}
const xt = 12, Fc = 1.06, Wc = 16, Hc = 4;
function Kc(e) {
  var a;
  const t = (a = e.codePointAt(0)) != null ? a : 0;
  return t >= 4352 && (t <= 4607 || t >= 11904 && t <= 55295 || t >= 63744 && t <= 64255 || t >= 65280 && t <= 65519) ? xt : e === " " ? xt * 0.3 : /[0-9]/.test(e) ? xt * 0.56 : /[A-Z]/.test(e) ? xt * 0.68 : /[a-z]/.test(e) ? xt * 0.56 : /[.,:;'|!]/.test(e) ? xt * 0.3 : xt * 0.6;
}
function Uc(e, t = !1) {
  let a = 0;
  for (const r of e) a += Kc(r);
  return t ? a * Fc : a;
}
function u0(e, t = {}) {
  var s, l, c;
  let a = 0;
  for (const i of e) {
    if (!i) continue;
    const u = Uc(i, t.bold);
    u > a && (a = u);
  }
  const r = (s = t.min) != null ? s : 64;
  if (a === 0) return r;
  const o = Math.ceil(a + Wc + ((l = t.extra) != null ? l : 0) + Hc);
  return Math.min(Math.max(o, r), (c = t.max) != null ? c : 1 / 0);
}
function Gc({
  colSpan: e,
  loading: t,
  error: a,
  count: r,
  empty: o = "조회 결과가 없습니다",
  idle: s = "조회조건을 정하고 조회하세요",
  loadingText: l = "조회 중…",
  className: c = ""
}) {
  const i = a != null && a !== !1 && a !== "", u = r == null || r === 0, m = a === !0 ? "조회하지 못했습니다 — 위 오류 안내를 확인한 뒤 다시 조회하세요" : a;
  let _;
  if (i) _ = "error";
  else if (t && u) _ = "loading";
  else if (r == null) {
    if (s === null) return null;
    _ = "idle";
  } else if (r === 0) _ = "empty";
  else return null;
  const f = /* @__PURE__ */ n.createElement(n.Fragment, null, _ === "loading" && /* @__PURE__ */ n.createElement("span", { className: ce.spin, "aria-hidden": "true" }), _ === "error" && /* @__PURE__ */ n.createElement("span", { className: ce.stIcon, "aria-hidden": "true" }, "!"), /* @__PURE__ */ n.createElement("span", null, _ === "error" ? m : _ === "loading" ? l : _ === "idle" ? s : o)), p = /* @__PURE__ */ n.createElement("div", { className: [ce.status, ce[`st_${_}`]].join(" "), role: "status" }, f);
  return e === void 0 ? /* @__PURE__ */ n.createElement("div", { className: c || void 0, "data-state": _ }, p) : /* @__PURE__ */ n.createElement("tr", { className: [ce.statusRow, c].filter(Boolean).join(" "), "data-state": _ }, /* @__PURE__ */ n.createElement("td", { colSpan: e, className: ce.statusCell }, p));
}
function Yc(e, t) {
  return {
    tabIndex: 0,
    "aria-current": t ? "true" : void 0,
    onKeyDown: (a) => {
      a.target === a.currentTarget && (a.key === "Enter" || a.key === " ") && (a.preventDefault(), e());
    }
  };
}
const Vc = "_cell_n9rrj_1", Qc = "_toggle_n9rrj_2", Jc = "_spacer_n9rrj_8", Zc = "_label_n9rrj_9", ei = "_dim_n9rrj_10", Zt = {
  cell: Vc,
  toggle: Qc,
  spacer: Jc,
  label: Zc,
  dim: ei
};
function m0(e, { id: t, parentId: a, defaultOpen: r = !0 }) {
  const [o, s] = A(() => /* @__PURE__ */ new Set()), [l, c] = A(() => /* @__PURE__ */ new Set()), { parents: i, kids: u } = ke(() => {
    const p = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Set(), d = new Set(e.map((b) => String(t(b))));
    for (const b of e) {
      const N = a(b), $ = N == null || !d.has(String(N)) ? null : String(N);
      p.set(String(t(b)), $), $ && y.add($);
    }
    return { parents: p, kids: y };
  }, [e, t, a]), m = re((p) => r ? !o.has(p) : l.has(p), [r, o, l]), _ = ke(() => e.filter((p) => {
    var b, N;
    let y = (b = i.get(String(t(p)))) != null ? b : null;
    const d = /* @__PURE__ */ new Set();
    for (; y && !d.has(y); ) {
      if (!m(y)) return !1;
      d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
    return !0;
  }), [e, i, t, m]), f = re((p, y) => {
    const d = (b, N) => {
      const $ = new Set(b);
      return N ? $.add(p) : $.delete(p), $;
    };
    r ? s((b) => d(b, !y)) : c((b) => d(b, y));
  }, [r]);
  return {
    visible: _,
    hasChildren: (p) => u.has(String(t(p))),
    isOpen: (p) => m(String(t(p))),
    toggle: (p) => {
      const y = String(t(p));
      f(y, !m(y));
    },
    expandAll: () => {
      s(/* @__PURE__ */ new Set()), c(new Set(u));
    },
    collapseAll: () => {
      s(new Set(u)), c(/* @__PURE__ */ new Set());
    },
    expandAllTemporarily: () => {
      const p = o, y = l;
      return s(/* @__PURE__ */ new Set()), c(new Set(u)), () => {
        s(p), c(y);
      };
    },
    reveal: (p) => {
      var b, N;
      let y = (b = i.get(String(p))) != null ? b : null;
      const d = /* @__PURE__ */ new Set();
      for (; y && !d.has(y); )
        f(y, !0), d.add(y), y = (N = i.get(y)) != null ? N : null;
    }
  };
}
function d0({ depth: e, hasChildren: t, open: a, onToggle: r, dim: o, toggleOutOfTabOrder: s, title: l, csvPath: c, children: i }) {
  const u = (_) => {
    _.stopPropagation(), r();
  }, m = l != null ? l : typeof i == "string" ? i : void 0;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Zt.cell, o ? Zt.dim : ""].filter(Boolean).join(" "),
      style: { paddingLeft: e * 16 },
      "data-tree-depth": e,
      "data-csv-path": c
    },
    t ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Zt.toggle,
        "aria-expanded": a,
        "aria-label": `${m ? `${m} ` : ""}${a ? "하위 접기" : "하위 펼치기"}`,
        onClick: u,
        tabIndex: s ? -1 : void 0,
        "data-csv-skip": ""
      },
      a ? "▾" : "▸"
    ) : /* @__PURE__ */ n.createElement("span", { className: Zt.spacer, "aria-hidden": "true" }),
    /* @__PURE__ */ n.createElement("span", { className: Zt.label, title: m }, i)
  );
}
function ti(e, t, a, r = !1) {
  const o = e[t.r];
  if (!o || t.i < 0 || t.i >= o.length) return null;
  const s = o[t.i], l = e.findIndex((i) => i.length > 0);
  let c = -1;
  for (let i = e.length - 1; i >= 0; i--) if (e[i].length > 0) {
    c = i;
    break;
  }
  switch (a) {
    case "ArrowLeft":
      return t.i > 0 ? { r: t.r, i: t.i - 1 } : null;
    case "ArrowRight":
      return t.i < o.length - 1 ? { r: t.r, i: t.i + 1 } : null;
    case "Home":
      return r ? { r: l, i: 0 } : { r: t.r, i: 0 };
    case "End":
      return r ? { r: c, i: e[c].length - 1 } : { r: t.r, i: o.length - 1 };
    case "ArrowUp":
    case "ArrowDown": {
      const i = a === "ArrowUp" ? -1 : 1;
      for (let u = t.r + i; u >= 0 && u < e.length; u += i)
        if (e[u].length > 0) return { r: u, i: ni(e[u], s) };
      return null;
    }
    default:
      return null;
  }
}
function ni(e, t) {
  let a = 0;
  for (let r = 1; r < e.length; r++)
    Math.abs(e[r] - t) < Math.abs(e[a] - t) && (a = r);
  return a;
}
function f0(e, t = {}) {
  var c;
  const a = (c = t.cellSelector) != null ? c : "[data-roving]", r = t.initialSelector, o = B(null), [s, l] = A(null);
  U(() => {
    e.current !== s && l(e.current);
  }), U(() => {
    if (!s) return;
    const i = () => Array.from(s.querySelectorAll(a)), u = () => {
      const y = i();
      if (!y.length) {
        o.current = null;
        return;
      }
      (!o.current || !y.includes(o.current)) && (o.current = r && y.find((d) => d.matches(r)) || y[0]), y.forEach((d) => {
        const b = d === o.current ? "0" : "-1";
        d.getAttribute("tabindex") !== b && d.setAttribute("tabindex", b);
      });
    }, m = () => {
      const y = i(), d = [], b = [], N = /* @__PURE__ */ new Map(), $ = [];
      return y.forEach((g) => {
        var T;
        const x = g.tagName === "TR", h = x ? null : g.closest("td, th"), w = h && s.contains(h) ? h.parentElement : null, E = x ? g : (T = w != null ? w : g.parentElement) != null ? T : s;
        let D = d.indexOf(E);
        D < 0 && (D = d.length, d.push(E), b.push([]), $.push([]));
        let C;
        if (x)
          C = 0;
        else if (h && w) {
          C = 0;
          for (const M of Array.from(w.cells)) {
            if (M === h) break;
            C += Math.max(1, M.colSpan || 1);
          }
        } else
          C = b[D].length;
        N.set(g, { r: D, i: b[D].length }), b[D].push(C), $[D].push(g);
      }), { rows: b, where: N, byPos: $ };
    }, _ = (y) => {
      var w;
      const d = y.target;
      if (!d || !d.matches(a) || !s.contains(d) || y.altKey || y.metaKey || d.tagName === "TR" && (y.key === "ArrowLeft" || y.key === "ArrowRight")) return;
      const { rows: b, where: N, byPos: $ } = m(), g = N.get(d);
      if (!g) return;
      const x = ti(b, g, y.key, y.ctrlKey);
      if (x === null) {
        ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"].includes(y.key) && y.preventDefault();
        return;
      }
      y.preventDefault();
      const h = (w = $[x.r]) == null ? void 0 : w[x.i];
      h && (o.current = h, u(), h.focus());
    }, f = (y) => {
      const d = y.target;
      !d || !d.matches(a) || d === o.current || (o.current = d, u());
    };
    u(), s.addEventListener("keydown", _), s.addEventListener("focusin", f);
    const p = typeof MutationObserver != "undefined" ? new MutationObserver(u) : null;
    return p == null || p.observe(s, { childList: !0, subtree: !0 }), () => {
      s.removeEventListener("keydown", _), s.removeEventListener("focusin", f), p == null || p.disconnect();
    };
  }, [s, a, r]);
}
const ai = "_btn_r1trx_1", ri = "_mark_r1trx_7", oi = "_sr_r1trx_9", aa = {
  btn: ai,
  mark: ri,
  sr: oi
};
function _0({ sortKey: e, sort: t, onSort: a, children: r, className: o = "", colSpan: s, style: l, title: c }) {
  const i = $r(t, e);
  return /* @__PURE__ */ n.createElement("th", { scope: "col", "aria-sort": i, colSpan: s, style: l, title: c, className: o }, /* @__PURE__ */ n.createElement("button", { type: "button", className: aa.btn, onClick: () => a(Nr(t, e)) }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("span", { className: aa.mark, "aria-hidden": "true" }, i === "ascending" ? "▲" : i === "descending" ? "▼" : "↕")));
}
function p0({ sort: e, labelOf: t }) {
  return /* @__PURE__ */ n.createElement("span", { className: aa.sr, role: "status", "aria-live": "polite" }, xr(e, t));
}
const si = "_card_14vt3_1", li = "_accent_14vt3_8", ci = "_grow_14vt3_9", ii = "_head_14vt3_11", ui = "_body_14vt3_20", mi = "_title_14vt3_28", di = "_trailing_14vt3_29", fi = "_summary_14vt3_32", _i = "_sumHead_14vt3_33", pi = "_sumTotal_14vt3_42", yi = "_tone_warn_14vt3_43", bi = "_tone_ok_14vt3_44", Ei = "_sumList_14vt3_46", hi = "_sumEm_14vt3_55", gi = "_sumFoot_14vt3_57", vi = "_sumNote_14vt3_66", Ne = {
  card: si,
  accent: li,
  grow: ci,
  head: ii,
  body: ui,
  title: mi,
  trailing: di,
  summary: fi,
  sumHead: _i,
  sumTotal: pi,
  tone_warn: yi,
  tone_ok: bi,
  sumList: Ei,
  sumEm: hi,
  sumFoot: gi,
  sumNote: vi
};
function Sr({
  title: e,
  trailing: t,
  accent: a,
  grow: r,
  flush: o,
  className: s = "",
  children: l
}) {
  return /* @__PURE__ */ n.createElement(
    "section",
    {
      className: [Ne.card, a ? Ne.accent : "", r ? Ne.grow : "", s].filter(Boolean).join(" "),
      "data-csv-title": typeof e == "string" && e ? e : void 0
    },
    e !== void 0 && /* @__PURE__ */ n.createElement("header", { className: Ne.head }, /* @__PURE__ */ n.createElement("span", { className: Ne.title, role: "heading", "aria-level": 2 }, e), t && /* @__PURE__ */ n.createElement("span", { className: Ne.trailing }, t)),
    o ? l : /* @__PURE__ */ n.createElement("div", { className: ["axe-card-body", Ne.body].join(" ") }, l)
  );
}
function y0({
  title: e,
  total: t,
  items: a,
  footerLabel: r,
  footerValue: o,
  note: s,
  tone: l = "default",
  children: c
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [Ne.card, Ne.accent, Ne.summary, Ne[`tone_${l}`]].join(" ") }, /* @__PURE__ */ n.createElement("header", { className: Ne.sumHead }, /* @__PURE__ */ n.createElement("span", null, e), t !== void 0 && /* @__PURE__ */ n.createElement("strong", { className: Ne.sumTotal }, t)), /* @__PURE__ */ n.createElement("ul", { className: Ne.sumList }, a.map((i, u) => {
    var m;
    return /* @__PURE__ */ n.createElement("li", { key: (m = i.key) != null ? m : u, className: i.em ? Ne.sumEm : "" }, /* @__PURE__ */ n.createElement("span", null, i.label), /* @__PURE__ */ n.createElement("strong", null, i.value));
  })), c, r !== void 0 && /* @__PURE__ */ n.createElement("footer", { className: Ne.sumFoot }, /* @__PURE__ */ n.createElement("span", null, r), /* @__PURE__ */ n.createElement("strong", null, o)), s && /* @__PURE__ */ n.createElement("div", { className: Ne.sumNote }, s));
}
let ki = 0;
function Qt(e = "axe") {
  const t = B(null);
  return t.current || (t.current = `${e}-${++ki}`), t.current;
}
const wi = "_sr_1y2mv_2", Ni = "_skip_1y2mv_8", $i = "_crit_1y2mv_16", xi = "_c_danger_1y2mv_21", Di = "_c_warn_1y2mv_22", Ai = "_critI_1y2mv_23", Ci = "_critBody_1y2mv_24", Si = "_critX_1y2mv_25", Mi = "_ch_1y2mv_32", Ti = "_chBtn_1y2mv_33", qi = "_chBox_1y2mv_43", Qe = {
  sr: wi,
  skip: Ni,
  crit: $i,
  c_danger: xi,
  c_warn: Di,
  critI: Ai,
  critBody: Ci,
  critX: Si,
  ch: Mi,
  chBtn: Ti,
  chBox: qi
};
function Mr({ as: e = "span", children: t, id: a }) {
  return /* @__PURE__ */ n.createElement(e, { className: Qe.sr, id: a }, t);
}
function b0({ targets: e = [{ label: "본문 바로가기", targetId: "axe-main" }], className: t = "" }) {
  const a = (r, o) => {
    const s = document.getElementById(o);
    s && (r.preventDefault(), s.hasAttribute("tabindex") || s.setAttribute("tabindex", "-1"), s.focus(), s.scrollIntoView({ block: "start" }));
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [Qe.skip, t].filter(Boolean).join(" "), "aria-label": "건너뛰기" }, e.slice(0, 3).map((r) => /* @__PURE__ */ n.createElement("a", { key: r.targetId, href: `#${r.targetId}`, onClick: (o) => a(o, r.targetId) }, r.label)));
}
function E0({ title: e, children: t, tone: a = "danger", onClose: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Qe.crit, Qe[`c_${a}`], o].filter(Boolean).join(" "), role: "alert" }, /* @__PURE__ */ n.createElement("span", { className: Qe.critI, "aria-hidden": "true" }, "▲"), /* @__PURE__ */ n.createElement("div", { className: Qe.critBody }, /* @__PURE__ */ n.createElement("b", null, e), t ? /* @__PURE__ */ n.createElement("span", null, " ", t) : null), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: Qe.critX, onClick: r, "aria-label": "알림 닫기" }, "✕"));
}
function h0({ label: e, children: t, className: a = "" }) {
  const [r, o] = A(!1), s = Qt("axe-ch"), l = B(null), c = B(null);
  return U(() => {
    if (!r) return;
    const i = (m) => {
      l.current && !l.current.contains(m.target) && o(!1);
    }, u = (m) => {
      var _;
      m.key !== "Escape" || m.isComposing || (m.preventDefault(), m.stopPropagation(), o(!1), (_ = c.current) == null || _.focus());
    };
    return document.addEventListener("mousedown", i), document.addEventListener("keydown", u, !0), () => {
      document.removeEventListener("mousedown", i), document.removeEventListener("keydown", u, !0);
    };
  }, [r]), /* @__PURE__ */ n.createElement("span", { className: [Qe.ch, a].filter(Boolean).join(" "), ref: l }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: c,
      type: "button",
      className: Qe.chBtn,
      "aria-label": e,
      "aria-expanded": r,
      "aria-controls": s,
      onClick: () => o((i) => !i)
    },
    "?"
  ), r && /* @__PURE__ */ n.createElement("span", { id: s, role: "region", "aria-label": e, className: Qe.chBox }, t));
}
function ra(e, t, a = "codeName") {
  const r = (e != null ? e : "").trim();
  if (!r) return "";
  const o = (t != null ? t : "").trim();
  return !o || a === "code" ? r : a === "name" ? o : `${r}. ${o}`;
}
function Bi(e, t = "전체", a = "codeName") {
  if (e.length === 0) return t;
  const r = ra(e[0].cd, e[0].nm, a);
  return e.length === 1 ? r : `${r} 외 ${e.length - 1}건`;
}
function Li(e, t, a, r) {
  const o = (e != null ? e : "").trim();
  if (!o) return null;
  if (t && t.name && t.code === o) return t.name;
  if (a && a.code === o && a.name) return a.name;
  const s = r == null ? void 0 : r.find((l) => l.code === o);
  return s && s.name ? s.name : null;
}
const ji = "_root_g2b1p_1", Ri = "_rootNone_g2b1p_5", Ii = "_field_g2b1p_12", Oi = "_codeInput_g2b1p_13", Pi = "_nameHint_g2b1p_16", Xi = "_pickBtn_g2b1p_25", zi = "_suggest_g2b1p_42", Fi = "_suggestList_g2b1p_48", Wi = "_suggestRow_g2b1p_49", Hi = "_suggestOn_g2b1p_50", Ki = "_suggestEmpty_g2b1p_55", Ui = "_suggestMore_g2b1p_55", Gi = "_popup_g2b1p_59", Yi = "_popupHead_g2b1p_73", Vi = "_searchRow_g2b1p_83", Qi = "_list_g2b1p_87", Ji = "_current_g2b1p_96", Zi = "_empty_g2b1p_100", eu = "_summaryBtn_g2b1p_108", tu = "_ov_g2b1p_129", nu = "_modal_g2b1p_140", au = "_modalWide_g2b1p_140", ru = "_head_g2b1p_152", ou = "_sub_g2b1p_160", su = "_x_g2b1p_162", lu = "_body_g2b1p_179", cu = "_chips_g2b1p_187", iu = "_chip_g2b1p_187", uu = "_chipOn_g2b1p_201", mu = "_search_g2b1p_83", du = "_tbl_g2b1p_220", fu = "_row_g2b1p_250", _u = "_rowCursor_g2b1p_252", pu = "_rowPicked_g2b1p_253", yu = "_rowCurrent_g2b1p_254", bu = "_curTag_g2b1p_255", Eu = "_busy_g2b1p_256", hu = "_count_g2b1p_257", gu = "_chk_g2b1p_259", vu = "_tdLeft_g2b1p_260", ku = "_tdCenter_g2b1p_261", wu = "_emptyCell_g2b1p_263", Nu = "_stop_g2b1p_265", $u = "_more_g2b1p_276", xu = "_pager_g2b1p_288", Du = "_note_g2b1p_301", Au = "_foot_g2b1p_304", Cu = "_ghost_g2b1p_313", Su = "_primary_g2b1p_325", K = {
  root: ji,
  rootNone: Ri,
  field: Ii,
  codeInput: Oi,
  nameHint: Pi,
  pickBtn: Xi,
  suggest: zi,
  suggestList: Fi,
  suggestRow: Wi,
  suggestOn: Hi,
  suggestEmpty: Ki,
  suggestMore: Ui,
  popup: Gi,
  popupHead: Yi,
  searchRow: Vi,
  list: Qi,
  current: Ji,
  empty: Zi,
  summaryBtn: eu,
  ov: tu,
  modal: nu,
  modalWide: au,
  head: ru,
  sub: ou,
  x: su,
  body: lu,
  chips: cu,
  chip: iu,
  chipOn: uu,
  search: mu,
  tbl: du,
  row: fu,
  rowCursor: _u,
  rowPicked: pu,
  rowCurrent: yu,
  curTag: bu,
  busy: Eu,
  count: hu,
  chk: gu,
  tdLeft: vu,
  tdCenter: ku,
  emptyCell: wu,
  stop: Nu,
  more: $u,
  pager: xu,
  note: Du,
  foot: Au,
  ghost: Cu,
  primary: Su
};
function Mu({
  items: e,
  value: t,
  title: a,
  popupRef: r,
  anchorRef: o,
  pos: s,
  onPick: l,
  onClose: c
}) {
  const [i, u] = A(""), m = ke(() => {
    const _ = i.trim().toLowerCase();
    return _ ? e.filter(
      (f) => {
        var p;
        return f.code.toLowerCase().includes(_) || f.name.toLowerCase().includes(_) || ((p = f.sub) != null ? p : "").toLowerCase().includes(_);
      }
    ) : e;
  }, [e, i]);
  return U(() => {
    const _ = (p) => {
      const y = p.target;
      r.current && !r.current.contains(y) && o.current && !o.current.contains(y) && c();
    }, f = (p) => {
      p.key === "Escape" && c();
    };
    return document.addEventListener("mousedown", _), document.addEventListener("keydown", f), () => {
      document.removeEventListener("mousedown", _), document.removeEventListener("keydown", f);
    };
  }, [r, o, c]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: r,
      className: K.popup,
      style: { left: s.left, top: s.top },
      role: "dialog",
      "aria-label": "코드 선택"
    },
    /* @__PURE__ */ n.createElement("header", { className: K.popupHead }, /* @__PURE__ */ n.createElement("strong", null, a), /* @__PURE__ */ n.createElement("button", { type: "button", "aria-label": "닫기", onClick: c }, "✕")),
    /* @__PURE__ */ n.createElement("div", { className: K.searchRow }, /* @__PURE__ */ n.createElement(
      "input",
      {
        autoFocus: !0,
        value: i,
        "aria-label": "코드·명칭 검색",
        placeholder: "코드·명칭 검색",
        onChange: (_) => u(_.target.value),
        onKeyDown: (_) => {
          _.key === "Enter" && m.length && l(m[0]), _.key === "Escape" && c();
        }
      }
    )),
    /* @__PURE__ */ n.createElement("ul", { className: K.list }, m.map((_) => /* @__PURE__ */ n.createElement("li", { key: _.code }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(_), className: _.code === t ? K.current : "" }, /* @__PURE__ */ n.createElement("code", null, _.code), /* @__PURE__ */ n.createElement("span", null, _.name), _.sub && /* @__PURE__ */ n.createElement("small", null, _.sub)))), m.length === 0 && /* @__PURE__ */ n.createElement("li", { className: K.empty }, "검색 결과가 없습니다"))
  ));
}
const Tr = 250, hn = 7;
function Ma(e, t) {
  const a = t.trim().toLowerCase();
  if (!a) return e;
  const r = e.toLowerCase().indexOf(a);
  return r < 0 ? e : /* @__PURE__ */ n.createElement(n.Fragment, null, e.slice(0, r), /* @__PURE__ */ n.createElement("b", null, e.slice(r, r + a.length)), e.slice(r + a.length));
}
function Tu(e, t) {
  const a = e.map((r) => ({ cd: r.code, nm: r.name, sub: r.sub }));
  return {
    key: "static",
    title: typeof t == "string" ? t : "코드 선택",
    nameLabel: "명칭",
    fetch: ({ q: r }) => {
      const o = r.trim().toLowerCase();
      return o ? Promise.resolve({
        rows: a.filter(
          (s) => {
            var l;
            return s.cd.toLowerCase().includes(o) || s.nm.toLowerCase().includes(o) || String((l = s.sub) != null ? l : "").toLowerCase().includes(o);
          }
        )
      }) : Promise.resolve({ rows: a });
    }
  };
}
function qu({
  source: e,
  items: t,
  title: a,
  multiple: r,
  selected: o,
  current: s,
  searchRef: l,
  onConfirm: c,
  onClose: i
}) {
  var se;
  const u = ke(() => Tu(t != null ? t : [], a), [t, a]), m = e != null ? e : u, [_, f] = A(""), [p, y] = A((se = e == null ? void 0 : e.defaultFilter) != null ? se : null), [d, b] = A(0), [N, $] = A([]), [g, x] = A(!1), [h, w] = A(!1), [E, D] = A(null), [C, T] = A(0), [M, R] = A(/* @__PURE__ */ new Map()), q = B(m);
  q.current = m, U(() => {
    var Z;
    f(""), y((Z = q.current.defaultFilter) != null ? Z : null), b(0), T(0), D(null), R(new Map((o != null ? o : []).map((I) => [I.cd, I])));
    const L = window.setTimeout(() => {
      l.current && l.current.focus();
    }, 30);
    return () => window.clearTimeout(L);
  }, [m.key]), U(() => {
    let L = !0;
    w(!0);
    const Z = () => {
      q.current.fetch({ q: _.trim(), ty: p, page: d }).then((X) => {
        var z, H;
        if (!L) return;
        $((z = X.rows) != null ? z : []), x(!!X.hasMore), D(null);
        const G = s ? ((H = X.rows) != null ? H : []).findIndex((ie) => ie.cd === s) : -1;
        T(G > 0 ? G : 0);
      }).catch((X) => {
        L && ($([]), x(!1), D("코드를 불러오지 못했습니다. 잠시 후 다시 조회하세요."));
      }).finally(() => {
        L && w(!1);
      });
    }, I = window.setTimeout(Z, _.trim() ? Tr : 0);
    return () => {
      L = !1, window.clearTimeout(I);
    };
  }, [m.key, _, p, d]);
  const F = B(null);
  U(() => {
    const L = F.current && F.current.children[C];
    L && "scrollIntoView" in L && L.scrollIntoView({ block: "nearest" });
  }, [C, N]);
  const Y = ke(() => {
    var Z, I;
    const L = [
      { key: "cd", label: "코드", width: (Z = m.codeWidth) != null ? Z : "96px", align: "center" },
      {
        key: "nm",
        label: m.nameLabel,
        align: "left",
        render: (X) => /* @__PURE__ */ n.createElement(n.Fragment, null, X.nm, X.useYn === !1 && /* @__PURE__ */ n.createElement("span", { className: K.stop }, "사용중단"))
      }
    ];
    return m.typeLabel && L.push({
      key: "__ty",
      label: "구분",
      width: "110px",
      align: "center",
      render: (X) => m.typeLabel ? m.typeLabel(X) : ""
    }), L.concat((I = m.extraColumns) != null ? I : []);
  }, [m]), W = re((L) => {
    R((Z) => {
      const I = new Map(Z);
      return I.has(L.cd) ? I.delete(L.cd) : I.set(L.cd, L), I;
    });
  }, []), j = re((L) => c([L]), [c]), ne = re(() => c(Array.from(M.values())), [M, c]), te = N.length > 0 && N.every((L) => M.has(L.cd)), v = () => {
    R((L) => {
      const Z = new Map(L);
      return te ? N.forEach((I) => Z.delete(I.cd)) : N.forEach((I) => Z.set(I.cd, I)), Z;
    });
  }, P = B(null);
  U(() => {
    const L = document.activeElement;
    return () => {
      window.setTimeout(() => {
        L && L.isConnected && typeof L.focus == "function" && (!document.activeElement || document.activeElement === document.body) && L.focus();
      }, 0);
    };
  }, []);
  const V = B(i);
  V.current = i, U(() => {
    const L = (Z) => {
      Z.key !== "Escape" || Z.isComposing || (Z.stopPropagation(), Z.preventDefault(), V.current());
    };
    return document.addEventListener("keydown", L, !0), () => document.removeEventListener("keydown", L, !0);
  }, []);
  const Q = (L) => {
    var X;
    if (L.nativeEvent.isComposing || L.keyCode === 229) return;
    if (L.key === "Tab" && P.current) {
      const G = Array.from(P.current.querySelectorAll("input:not([disabled]), button:not([disabled])"));
      if (G.length) {
        const z = G[0], H = G[G.length - 1], ie = document.activeElement;
        L.shiftKey && ie === z ? (L.preventDefault(), H.focus()) : !L.shiftKey && ie === H && (L.preventDefault(), z.focus());
      }
      return;
    }
    if (L.key === "Escape") {
      L.stopPropagation(), i();
      return;
    }
    const Z = L.target, I = Z === l.current;
    if (!(!I && Z !== P.current)) {
      if (L.key === "ArrowDown" || L.key === "ArrowUp") {
        L.preventDefault(), T((G) => Math.max(0, Math.min(N.length - 1, G + (L.key === "ArrowDown" ? 1 : -1))));
        return;
      }
      if (L.key === " " && r && N[C] && !(I && ((X = l.current) != null && X.value))) {
        L.preventDefault(), W(N[C]);
        return;
      }
      if (L.key === "Enter") {
        if (L.preventDefault(), h) return;
        r ? ne() : N[C] && j(N[C]);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { className: K.ov, onClick: i }, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: m.wide ? `${K.modal} ${K.modalWide}` : K.modal,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": m.title,
      ref: P,
      onClick: (L) => L.stopPropagation(),
      onKeyDown: Q
    },
    /* @__PURE__ */ n.createElement("div", { className: K.head }, /* @__PURE__ */ n.createElement("h2", null, m.title), r && /* @__PURE__ */ n.createElement("span", { className: K.sub }, "복수 선택 가능"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.x, onClick: i, "aria-label": "닫기" }, "×")),
    /* @__PURE__ */ n.createElement("div", { className: K.body }, m.filters && m.filters.length > 0 && /* @__PURE__ */ n.createElement("div", { className: K.chips }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: p === null ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(null), b(0);
        }
      },
      "전체"
    ), m.filters.map((L) => /* @__PURE__ */ n.createElement(
      "button",
      {
        key: L.value,
        type: "button",
        className: p === L.value ? `${K.chip} ${K.chipOn}` : K.chip,
        onClick: () => {
          y(L.value), b(0);
        }
      },
      L.label
    ))), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        className: K.search,
        value: _,
        placeholder: "코드, 명칭 검색",
        autoComplete: "off",
        "aria-label": "코드·명칭 검색",
        onChange: (L) => {
          f(L.target.value), b(0);
        }
      }
    ), /* @__PURE__ */ n.createElement("div", { className: K.tbl }, /* @__PURE__ */ n.createElement("table", null, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, r && /* @__PURE__ */ n.createElement("th", { className: K.chk }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "checkbox",
        checked: te,
        onChange: v,
        "aria-label": "표시된 행 전체 선택"
      }
    )), Y.map((L) => /* @__PURE__ */ n.createElement("th", { key: L.key, style: L.width ? { width: L.width } : void 0 }, L.label)))), /* @__PURE__ */ n.createElement("tbody", { ref: F, className: h && N.length > 0 ? K.busy : void 0, "aria-busy": h }, N.length === 0 ? /* @__PURE__ */ n.createElement("tr", null, /* @__PURE__ */ n.createElement("td", { className: K.emptyCell, colSpan: Y.length + (r ? 1 : 0) }, h ? "검색 중…" : E || m.emptyText || "검색 결과가 없습니다")) : N.map((L, Z) => /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: L.cd,
        className: [
          K.row,
          Z === C ? K.rowCursor : "",
          M.has(L.cd) ? K.rowPicked : "",
          !r && s && L.cd === s ? K.rowCurrent : ""
        ].filter(Boolean).join(" "),
        "aria-selected": Z === C,
        onClick: () => {
          T(Z), r ? W(L) : j(L);
        }
      },
      r && /* @__PURE__ */ n.createElement("td", { className: K.chk }, /* @__PURE__ */ n.createElement(
        "input",
        {
          type: "checkbox",
          checked: M.has(L.cd),
          onChange: () => W(L),
          onClick: (I) => I.stopPropagation(),
          "aria-label": `${L.cd} 선택`
        }
      )),
      Y.map((I) => {
        var X, G;
        return /* @__PURE__ */ n.createElement(
          "td",
          {
            key: I.key,
            className: I.align === "left" ? K.tdLeft : K.tdCenter,
            title: I.render ? void 0 : String((X = L[I.key]) != null ? X : "")
          },
          I.render ? I.render(L) : String((G = L[I.key]) != null ? G : ""),
          I.key === "cd" && !r && s && L.cd === s && /* @__PURE__ */ n.createElement("em", { className: K.curTag }, "현재")
        );
      })
    ))))), /* @__PURE__ */ n.createElement("p", { className: K.count, role: "status", "aria-live": "polite" }, h ? "검색 중…" : E ? "" : `${N.length}건`, !r && !h && !E && N.length > 0 && " — ↑↓ 로 고르고 Enter, 또는 행을 누르세요"), (g || d > 0) && /* @__PURE__ */ n.createElement("div", { className: K.more }, /* @__PURE__ */ n.createElement("span", null, g ? "표시 상한까지만 보여 주고 있습니다 — 검색어를 좁히거나 다음 쪽으로 넘기세요" : "마지막 쪽입니다"), /* @__PURE__ */ n.createElement("span", { className: K.pager }, /* @__PURE__ */ n.createElement("button", { type: "button", disabled: d === 0, onClick: () => b((L) => Math.max(0, L - 1)) }, "이전"), /* @__PURE__ */ n.createElement("b", null, d + 1), g && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => b((L) => L + 1) }, "다음"))), r && /* @__PURE__ */ n.createElement("p", { className: K.note }, "선택 ", /* @__PURE__ */ n.createElement("b", null, M.size), "건 — 선택이 없으면 ", /* @__PURE__ */ n.createElement("b", null, "전체"), "로 조회됩니다")),
    /* @__PURE__ */ n.createElement("div", { className: K.foot }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: () => R(/* @__PURE__ */ new Map()) }, "초기화"), /* @__PURE__ */ n.createElement("button", { type: "button", className: K.ghost, onClick: i }, "취소"), r && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.primary, onClick: ne }, "확인"))
  )));
}
let Bu = 0;
function Lu({ source: e, items: t, anchorRef: a }) {
  const [r, o] = A(null), [s, l] = A(-1), [c, i] = A(null), u = B(null), m = B(0), _ = B(`axe-cp-${++Bu}`), f = B(e);
  f.current = e;
  const p = B(t);
  p.current = t;
  const y = re(() => {
    u.current != null && (window.clearTimeout(u.current), u.current = null), m.current += 1, o(null), l(-1);
  }, []);
  U(() => y, [y]);
  const d = (b) => {
    u.current != null && window.clearTimeout(u.current), m.current += 1;
    const N = m.current;
    if (!b.trim()) {
      o(null), l(-1);
      return;
    }
    u.current = window.setTimeout(async () => {
      var x;
      let $ = [], g = !1;
      try {
        const h = f.current;
        if (h) {
          const w = await h.fetch({ q: b, ty: null, page: 0 });
          $ = w.rows, g = !!w.hasMore || $.length > hn;
        } else {
          const w = b.trim().toLowerCase();
          $ = ((x = p.current) != null ? x : []).filter((E) => {
            var D;
            return E.code.toLowerCase().includes(w) || E.name.toLowerCase().includes(w) || ((D = E.sub) != null ? D : "").toLowerCase().includes(w);
          }).map((E) => ({ cd: E.code, nm: E.name, sub: E.sub })), g = $.length > hn;
        }
      } catch {
        return;
      }
      N === m.current && (o({ rows: $.slice(0, hn), more: g, q: b }), l(-1));
    }, Tr);
  };
  return U(() => {
    if (!r) {
      i(null);
      return;
    }
    const b = () => {
      const N = a.current;
      if (!N) return;
      const $ = N.getBoundingClientRect(), g = Math.min(r.rows.length, hn) * 28 + 34, x = $.bottom + g > window.innerHeight - 8 && $.top - g - 2 > 8 ? $.top - g - 2 : $.bottom + 2, h = Math.max($.width, 260);
      i({ left: Math.max(8, Math.min($.left, window.innerWidth - h - 8)), top: x, width: h });
    };
    return b(), window.addEventListener("resize", b), window.addEventListener("scroll", b, !0), () => {
      window.removeEventListener("resize", b), window.removeEventListener("scroll", b, !0);
    };
  }, [r, a]), { sugg: r, active: s, setActive: l, suggPos: c, suggId: _, runSuggest: d, cancelSuggest: y };
}
function g0({
  value: e = "",
  name: t,
  show: a = "codeName",
  onChange: r,
  items: o,
  source: s,
  multiple: l = !1,
  selected: c,
  onConfirm: i,
  current: u,
  trigger: m,
  emptyLabel: _ = "전체",
  open: f,
  onOpenChange: p,
  placeholder: y,
  title: d = "코드 선택",
  variant: b,
  disabled: N,
  className: $ = "",
  maxLength: g,
  numeric: x = !1,
  ariaLabel: h,
  autoFocus: w,
  onEnter: E,
  openOnEmptyEnter: D,
  onEscape: C,
  onBlur: T,
  invalid: M,
  selectOnFocus: R = !1
}) {
  const q = s ? "source" : "static", F = h != null ? h : (s == null ? void 0 : s.title) || (typeof d == "string" && d !== "코드 선택" ? d : "") || "코드", Y = b != null ? b : q === "source" ? "modal" : "anchor", W = m != null ? m : l ? "summary" : "input", [j, ne] = A(!1), te = f != null ? f : j, v = re(
    (k) => {
      f === void 0 && ne(k), p && p(k);
    },
    [f, p]
  ), P = B(null), V = B(!1), Q = B(null), se = B(null), [L, Z] = A(null), I = () => {
    if (!N) {
      if (Y === "anchor") {
        const k = P.current;
        if (!k) return;
        const O = k.getBoundingClientRect(), J = 320, oe = O.bottom + J > window.innerHeight ? Math.max(8, O.top - J - 4) : O.bottom + 4;
        Z({ left: Math.min(O.left, window.innerWidth - 320), top: oe });
      }
      v(!0);
    }
  }, X = re(() => v(!1), [v]), [G, z] = A(!1), [H, ie] = A(null), Ie = B(null);
  (!Ie.current || Ie.current.name !== t) && (Ie.current = { name: t, code: e });
  const xe = Li(e, Ie.current, H, o), ze = ra(e, xe, a), dt = ra(e, xe), Rt = G && xe && a !== "code" ? xe : "", wt = (k) => {
    !l && k[0] && ie({ code: k[0].cd, name: k[0].nm }), i ? i(k) : k[0] && r && r(k[0].cd, { code: k[0].cd, name: k[0].nm });
  }, { sugg: pe, active: nt, setActive: Ke, suggPos: It, suggId: ft, runSuggest: Ot, cancelSuggest: Nt } = Lu({ source: s, items: o, anchorRef: P }), yn = (k) => {
    Nt(), wt([k]);
  };
  return /* @__PURE__ */ n.createElement("span", { ref: P, className: [W === "none" ? K.rootNone : K.root, $].filter(Boolean).join(" ") }, W === "input" && /* @__PURE__ */ n.createElement("span", { className: K.field }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: K.codeInput,
      style: { paddingRight: Rt ? "calc(24px + 45%)" : 24 },
      value: G ? e : ze,
      placeholder: y,
      disabled: N,
      maxLength: g,
      inputMode: x ? "numeric" : void 0,
      autoComplete: "off",
      autoFocus: w,
      "aria-label": F,
      "aria-invalid": M ? !0 : void 0,
      onChange: (k) => {
        const O = k.target.value.trim(), J = x ? O.replace(/[^0-9]/g, "") : O, oe = g ? J.slice(0, g) : J;
        r && r(oe), !N && (s || o) && Ot(oe);
      },
      onKeyDown: (k) => {
        if (k.key === "F2") {
          k.preventDefault(), Nt(), I();
          return;
        }
        if (!pe) {
          if (k.key === "Enter" && D && !e.trim() && !k.nativeEvent.isComposing) {
            k.preventDefault(), I();
            return;
          }
          k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), E()) : k.key === "Escape" && C && (k.preventDefault(), C());
          return;
        }
        const O = pe.rows.length;
        k.key === "ArrowDown" && O ? (k.preventDefault(), Ke((J) => (J + 1) % O)) : k.key === "ArrowUp" && O ? (k.preventDefault(), Ke((J) => (J <= 0 ? O : J) - 1)) : k.key === "Enter" && nt >= 0 && pe.rows[nt] ? (k.preventDefault(), yn(pe.rows[nt])) : k.key === "Enter" && E && !k.nativeEvent.isComposing ? (k.preventDefault(), Nt(), E()) : k.key === "Escape" && (k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), Nt());
      },
      onFocus: (k) => {
        if (z(!0), !R) return;
        const O = k.currentTarget;
        window.requestAnimationFrame(() => O.select());
      },
      onMouseDown: (k) => {
        R && document.activeElement !== k.currentTarget && (V.current = !0);
      },
      onMouseUp: (k) => {
        V.current && (k.preventDefault(), V.current = !1);
      },
      onBlur: () => {
        z(!1), Nt(), T && T();
      },
      title: typeof M == "string" && M ? M : dt && dt !== e ? `${dt} (F2: 코드 선택)` : "F2: 코드 선택",
      role: "combobox",
      "aria-autocomplete": "list",
      "aria-expanded": !!pe,
      "aria-controls": pe ? ft.current : void 0,
      "aria-activedescendant": pe && nt >= 0 ? `${ft.current}-${nt}` : void 0,
      "aria-describedby": typeof M == "string" && M ? `${ft.current}-inv` : void 0
    }
  ), Rt && /* @__PURE__ */ n.createElement("span", { className: K.nameHint, "aria-hidden": "true" }, Rt), typeof M == "string" && M && /* @__PURE__ */ n.createElement(Mr, { id: `${ft.current}-inv` }, M), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: K.pickBtn,
      "aria-label": "코드 선택 열기",
      disabled: N,
      onClick: I,
      onMouseDown: (k) => k.preventDefault(),
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 })
  )), W === "summary" && /* @__PURE__ */ n.createElement("button", { type: "button", className: K.summaryBtn, disabled: N, onClick: I }, /* @__PURE__ */ n.createElement("span", null, Bi(c != null ? c : [], _, a)), /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }, /* @__PURE__ */ n.createElement(mn, { name: "search", size: 13 }))), pe && It && W === "input" && !te && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      className: K.suggest,
      style: { left: It.left, top: It.top, width: It.width },
      onMouseDown: (k) => k.preventDefault()
    },
    pe.rows.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: K.suggestEmpty }, "일치하는 코드가 없습니다 · F2 로 전체 검색") : /* @__PURE__ */ n.createElement("ul", { id: ft.current, role: "listbox", className: K.suggestList }, pe.rows.map((k, O) => /* @__PURE__ */ n.createElement(
      "li",
      {
        key: k.cd,
        id: `${ft.current}-${O}`,
        role: "option",
        "aria-selected": O === nt,
        className: [K.suggestRow, O === nt ? K.suggestOn : ""].filter(Boolean).join(" "),
        onMouseEnter: () => Ke(O),
        onClick: () => yn(k)
      },
      /* @__PURE__ */ n.createElement("code", null, Ma(k.cd, pe.q)),
      /* @__PURE__ */ n.createElement("span", null, Ma(k.nm, pe.q)),
      k.useYn === !1 && /* @__PURE__ */ n.createElement("em", null, "사용중단")
    ))),
    pe.more && /* @__PURE__ */ n.createElement("div", { className: K.suggestMore }, "더 있습니다 · F2 로 전체 보기")
  )), te && q === "static" && Y === "anchor" && L && /* @__PURE__ */ n.createElement(
    Mu,
    {
      items: o != null ? o : [],
      value: e,
      title: d,
      popupRef: Q,
      anchorRef: P,
      pos: L,
      onPick: (k) => {
        ie({ code: k.code, name: k.name }), r && r(k.code, k), X();
      },
      onClose: X
    }
  ), te && (q === "source" || Y === "modal") && /* @__PURE__ */ n.createElement(
    qu,
    {
      source: s,
      items: o,
      title: d,
      multiple: l,
      selected: c,
      current: u,
      searchRef: se,
      onConfirm: (k) => {
        wt(k), X();
      },
      onClose: X
    }
  ));
}
const ba = 864e5;
function ju(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
function Le(e, t) {
  return t === 2 ? ju(e) ? 29 : 28 : t === 4 || t === 6 || t === 9 || t === 11 ? 30 : 31;
}
function vt(e) {
  return Math.round(Date.UTC(+e.slice(0, 4), +e.slice(5, 7) - 1, +e.slice(8, 10)) / ba);
}
function Ru(e) {
  const t = new Date(e * ba);
  return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}-${String(t.getUTCDate()).padStart(2, "0")}`;
}
function Ln(e, t) {
  return Ru(vt(e) + t);
}
function Ea(e) {
  return new Date(vt(e) * ba).getUTCDay();
}
const Ta = "1900-01-01", qa = "2099-12-31", Fn = ["일", "월", "화", "수", "목", "금", "토"], Dn = (e) => String(e).padStart(2, "0");
function tt(e, t, a) {
  return `${String(e).padStart(4, "0")}-${Dn(t)}-${Dn(a)}`;
}
function de(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2], o = +t[3];
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Iu(e) {
  const t = /^(\d{4})-(\d{2})$/.exec(e != null ? e : "");
  if (!t) return null;
  const a = +t[1], r = +t[2];
  return r < 1 || r > 12 ? null : { y: a, m: r, d: 1 };
}
function en(e, t) {
  return t === "month" ? Iu(e) : de(e);
}
function Be(e, t) {
  return t === "month" ? `${String(e.y).padStart(4, "0")}-${Dn(e.m)}` : tt(e.y, e.m, e.d);
}
function je(e) {
  return new Date(Date.UTC(e.y, e.m - 1, e.d)).getUTCDay();
}
function dn(e, t) {
  const a = new Date(Date.UTC(e.y, e.m - 1, e.d + t));
  return { y: a.getUTCFullYear(), m: a.getUTCMonth() + 1, d: a.getUTCDate() };
}
function kt(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = (a % 12 + 12) % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
function Ou(e, t, a) {
  return e >= t && e <= a;
}
function Xt(e, t) {
  return e.replace(/\D/g, "").slice(0, t === "month" ? 6 : 8);
}
function Wn(e, t) {
  const a = e.slice(0, 4), r = e.slice(4, 6), o = e.slice(6, 8);
  let s = a;
  return e.length > 4 && (s += "-" + r), t === "date" && e.length > 6 && (s += "-" + o), s;
}
function Ba(e, t) {
  if (t <= 0) return 0;
  let a = 0;
  for (let r = 0; r < e.length; r++)
    if (/\d/.test(e[r]) && (a++, a === t))
      return r + 1;
  return e.length;
}
function $n(e, t, a) {
  let r, o, s = 1;
  if (t === "month")
    if (e.length === 6)
      r = +e.slice(0, 4), o = +e.slice(4, 6);
    else if (e.length === 4)
      r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4);
    else return null;
  else if (e.length === 8)
    r = +e.slice(0, 4), o = +e.slice(4, 6), s = +e.slice(6, 8);
  else if (e.length === 6)
    r = 2e3 + +e.slice(0, 2), o = +e.slice(2, 4), s = +e.slice(4, 6);
  else if (e.length === 4)
    r = a.y, o = +e.slice(0, 2), s = +e.slice(2, 4);
  else return null;
  return o < 1 || o > 12 || s < 1 || s > Le(r, o) ? null : { y: r, m: o, d: s };
}
function Pu(e, t, a) {
  const r = e.trim(), o = t === "month" ? /^(\d{4})\D+(\d{1,2})$/.exec(r) : /^(\d{4})\D+(\d{1,2})\D+(\d{1,2})$/.exec(r);
  if (o) {
    const s = { y: +o[1], m: +o[2], d: t === "month" ? 1 : +o[3] };
    return s.m >= 1 && s.m <= 12 && s.d >= 1 && s.d <= Le(s.y, s.m) ? s : null;
  }
  return $n(r.replace(/\D/g, ""), t, a);
}
function Xu(e, t) {
  const a = { y: e, m: t, d: 1 }, r = dn(a, -je(a));
  return Array.from({ length: 42 }, (o, s) => dn(r, s));
}
function zu(e, t) {
  const a = e.y, r = [], o = (u, m) => `${String(u).padStart(4, "0")}-${Dn(m)}`, s = (u, m, _) => tt(u, m, _);
  if (t === "month") {
    r.push({ label: "이번 달", from: o(a, e.m), to: o(a, e.m) });
    const u = kt(e, -1);
    r.push({ label: "지난달", from: o(u.y, u.m), to: o(u.y, u.m) }), r.push({ label: "올해", from: o(a, 1), to: o(a, 12) }), r.push({ label: "올해 누계", from: o(a, 1), to: o(a, e.m) }), r.push({ label: "전년도", from: o(a - 1, 1), to: o(a - 1, 12) });
    for (let m = 1; m <= 4; m++) r.push({ label: `${m}분기`, from: o(a, m * 3 - 2), to: o(a, m * 3) });
    return r.push({ label: "상반기", from: o(a, 1), to: o(a, 6) }), r.push({ label: "하반기", from: o(a, 7), to: o(a, 12) }), r;
  }
  const l = tt(e.y, e.m, e.d);
  r.push({ label: "오늘", from: l, to: l });
  const c = dn(e, -je(e));
  r.push({ label: "이번 주", from: Be(c, "date"), to: Be(dn(c, 6), "date") }), r.push({ label: "이번 달", from: s(a, e.m, 1), to: s(a, e.m, Le(a, e.m)) });
  const i = kt({ ...e, d: 1 }, -1);
  r.push({ label: "지난달", from: s(i.y, i.m, 1), to: s(i.y, i.m, Le(i.y, i.m)) }), r.push({ label: "올해", from: s(a, 1, 1), to: s(a, 12, 31) }), r.push({ label: "올해 오늘까지", from: s(a, 1, 1), to: l }), r.push({ label: "전년도", from: s(a - 1, 1, 1), to: s(a - 1, 12, 31) });
  for (let u = 1; u <= 4; u++)
    r.push({ label: `${u}분기`, from: s(a, u * 3 - 2, 1), to: s(a, u * 3, Le(a, u * 3)) });
  return r;
}
const Fu = "_wrap_uxy72_1", Wu = "_disabled_uxy72_18", Hu = "_input_uxy72_22", Ku = "_month_uxy72_36", Uu = "_weekday_uxy72_39", Gu = "_sun_uxy72_40", Yu = "_sat_uxy72_41", Vu = "_icon_uxy72_43", Qu = "_readOnly_uxy72_57", Ju = "_required_uxy72_62", Zu = "_invalid_uxy72_63", em = "_pop_uxy72_66", tm = "_calHead_uxy72_79", nm = "_calTitleStatic_uxy72_80", am = "_calTitle_uxy72_80", rm = "_grid_uxy72_90", om = "_wd_uxy72_91", sm = "_day_uxy72_95", lm = "_mon_uxy72_36", cm = "_out_uxy72_104", im = "_sel_uxy72_105", um = "_today_uxy72_108", mm = "_months_uxy72_111", dm = "_foot_uxy72_114", fm = "_clear_uxy72_127", _m = "_range_uxy72_130", pm = "_tilde_uxy72_131", ym = "_rangeErr_uxy72_132", ae = {
  wrap: Fu,
  disabled: Wu,
  input: Hu,
  month: Ku,
  weekday: Uu,
  sun: Gu,
  sat: Yu,
  icon: Vu,
  readOnly: Qu,
  required: Ju,
  invalid: Zu,
  pop: em,
  calHead: tm,
  calTitleStatic: nm,
  calTitle: am,
  grid: rm,
  wd: om,
  day: sm,
  mon: lm,
  out: cm,
  sel: im,
  today: um,
  months: mm,
  foot: dm,
  clear: fm,
  range: _m,
  tilde: pm,
  rangeErr: ym
}, yt = () => {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
};
function La({
  value: e,
  onChange: t,
  mode: a = "date",
  min: r,
  max: o,
  disabled: s,
  readOnly: l,
  required: c,
  invalid: i,
  showWeekday: u,
  onReject: m,
  placeholder: _,
  id: f,
  name: p,
  onBlur: y,
  "aria-label": d,
  "aria-describedby": b,
  className: N = "",
  style: $
}) {
  const g = a === "month", x = Qt("axe-dp"), h = r || (g ? Ta.slice(0, 7) : Ta), w = o || (g ? qa.slice(0, 7) : qa), E = (k) => Ou(k, h, w), D = !!s || !!l, [C, T] = A(e || ""), [M, R] = A(!1), [q, F] = A(!1), [Y, W] = A(g ? "month" : "day"), [j, ne] = A(() => {
    var O;
    const k = (O = en(e, a)) != null ? O : yt();
    return { y: k.y, m: k.m };
  }), [te, v] = A({ top: 0, left: 0 }), P = B(null), V = B(null), Q = B(null), se = B(null);
  U(() => {
    T(e || ""), R(!1);
  }, [e]), U(() => {
    const k = en(e, a);
    k && ne({ y: k.y, m: k.m });
  }, [e, a]), $e(() => {
    const k = V.current;
    se.current != null && k && document.activeElement === k && k.setSelectionRange(se.current, se.current), se.current = null;
  }, [C]), $e(() => {
    if (!q) return;
    const k = () => {
      const O = P.current, J = Q.current;
      if (!O || !J) return;
      const oe = O.getBoundingClientRect(), ue = J.offsetHeight, Ee = J.offsetWidth;
      let De = oe.bottom + 4;
      De + ue > window.innerHeight - 8 && oe.top - ue - 4 > 8 && (De = oe.top - ue - 4);
      const Jt = Math.max(8, Math.min(oe.left, window.innerWidth - Ee - 8));
      v((Xn) => Xn.top === De && Xn.left === Jt ? Xn : { top: De, left: Jt });
    };
    return k(), window.addEventListener("resize", k), window.addEventListener("scroll", k, !0), () => {
      window.removeEventListener("resize", k), window.removeEventListener("scroll", k, !0);
    };
  }, [q, Y, j.y, j.m]), U(() => {
    if (!q) return;
    const k = (O) => {
      var oe, ue;
      const J = O.target;
      (oe = P.current) != null && oe.contains(J) || (ue = Q.current) != null && ue.contains(J) || F(!1);
    };
    return document.addEventListener("mousedown", k), () => document.removeEventListener("mousedown", k);
  }, [q]);
  const L = (k) => {
    k !== (e || "") && t(k);
  }, Z = (k) => {
    T(k), R(!1), L(k);
  }, I = () => {
    const k = Xt(C, a);
    if (!k) return;
    const O = $n(k, a, yt()), J = O ? Be(O, a) : null;
    if (J && E(J)) {
      Z(J);
      return;
    }
    m == null || m(C, J ? "range" : "format"), T(e || ""), R(!1);
  }, X = (k, O) => {
    const J = Xt(k.slice(0, O), a).length, oe = Xt(k, a), ue = Wn(oe, a);
    if (se.current = Ba(ue, Math.min(J, oe.length)), T(ue), !oe) {
      R(!1), L("");
      return;
    }
    if (oe.length === (g ? 6 : 8)) {
      const Ee = $n(oe, a, yt()), De = Ee ? Be(Ee, a) : null;
      De && E(De) ? (R(!1), L(De)) : R(!0);
    } else R(!1);
  }, G = (k, O) => {
    var Jt;
    const J = yt(), oe = Xt(C, a), ue = (Jt = $n(oe, a, J)) != null ? Jt : en(e, a);
    let Ee;
    ue ? g ? Ee = kt(ue, k === "year" ? 12 * O : O) : k === "day" ? Ee = dn(ue, O) : Ee = kt(ue, k === "month" ? O : 12 * O) : Ee = J;
    const De = Be(Ee, a);
    E(De) && Z(De);
  }, z = (k) => {
    var O;
    Z(k), F(!1), (O = V.current) == null || O.focus();
  }, H = () => {
    var O;
    if (D) return;
    const k = (O = en(e, a)) != null ? O : yt();
    ne({ y: k.y, m: k.m }), W(g ? "month" : "day"), F(!0);
  }, ie = (k) => {
    var J, oe;
    if (D) return;
    const O = k.currentTarget;
    switch (k.key) {
      case "Escape":
        q ? (F(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation()) : C !== (e || "") && (T(e || ""), R(!1), k.preventDefault(), k.stopPropagation(), k.nativeEvent.stopImmediatePropagation(), requestAnimationFrame(() => O.select()));
        break;
      case "ArrowDown":
        k.preventDefault(), k.altKey ? q ? F(!1) : H() : G("day", 1);
        break;
      case "ArrowUp":
        k.preventDefault(), G("day", -1);
        break;
      case "PageDown":
        k.preventDefault(), G("month", 1);
        break;
      case "PageUp":
        k.preventDefault(), G("month", -1);
        break;
      case "F2":
      case "F4":
        k.preventDefault(), q ? F(!1) : H();
        break;
      case "Enter":
        I(), q && F(!1);
        break;
      case "t":
      case "T":
        if (k.ctrlKey || k.metaKey || k.altKey) break;
        k.preventDefault(), Z(Be(yt(), a));
        break;
      case "Backspace": {
        const ue = (J = O.selectionStart) != null ? J : 0;
        if (ue === ((oe = O.selectionEnd) != null ? oe : 0) && ue > 0 && C[ue - 1] === "-") {
          k.preventDefault();
          const Ee = Xt(C.slice(0, ue), a).length, De = Xt(C, a);
          X(Wn(De.slice(0, Ee - 1) + De.slice(Ee), a), 0), se.current = Ba(Wn(De.slice(0, Ee - 1) + De.slice(Ee), a), Ee - 1);
        }
        break;
      }
    }
  }, Ie = (k) => {
    if (D) return;
    k.preventDefault();
    const O = Pu(k.clipboardData.getData("text"), a, yt()), J = O ? Be(O, a) : null;
    J && E(J) ? Z(J) : R(!0);
  }, xe = (k) => {
    var J, oe;
    const O = k.relatedTarget;
    O && ((J = P.current) != null && J.contains(O) || (oe = Q.current) != null && oe.contains(O)) || (I(), F(!1), y && y());
  }, ze = en(e, a), dt = yt(), Rt = M || !!i, wt = u && !g && ze ? je(ze) : null, pe = (k) => Be(k, a), nt = (k, O) => {
    const J = Be({ y: k, m: O, d: 1 }, "date"), oe = Be({ y: k, m: O, d: Le(k, O) }, "date"), ue = g ? h + "-01" : h, Ee = g ? w + "-31" : w;
    return oe >= ue && J <= Ee;
  }, Ke = (k) => {
    const O = kt({ y: j.y, m: j.m, d: 1 }, k);
    ne({ y: O.y, m: O.m });
  }, It = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ke(-12) }, "«"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 달", onClick: () => Ke(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.calTitle, "aria-label": "연·월 선택", onClick: () => W("month") }, j.y, "년 ", j.m, "월"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 달", onClick: () => Ke(1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ke(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.grid }, Fn.map((k, O) => /* @__PURE__ */ n.createElement("span", { key: k, className: [ae.wd, O === 0 ? ae.sun : "", O === 6 ? ae.sat : ""].join(" ") }, k)), Xu(j.y, j.m).map((k) => {
    const O = Be(k, "date"), J = je(k), oe = [
      ae.day,
      k.m !== j.m ? ae.out : "",
      J === 0 ? ae.sun : "",
      J === 6 ? ae.sat : "",
      O === Be(dt, "date") ? ae.today : "",
      ze && O === Be(ze, "date") ? ae.sel : ""
    ].join(" "), ue = !E(O);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: O,
        type: "button",
        tabIndex: -1,
        className: oe,
        disabled: ue,
        "aria-label": `${k.y}년 ${k.m}월 ${k.d}일 ${Fn[J]}요일`,
        "aria-pressed": !!ze && O === Be(ze, "date"),
        onClick: () => z(O)
      },
      k.d
    );
  }))), ft = () => /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("div", { className: ae.calHead }, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "이전 해", onClick: () => Ke(-12) }, "«"), /* @__PURE__ */ n.createElement("span", { className: ae.calTitleStatic }, j.y, "년"), /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, "aria-label": "다음 해", onClick: () => Ke(12) }, "»")), /* @__PURE__ */ n.createElement("div", { className: ae.months }, Array.from({ length: 12 }, (k, O) => O + 1).map((k) => {
    const O = !!ze && ze.y === j.y && ze.m === k, J = [ae.mon, O ? ae.sel : "", dt.y === j.y && dt.m === k ? ae.today : ""].join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: k,
        type: "button",
        tabIndex: -1,
        className: J,
        disabled: !nt(j.y, k),
        "aria-pressed": O,
        onClick: () => {
          g ? z(pe({ y: j.y, m: k, d: 1 })) : (ne({ y: j.y, m: k }), W("day"));
        }
      },
      k,
      "월"
    );
  }))), Ot = Be(dt, a), Nt = g ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ot), onClick: () => z(Ot) }, "이번 달")) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, disabled: !E(Ot), onClick: () => z(Ot) }, "오늘"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(pe({ y: j.y, m: j.m, d: 1 })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: 1 }))
    },
    "월초"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      disabled: !E(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) })),
      onClick: () => z(pe({ y: j.y, m: j.m, d: Le(j.y, j.m) }))
    },
    "월말"
  )), yn = [
    ae.wrap,
    s ? ae.disabled : "",
    l ? ae.readOnly : "",
    c && !e && !C ? ae.required : "",
    Rt ? ae.invalid : "",
    g ? ae.month : "",
    N
  ].filter(Boolean).join(" ");
  return /* @__PURE__ */ n.createElement("span", { ref: P, className: yn, style: $, onBlur: xe }, /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: V,
      id: f,
      name: p,
      className: ae.input,
      inputMode: "numeric",
      autoComplete: "off",
      spellCheck: !1,
      value: C,
      placeholder: _ != null ? _ : g ? "YYYY-MM" : "YYYY-MM-DD",
      disabled: s,
      readOnly: l,
      role: "combobox",
      "aria-haspopup": "dialog",
      "aria-expanded": q,
      "aria-controls": x,
      "aria-label": d,
      "aria-describedby": b,
      "aria-invalid": Rt || void 0,
      "aria-required": c || void 0,
      onChange: (k) => {
        var O;
        return X(k.target.value, (O = k.target.selectionStart) != null ? O : k.target.value.length);
      },
      onKeyDown: ie,
      onPaste: Ie
    }
  ), wt != null && /* @__PURE__ */ n.createElement("span", { className: [ae.weekday, wt === 0 ? ae.sun : "", wt === 6 ? ae.sat : ""].join(" "), "aria-hidden": "true" }, "(", Fn[wt], ")"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      tabIndex: -1,
      className: ae.icon,
      disabled: D,
      "aria-label": g ? "월 선택 열기" : "달력 열기",
      onMouseDown: (k) => k.preventDefault(),
      onClick: () => {
        var k;
        (k = V.current) == null || k.focus(), q ? F(!1) : H();
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "calendar", size: 15 })
  ), q && /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: Q,
      id: x,
      className: ae.pop,
      style: { top: te.top, left: te.left },
      role: "dialog",
      "aria-label": g ? "월 선택" : "날짜 선택",
      onMouseDown: (k) => k.preventDefault()
    },
    Y === "day" && !g ? It() : ft(),
    /* @__PURE__ */ n.createElement("div", { className: ae.foot }, Nt, !c && /* @__PURE__ */ n.createElement("button", { type: "button", tabIndex: -1, className: ae.clear, onClick: () => z("") }, "비우기"))
  )));
}
const Mt = (e) => String(e).padStart(2, "0");
function qr() {
  const e = /* @__PURE__ */ new Date();
  return `${e.getFullYear()}-${Mt(e.getMonth() + 1)}-${Mt(e.getDate())}`;
}
function v0(e) {
  if (!e) return "";
  const t = new Date(e);
  return Number.isNaN(t.getTime()) ? String(e) : `${t.getFullYear()}-${Mt(t.getMonth() + 1)}-${Mt(t.getDate())} ${Mt(t.getHours())}:${Mt(t.getMinutes())}:${Mt(t.getSeconds())}`;
}
function k0(e, t) {
  return !!e && !!t && e <= t;
}
function w0({
  from: e,
  to: t,
  onChange: a,
  mode: r = "date",
  min: o,
  max: s,
  disabled: l,
  label: c = "기간",
  presets: i = !0,
  showWeekday: u,
  onReject: m
}) {
  const _ = !!e && !!t && e > t, f = /* @__PURE__ */ new Date(), p = i === !1 ? [] : Array.isArray(i) ? i : zu({ y: f.getFullYear(), m: f.getMonth() + 1, d: f.getDate() }, r), y = (d) => (!o || d.from >= o) && (!s || d.to <= s);
  return /* @__PURE__ */ n.createElement("span", { className: ae.range }, /* @__PURE__ */ n.createElement(
    La,
    {
      value: e,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 시작일`,
      onChange: (d) => a(d, t),
      onReject: m && ((d, b) => m(d, b, "from"))
    }
  ), /* @__PURE__ */ n.createElement("span", { className: ae.tilde, "aria-hidden": "true" }, "~"), /* @__PURE__ */ n.createElement(
    La,
    {
      value: t,
      mode: r,
      min: o,
      max: s,
      disabled: l,
      showWeekday: u,
      "aria-label": `${c} 종료일`,
      onChange: (d) => a(e, d),
      onReject: m && ((d, b) => m(d, b, "to"))
    }
  ), p.length > 0 && /* @__PURE__ */ n.createElement(
    cs,
    {
      label: "기간",
      title: `${c} 빠른 선택`,
      disabled: l,
      entries: p.map((d) => ls(
        d.label,
        d.label,
        () => a(d.from, d.to),
        y(d) ? {} : { disabled: !0, reason: "허용 범위 밖" }
      ))
    }
  ), _ && /* @__PURE__ */ n.createElement("span", { className: ae.rangeErr, role: "alert" }, "시작일이 종료일보다 늦습니다"));
}
const Br = [
  { name: "明治", short: "M", start: "1868-09-08" },
  { name: "大正", short: "T", start: "1912-07-30" },
  { name: "昭和", short: "S", start: "1926-12-25" },
  { name: "平成", short: "H", start: "1989-01-08" },
  { name: "令和", short: "R", start: "2019-05-01" }
];
function Lr(e, t = Br) {
  const a = /^(\d{4})-\d{2}-\d{2}/.exec(e != null ? e : "");
  if (!a) return null;
  let r = null;
  for (const o of t) o.start <= e.slice(0, 10) && (!r || o.start > r.start) && (r = o);
  return r ? { era: r, year: +a[1] - +r.start.slice(0, 4) + 1 } : null;
}
function bm(e, t = {}) {
  const a = Lr(e, t.eras);
  return a ? `${a.era.name}${a.year === 1 && t.gannen !== !1 ? "元" : a.year}年` : null;
}
function N0(e, t) {
  const a = Lr(e, t);
  return a ? `${a.era.short}${a.year}.${e.slice(5, 7)}.${e.slice(8, 10)}` : null;
}
const Se = 1440, An = (e) => String(e).padStart(2, "0");
function _e(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/.exec(e != null ? e : "");
  return t ? Date.UTC(+t[1], +t[2] - 1, +t[3], t[4] ? +t[4] : 0, t[5] ? +t[5] : 0) / 6e4 : NaN;
}
function qt(e) {
  const t = new Date(e * 6e4);
  return tt(t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate());
}
function on(e) {
  const t = new Date(e * 6e4);
  return `${qt(e)}T${An(t.getUTCHours())}:${An(t.getUTCMinutes())}`;
}
function Je(e) {
  const t = (e % Se + Se) % Se;
  return `${An(Math.floor(t / 60))}:${An(t % 60)}`;
}
function ve(e, t) {
  return de(e) ? Ln(e, t) : e;
}
function Gt(e, t) {
  return Math.round((_e(t) - _e(e)) / Se);
}
function fn(e) {
  if (!de(e)) return !1;
  const t = Ea(e);
  return t === 0 || t === 6;
}
function Em(e) {
  var o;
  const t = _e(e.start);
  if (Number.isNaN(t)) return null;
  const a = (o = e.allDay) != null ? o : !/[T ]\d{2}:\d{2}/.test(e.start);
  if (a) {
    const s = qt(t), l = e.end ? qt(_e(e.end)) : s, c = l < s ? s : l;
    return { ev: e, s: _e(s), e: _e(c) + Se, allDay: a, sDay: s, eDay: c };
  }
  let r = e.end ? _e(e.end) : t + 60;
  return (Number.isNaN(r) || r <= t) && (r = t + 30), { ev: e, s: t, e: r, allDay: a, sDay: qt(t), eDay: qt(r - 1) };
}
function jn(e, t, a, r) {
  const o = [];
  for (const s of e) {
    const l = r && s.id === r.id ? { ...s, start: r.start, end: r.end } : s, c = Em(l);
    c && c.eDay >= t && c.sDay <= a && o.push(c);
  }
  return o.sort(hm);
}
function hm(e, t) {
  if (e.sDay !== t.sDay) return e.sDay < t.sDay ? -1 : 1;
  const a = Gt(t.sDay, t.eDay) - Gt(e.sDay, e.eDay);
  return a || (e.allDay !== t.allDay ? e.allDay ? -1 : 1 : e.s !== t.s ? e.s - t.s : e.ev.title.localeCompare(t.ev.title));
}
function gm(e) {
  return e.allDay || e.sDay !== e.eDay;
}
function jr(e) {
  return e.allDay || e.e - e.s >= Se;
}
function Cn(e, t) {
  const a = de(e);
  if (!a) return e;
  const r = (je(a) - t + 7) % 7;
  return ve(e, -r);
}
function Rn(e, t) {
  const a = Gt(e, t);
  return Array.from({ length: Math.max(0, a + 1) }, (r, o) => ve(e, o));
}
function Rr(e, t) {
  const a = de(e), r = tt(a.y, a.m, 1), o = tt(a.y, a.m, Le(a.y, a.m)), s = Cn(r, t), l = ve(Cn(o, t), 6), c = Rn(s, l), i = [];
  for (let u = 0; u < c.length; u += 7) i.push(c.slice(u, u + 7));
  return i;
}
function ha(e, t, a) {
  if (e === "month") {
    const r = Rr(t, a);
    return { from: r[0][0], to: r[r.length - 1][6] };
  }
  if (e === "agenda") {
    const r = de(t);
    return { from: tt(r.y, r.m, 1), to: tt(r.y, r.m, Le(r.y, r.m)) };
  }
  if (e === "week") {
    const r = Cn(t, a);
    return { from: r, to: ve(r, 6) };
  }
  return { from: t, to: t };
}
function vm(e, t, a, r = !1) {
  const o = de(t);
  if (!o) return t;
  if (e === "month" || e === "agenda") {
    const l = kt(o, a);
    return tt(l.y, l.m, l.d);
  }
  if (e === "week") return ve(t, 7 * a);
  let s = ve(t, a);
  for (; r && fn(s); ) s = ve(s, a);
  return s;
}
function km(e, t, a, r) {
  if (!de(t)) return "";
  if (e === "month" || e === "agenda") return r.ym(`${t.slice(0, 7)}-01`);
  if (e === "day") return r.dayTitle(t);
  const { from: o, to: s } = ha("week", t, a);
  return r.year(o) !== r.year(s) ? `${r.ymd(o)} – ${r.ymd(s)}` : o.slice(5, 7) !== s.slice(5, 7) ? `${r.ymd(o)} – ${r.md(s)}` : `${r.ymd(o)} – ${r.d(s)}`;
}
function Ir(e, t) {
  const a = [], r = [];
  for (const o of e) {
    let s = -1, l = -1;
    for (let i = 0; i < t.length; i++)
      t[i] >= o.sDay && t[i] <= o.eDay && (s < 0 && (s = i), l = i);
    if (s < 0) continue;
    let c = r.findIndex((i) => i < s);
    c < 0 ? (c = r.length, r.push(l)) : r[c] = l, a.push({ item: o, col: s, span: l - s + 1, lane: c, contL: o.sDay < t[s], contR: o.eDay > t[l] });
  }
  return a;
}
function wm(e, t, a) {
  const r = new Array(t).fill(0);
  for (const c of e) for (let i = c.col; i < c.col + c.span; i++) r[i]++;
  const o = Math.max(1, a), s = e.filter((c) => {
    if (c.lane < o - 1) return !0;
    if (c.lane > o - 1) return !1;
    for (let i = c.col; i < c.col + c.span; i++) if (r[i] > o) return !1;
    return !0;
  }), l = new Array(t).fill(0);
  for (const c of s) for (let i = c.col; i < c.col + c.span; i++) l[i]++;
  return { shown: s, more: r.map((c, i) => c - l[i]) };
}
const Nm = 20;
function $m(e, t) {
  const a = _e(t), r = a + Se, o = e.filter((u) => !jr(u) && u.s < r && u.e > a).map((u) => ({
    item: u,
    top: Math.max(u.s, a) - a,
    bottom: Math.min(u.e, r) - a,
    col: 0,
    cols: 1,
    contTop: u.s < a,
    contBottom: u.e > r
  })).sort((u, m) => u.top - m.top || m.bottom - u.bottom);
  let s = [], l = [], c = -1;
  const i = () => {
    for (const u of s) u.cols = l.length;
    s = [], l = [];
  };
  for (const u of o) {
    u.top >= c && i();
    const m = Math.max(u.bottom, u.top + Nm);
    let _ = l.findIndex((f) => f <= u.top);
    _ < 0 ? (_ = l.length, l.push(m)) : l[_] = m, u.col = _, s.push(u), c = Math.max(c, m);
  }
  return i(), o;
}
function ja(e, t) {
  return Math.round(e / t) * t;
}
function oa(e, t) {
  if (e.allDay) {
    const a = Math.round(t / Se);
    return { start: ve(e.sDay, a), end: ve(e.eDay, a) };
  }
  return { start: on(e.s + t), end: on(e.e + t) };
}
function ga(e, t = "종일") {
  if (e.allDay) {
    if (e.sDay === e.eDay) return t;
    const l = de(e.sDay), c = de(e.eDay);
    return `${l.m}/${l.d} – ${c.m}/${c.d}`;
  }
  const a = _e(e.sDay), r = Je(e.s - a);
  if (e.sDay === e.eDay) return `${r} – ${e.e - a === Se ? "24:00" : Je(e.e - a)}`;
  const o = de(e.sDay), s = de(qt(e.e));
  return `${o.m}/${o.d} ${r} – ${s.m}/${s.d} ${Je(e.e - _e(qt(e.e)))}`;
}
const Ae = (e) => {
  const t = de(e);
  return { ...t, w: je(t) };
};
function Ra(e, t, a, r, o) {
  const s = `${+e.slice(0, 4)}${a}`;
  if (t === "gregorian") return s;
  const l = bm(e, { eras: r, gannen: o });
  return l ? t === "era" ? l : `${s}(${l})` : s;
}
function xm(e = "ko", t = {}) {
  var i, u;
  const a = (i = t.year) != null ? i : e === "ja" ? "era" : "gregorian", r = (u = t.eras) != null ? u : Br, o = t.gannen !== !1;
  if (e === "ja") {
    const m = ["日", "月", "火", "水", "木", "金", "土"], _ = (p) => Ra(p, a, "年", r, o), f = { month: "月", week: "週", day: "日", agenda: "月" };
    return {
      weekdays: m,
      views: { month: "月", week: "週", day: "日", agenda: "一覧" },
      today: "今日",
      prev: (p) => `前の${f[p]} (P)`,
      next: (p) => `次の${f[p]} (N)`,
      hideWeekends: "週末を隠す",
      prevMonth: "前月",
      nextMonth: "翌月",
      prevYear: "前年",
      nextYear: "翌年",
      pickMonth: "月を選択",
      viewTabs: "表示",
      region: "スケジュール",
      loading: "読み込み中",
      close: "閉じる",
      allDay: "終日",
      empty: "この期間の予定はありません。",
      more: (p) => `他${p}件`,
      eventCount: (p) => `予定${p}件`,
      dayOfSpan: (p, y) => `${p}/${y}日目`,
      openDay: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日を日表示`;
      },
      year: _,
      ym: (p) => `${_(p)}${Ae(p).m}月`,
      ymd: (p) => {
        const y = Ae(p);
        return `${_(p)}${y.m}月${y.d}日`;
      },
      md: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日`;
      },
      d: (p) => `${Ae(p).d}日`,
      m: (p) => `${Ae(p).m}月`,
      dayTitle: (p) => {
        const y = Ae(p);
        return `${_(p)}${y.m}月${y.d}日(${m[y.w]})`;
      },
      dayAria: (p) => {
        const y = Ae(p);
        return `${y.m}月${y.d}日 ${m[y.w]}曜日`;
      }
    };
  }
  const s = ["일", "월", "화", "수", "목", "금", "토"], l = (m) => Ra(m, a, "년", r, o), c = { month: "달", week: "주", day: "날", agenda: "달" };
  return {
    weekdays: s,
    views: { month: "월", week: "주", day: "일", agenda: "목록" },
    today: "오늘",
    prev: (m) => `이전 ${c[m]} (P)`,
    next: (m) => `다음 ${c[m]} (N)`,
    hideWeekends: "주말 숨김",
    prevMonth: "이전 달",
    nextMonth: "다음 달",
    prevYear: "이전 해",
    nextYear: "다음 해",
    pickMonth: "월 선택",
    viewTabs: "보기",
    region: "일정 달력",
    loading: "일정 불러오는 중",
    close: "닫기",
    allDay: "종일",
    empty: "이 기간에 일정이 없습니다.",
    more: (m) => `+${m}개`,
    eventCount: (m) => `일정 ${m}건`,
    dayOfSpan: (m, _) => `${m}/${_}일째`,
    openDay: (m) => {
      const _ = Ae(m);
      return `${_.m}월 ${_.d}일 일 보기`;
    },
    year: l,
    ym: (m) => `${l(m)} ${Ae(m).m}월`,
    ymd: (m) => {
      const _ = Ae(m);
      return `${l(m)} ${_.m}월 ${_.d}일`;
    },
    md: (m) => {
      const _ = Ae(m);
      return `${_.m}월 ${_.d}일`;
    },
    d: (m) => `${Ae(m).d}일`,
    m: (m) => `${Ae(m).m}월`,
    dayTitle: (m) => {
      const _ = Ae(m);
      return `${l(m)} ${_.m}월 ${_.d}일 (${s[_.w]})`;
    },
    dayAria: (m) => {
      const _ = Ae(m);
      return `${_.m}월 ${_.d}일 ${s[_.w]}요일`;
    }
  };
}
const Or = xm("ko"), Dm = "_cal_38qtm_2", Am = "_toolbar_38qtm_20", Cm = "_navBtns_38qtm_28", Sm = "_title_38qtm_29", Mm = "_toolRight_38qtm_36", Tm = "_toggle_38qtm_37", qm = "_body_38qtm_58", Bm = "_busy_38qtm_59", Lm = "_sun_38qtm_71", jm = "_sat_38qtm_72", Rm = "_tAccent_38qtm_75", Im = "_tOk_38qtm_76", Om = "_tWarn_38qtm_77", Pm = "_tDanger_38qtm_78", Xm = "_tViolet_38qtm_79", zm = "_tGray_38qtm_80", Fm = "_month_38qtm_83", Wm = "_mHead_38qtm_84", Hm = "_wdName_38qtm_85", Km = "_mBody_38qtm_91", Um = "_mWeek_38qtm_92", Gm = "_mCells_38qtm_94", Ym = "_cell_38qtm_96", Vm = "_out_38qtm_104", Qm = "_dayNum_38qtm_105", Jm = "_creatable_38qtm_106", Zm = "_selDay_38qtm_109", ed = "_cellHead_38qtm_111", td = "_isToday_38qtm_124", nd = "_holiday_38qtm_125", ad = "_addHint_38qtm_130", rd = "_barLayer_38qtm_138", od = "_chip_38qtm_139", sd = "_more_38qtm_139", ld = "_tEv_38qtm_155", cd = "_aRow_38qtm_155", id = "_popItem_38qtm_155", ud = "_bar_38qtm_138", md = "_contL_38qtm_165", dd = "_contR_38qtm_166", fd = "_dotChip_38qtm_167", _d = "_dot_38qtm_167", pd = "_chipTime_38qtm_170", yd = "_chipTitle_38qtm_171", bd = "_movable_38qtm_173", Ed = "_ghost_38qtm_176", hd = "_time_38qtm_189", gd = "_tHead_38qtm_190", vd = "_tAllDay_38qtm_190", kd = "_gutter_38qtm_193", wd = "_tHeadDays_38qtm_197", Nd = "_tAllDayCells_38qtm_197", $d = "_tDay_38qtm_198", xd = "_tDayBtn_38qtm_202", Dd = "_tWd_38qtm_206", Ad = "_tDayNum_38qtm_208", Cd = "_tAllDayRow_38qtm_216", Sd = "_allDayCell_38qtm_218", Md = "_tBody_38qtm_222", Td = "_tGrid_38qtm_223", qd = "_tGutter_38qtm_224", Bd = "_tCols_38qtm_230", Ld = "_tCol_38qtm_230", jd = "_tSel_38qtm_238", Rd = "_tEvTitle_38qtm_258", Id = "_tEvTime_38qtm_259", Od = "_tEvShort_38qtm_261", Pd = "_contTop_38qtm_263", Xd = "_contBottom_38qtm_264", zd = "_resize_38qtm_265", Fd = "_now_38qtm_268", Wd = "_agenda_38qtm_272", Hd = "_aDay_38qtm_273", Kd = "_aDate_38qtm_275", Ud = "_aDateBtn_38qtm_276", Gd = "_aDayNum_38qtm_280", Yd = "_aDayWd_38qtm_286", Vd = "_aList_38qtm_288", Qd = "_aTime_38qtm_295", Jd = "_aTitle_38qtm_296", Zd = "_aSpan_38qtm_297", ef = "_aLoc_38qtm_298", tf = "_empty_38qtm_303", nf = "_pop_38qtm_155", af = "_popHead_38qtm_321", rf = "_popDay_38qtm_322", of = "_popClose_38qtm_329", sf = "_popList_38qtm_334", lf = "_tAllDayOnly_38qtm_348", S = {
  cal: Dm,
  toolbar: Am,
  navBtns: Cm,
  title: Sm,
  toolRight: Mm,
  toggle: Tm,
  body: qm,
  busy: Bm,
  sun: Lm,
  sat: jm,
  tAccent: Rm,
  tOk: Im,
  tWarn: Om,
  tDanger: Pm,
  tViolet: Xm,
  tGray: zm,
  month: Fm,
  mHead: Wm,
  wdName: Hm,
  mBody: Km,
  mWeek: Um,
  mCells: Gm,
  cell: Ym,
  out: Vm,
  dayNum: Qm,
  creatable: Jm,
  selDay: Zm,
  cellHead: ed,
  isToday: td,
  holiday: nd,
  addHint: ad,
  barLayer: rd,
  chip: od,
  more: sd,
  tEv: ld,
  aRow: cd,
  popItem: id,
  bar: ud,
  contL: md,
  contR: dd,
  dotChip: fd,
  dot: _d,
  chipTime: pd,
  chipTitle: yd,
  movable: bd,
  ghost: Ed,
  time: hd,
  tHead: gd,
  tAllDay: vd,
  gutter: kd,
  tHeadDays: wd,
  tAllDayCells: Nd,
  tDay: $d,
  tDayBtn: xd,
  tWd: Dd,
  tDayNum: Ad,
  tAllDayRow: Cd,
  allDayCell: Sd,
  tBody: Md,
  tGrid: Td,
  tGutter: qd,
  tCols: Bd,
  tCol: Ld,
  tSel: jd,
  tEvTitle: Rd,
  tEvTime: Id,
  tEvShort: Od,
  contTop: Pd,
  contBottom: Xd,
  resize: zd,
  now: Fd,
  agenda: Wd,
  aDay: Hd,
  aDate: Kd,
  aDateBtn: Ud,
  aDayNum: Gd,
  aDayWd: Yd,
  aList: Vd,
  aTime: Qd,
  aTitle: Jd,
  aSpan: Zd,
  aLoc: ef,
  empty: tf,
  pop: nf,
  popHead: af,
  popDay: rf,
  popClose: of,
  popList: sf,
  tAllDayOnly: lf
}, _n = 22, cf = {
  accent: S.tAccent,
  ok: S.tOk,
  warn: S.tWarn,
  danger: S.tDanger,
  violet: S.tViolet,
  gray: S.tGray
};
function In(e) {
  var t;
  return e.color ? "" : cf[(t = e.tone) != null ? t : "accent"];
}
function On(e) {
  if (e.color)
    return { "--ev": e.color };
}
function Pr(e, t) {
  return [e.ev.title, ga(e, t.allDay), e.ev.location].filter(Boolean).join(", ");
}
const sn = (e, t) => !!e.onEventChange && !t.locked;
function xn(e, t, a) {
  var r;
  for (const o of document.elementsFromPoint(e, t)) {
    const s = (r = o.closest) == null ? void 0 : r.call(o, `[${a}]`);
    if (s) return s;
  }
  return null;
}
function Sn(e, t) {
  const a = e.clientX, r = e.clientY;
  let o = !1;
  const s = (m) => {
    !o && Math.hypot(m.clientX - a, m.clientY - r) < 4 || (o = !0, t.move(m));
  }, l = () => {
    window.removeEventListener("pointermove", s), window.removeEventListener("pointerup", c), window.removeEventListener("pointercancel", i), window.removeEventListener("keydown", u, !0);
  }, c = (m) => {
    l(), t.end(m, o);
  }, i = () => {
    l(), t.cancel();
  }, u = (m) => {
    m.key === "Escape" && (m.preventDefault(), m.stopPropagation(), i());
  };
  window.addEventListener("pointermove", s), window.addEventListener("pointerup", c), window.addEventListener("pointercancel", i), window.addEventListener("keydown", u, !0);
}
function Xr(e) {
  const [t, a] = A(null), [r, o] = A(null), s = B(!1);
  return { preview: t, items: (_, f) => jn(e.events, _, f, t), onItemDown: (_, f) => {
    var d;
    if (_.button !== 0 || !sn(e, f.ev)) return;
    const p = (d = xn(_.clientX, _.clientY, "data-cal-day")) == null ? void 0 : d.dataset.calDay;
    if (!p) return;
    s.current = !1;
    let y = 0;
    Sn(_, {
      move: (b) => {
        var $;
        s.current = !0;
        const N = ($ = xn(b.clientX, b.clientY, "data-cal-day")) == null ? void 0 : $.dataset.calDay;
        N && (y = Gt(p, N), a({ id: f.ev.id, ...oa(f, y * Se) }));
      },
      end: (b, N) => {
        var $;
        a(null), N && y && (($ = e.onEventChange) == null || $.call(e, f.ev, oa(f, y * Se)));
      },
      cancel: () => a(null)
    });
  }, onCellDown: (_, f) => {
    if (_.button !== 0 || !e.onCreate) return;
    _.preventDefault();
    let p = f;
    o({ a: f, b: f }), Sn(_, {
      move: (y) => {
        var b;
        const d = (b = xn(y.clientX, y.clientY, "data-cal-day")) == null ? void 0 : b.dataset.calDay;
        d && (p = d, o({ a: f, b: d }));
      },
      end: () => {
        var b;
        o(null);
        const [y, d] = f <= p ? [f, p] : [p, f];
        (b = e.onCreate) == null || b.call(e, { start: y, end: d, allDay: !0 });
      },
      cancel: () => o(null)
    });
  }, clickItem: (_, f) => {
    var p;
    if (s.current) {
      s.current = !1;
      return;
    }
    (p = e.onEventClick) == null || p.call(e, f, _);
  }, inSel: (_) => !!r && _ >= (r.a < r.b ? r.a : r.b) && _ <= (r.a < r.b ? r.b : r.a) };
}
function zr({
  segs: e,
  cols: t,
  top: a,
  ctx: r,
  drag: o
}) {
  return /* @__PURE__ */ n.createElement("div", { className: S.barLayer }, e.map((s) => {
    var _;
    const l = s.item, c = l.ev, i = gm(l), u = Je(l.s - _e(l.sDay)), m = [
      S.chip,
      i ? S.bar : S.dotChip,
      In(c),
      s.contL ? S.contL : "",
      s.contR ? S.contR : "",
      ((_ = o.preview) == null ? void 0 : _.id) === c.id ? S.ghost : "",
      sn(r, c) ? S.movable : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: `${c.id}:${s.col}`,
        type: "button",
        className: m,
        style: {
          left: `calc(${s.col / t * 100}% + 2px)`,
          width: `calc(${s.span / t * 100}% - 4px)`,
          top: a + s.lane * _n,
          ...On(c)
        },
        "aria-label": Pr(l, r.L),
        onPointerDown: (f) => o.onItemDown(f, l),
        onClick: (f) => o.clickItem(f.currentTarget, c)
      },
      i ? /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, !l.allDay && !s.contL && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), c.title) : /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }), /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, u), /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, c.title))
    );
  }));
}
const Hn = 26;
function uf({ ctx: e }) {
  const { L: t, cursor: a, today: r, weekStartsOn: o, showWeekends: s, holidays: l } = e, c = a.slice(0, 7), i = ke(
    () => Rr(a, o).map((x) => s ? x : x.filter((h) => !fn(h))),
    [a, o, s]
  ), u = i[0].length, m = Xr(e), _ = m.items(i[0][0], i[i.length - 1][u - 1]), f = B(null), [p, y] = A(0);
  $e(() => {
    const x = f.current;
    if (!x) return;
    const h = () => y(x.clientHeight / i.length);
    if (h(), typeof ResizeObserver == "undefined") return;
    const w = new ResizeObserver(h);
    return w.observe(x), () => w.disconnect();
  }, [i.length]);
  const d = p ? Math.max(1, Math.floor((p - Hn - 4) / _n)) : 3, b = B(!1), N = B(null);
  U(() => {
    var x, h;
    b.current && (b.current = !1, (h = (x = N.current) == null ? void 0 : x.querySelector(`[data-cal-day="${a}"]`)) == null || h.focus());
  }, [a, c]);
  const $ = (x, h) => {
    let w = ve(x, h);
    for (; !s && fn(w); ) w = ve(w, h > 0 ? 1 : -1);
    return w;
  }, g = (x, h, w) => {
    let E = null;
    if (x.key === "ArrowLeft") E = $(h, -1);
    else if (x.key === "ArrowRight") E = $(h, 1);
    else if (x.key === "ArrowUp") E = $(h, -7);
    else if (x.key === "ArrowDown") E = $(h, 7);
    else if (x.key === "Home") E = w[0];
    else if (x.key === "End") E = w[w.length - 1];
    else if (x.key === "Enter" || x.key === " ") {
      x.preventDefault(), e.goto("day", h);
      return;
    }
    E && (x.preventDefault(), b.current = !0, e.setCursor(E));
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.month, role: "grid", "aria-label": t.ym(`${c}-01`), ref: N }, /* @__PURE__ */ n.createElement("div", { className: S.mHead, role: "row" }, i[0].map((x) => {
    const h = je(de(x));
    return /* @__PURE__ */ n.createElement("div", { key: x, role: "columnheader", className: [S.wdName, h === 0 ? S.sun : "", h === 6 ? S.sat : ""].join(" ") }, t.weekdays[h]);
  })), /* @__PURE__ */ n.createElement("div", { className: S.mBody, ref: f }, i.map((x) => {
    const { shown: h, more: w } = wm(Ir(_, x), u, d);
    return /* @__PURE__ */ n.createElement("div", { key: x[0], className: S.mWeek, role: "row" }, /* @__PURE__ */ n.createElement("div", { className: S.mCells, style: { gridTemplateColumns: `repeat(${u}, minmax(0, 1fr))` } }, x.map((E) => {
      const D = de(E), C = je(D), T = l[E], M = _.filter((q) => q.sDay <= E && q.eDay >= E).length, R = [
        S.cell,
        E.slice(0, 7) !== c ? S.out : "",
        C === 0 || T ? S.sun : C === 6 ? S.sat : "",
        E === r ? S.isToday : "",
        m.inSel(E) ? S.selDay : "",
        e.onCreate ? S.creatable : ""
      ].filter(Boolean).join(" ");
      return /* @__PURE__ */ n.createElement(
        "div",
        {
          key: E,
          role: "gridcell",
          "data-cal-day": E,
          tabIndex: E === a ? 0 : -1,
          "aria-selected": E === a,
          "aria-current": E === r ? "date" : void 0,
          "aria-label": `${t.dayAria(E)}${T ? ` ${T}` : ""}, ${t.eventCount(M)}`,
          className: R,
          onPointerDown: (q) => m.onCellDown(q, E),
          onKeyDown: (q) => g(q, E, x)
        },
        /* @__PURE__ */ n.createElement("div", { className: S.cellHead }, /* @__PURE__ */ n.createElement(
          "button",
          {
            type: "button",
            tabIndex: -1,
            className: S.dayNum,
            "aria-label": t.openDay(E),
            onPointerDown: (q) => q.stopPropagation(),
            onClick: () => e.goto("day", E)
          },
          D.d === 1 ? t.md(E) : D.d
        ), T && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: T }, T), e.onCreate && /* @__PURE__ */ n.createElement("span", { className: S.addHint, "aria-hidden": !0 }, "+"))
      );
    })), /* @__PURE__ */ n.createElement(zr, { segs: h, cols: u, top: Hn, ctx: e, drag: m }), w.map((E, D) => E > 0 ? /* @__PURE__ */ n.createElement(
      "button",
      {
        key: x[D],
        type: "button",
        className: S.more,
        style: {
          left: `calc(${D / u * 100}% + 2px)`,
          width: `calc(${100 / u}% - 4px)`,
          top: Hn + (d - 1) * _n
        },
        onClick: (C) => e.openMore(x[D], C.currentTarget)
      },
      t.more(E)
    ) : null));
  })));
}
const Ye = 44, mf = Array.from({ length: 23 }, (e, t) => t + 1);
function Ia() {
  const e = /* @__PURE__ */ new Date();
  return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes()) / 6e4;
}
function Kn(e, t) {
  const a = t.getBoundingClientRect();
  return Math.max(0, Math.min(Se, (e - a.top) / Ye * 60));
}
function Oa({ ctx: e, days: t }) {
  const a = t.length, r = e.slotMinutes, o = Xr(e), [s, l] = A(null), [c, i] = A(null), u = B(!1), m = jn(e.events, t[0], t[a - 1], s != null ? s : o.preview), _ = Ir(e.timeGrid ? m.filter(jr) : m, t), f = _.reduce((h, w) => Math.max(h, w.lane + 1), 0), p = { gridTemplateColumns: `repeat(${a}, minmax(0, 1fr))` }, [y, d] = A(Ia);
  U(() => {
    const h = window.setInterval(() => d(Ia()), 6e4);
    return () => window.clearInterval(h);
  }, []);
  const b = B(null), N = t.includes(e.today);
  $e(() => {
    const h = b.current;
    if (!h) return;
    const w = N ? Math.max(0, Math.floor((y - _e(e.today)) / 60) - 1) : e.scrollToHour;
    h.scrollTop = w * Ye;
  }, [t[0], a]);
  const $ = (h, w) => {
    if (h.button !== 0 || !e.onCreate) return;
    h.preventDefault();
    const E = h.currentTarget, D = Math.min(Se - r, Math.floor(Kn(h.clientY, E) / r) * r);
    let C = D;
    i({ day: w, a: D, b: D + r }), Sn(h, {
      move: (T) => {
        C = Math.min(Se - r, Math.floor(Kn(T.clientY, E) / r) * r), i({ day: w, a: Math.min(D, C), b: Math.max(D, C) + r });
      },
      end: (T, M) => {
        var Y;
        i(null);
        const R = _e(w), q = M ? Math.min(D, C) : D, F = M ? Math.max(D, C) + r : Math.min(D + 60, Se);
        (Y = e.onCreate) == null || Y.call(e, { start: on(R + q), end: on(R + F), allDay: !1 });
      },
      cancel: () => i(null)
    });
  }, g = (h, w, E) => {
    if (h.stopPropagation(), h.button !== 0 || !sn(e, w.ev)) return;
    const D = (M, R) => {
      const q = xn(M, R, "data-cal-col");
      return q ? _e(q.dataset.calCol) + Kn(R, q) : null;
    }, C = D(h.clientX, h.clientY);
    if (C == null) return;
    u.current = !1;
    let T = null;
    Sn(h, {
      move: (M) => {
        u.current = !0;
        const R = D(M.clientX, M.clientY);
        if (R != null) {
          if (E === "move") {
            const q = ja(R - C, r);
            T = q ? oa(w, q) : null;
          } else {
            const q = Math.max(w.s + r, ja(R, r));
            T = q !== w.e ? { start: w.ev.start, end: on(q) } : null;
          }
          l(T ? { id: w.ev.id, ...T } : null);
        }
      },
      end: (M, R) => {
        var q;
        l(null), R && T && ((q = e.onEventChange) == null || q.call(e, w.ev, T));
      },
      cancel: () => l(null)
    });
  }, x = (h, w) => {
    var E;
    if (u.current) {
      u.current = !1;
      return;
    }
    (E = e.onEventClick) == null || E.call(e, w, h);
  };
  return /* @__PURE__ */ n.createElement("div", { className: S.time }, /* @__PURE__ */ n.createElement("div", { className: S.tHead }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }), /* @__PURE__ */ n.createElement("div", { className: S.tHeadDays, style: p }, t.map((h) => {
    const w = de(h), E = je(w), D = e.holidays[h];
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        className: [S.tDay, h === e.today ? S.isToday : "", E === 0 || D ? S.sun : E === 6 ? S.sat : ""].join(" ")
      },
      /* @__PURE__ */ n.createElement("button", { type: "button", className: S.tDayBtn, onClick: () => e.goto("day", h), "aria-label": e.L.openDay(h) }, /* @__PURE__ */ n.createElement("span", { className: S.tWd }, e.L.weekdays[E]), /* @__PURE__ */ n.createElement("span", { className: S.tDayNum }, w.d)),
      D && /* @__PURE__ */ n.createElement("span", { className: S.holiday, title: D }, D)
    );
  }))), /* @__PURE__ */ n.createElement("div", { className: [S.tAllDay, e.timeGrid ? "" : S.tAllDayOnly].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: S.gutter }, e.timeGrid ? e.L.allDay : ""), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: S.tAllDayRow,
      style: e.timeGrid ? { height: Math.max(1, f) * _n + 6 } : { minHeight: Math.max(1, f) * _n + 6 }
    },
    /* @__PURE__ */ n.createElement("div", { className: S.tAllDayCells, style: p }, t.map((h) => /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-day": h,
        className: [S.allDayCell, o.inSel(h) ? S.selDay : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (w) => o.onCellDown(w, h)
      }
    ))),
    /* @__PURE__ */ n.createElement(zr, { segs: _, cols: a, top: 3, ctx: e, drag: o })
  )), e.timeGrid && /* @__PURE__ */ n.createElement("div", { className: S.tBody, ref: b }, /* @__PURE__ */ n.createElement("div", { className: S.tGrid, style: { height: 24 * Ye } }, /* @__PURE__ */ n.createElement("div", { className: S.tGutter, "aria-hidden": !0 }, mf.map((h) => /* @__PURE__ */ n.createElement("span", { key: h, style: { top: h * Ye } }, Je(h * 60)))), /* @__PURE__ */ n.createElement("div", { className: S.tCols, style: { ...p, backgroundSize: `100% ${Ye}px` } }, t.map((h) => {
    const w = $m(m, h);
    return /* @__PURE__ */ n.createElement(
      "div",
      {
        key: h,
        "data-cal-col": h,
        className: [S.tCol, h === e.today ? S.isToday : "", e.onCreate ? S.creatable : ""].join(" "),
        onPointerDown: (E) => $(E, h)
      },
      (c == null ? void 0 : c.day) === h && /* @__PURE__ */ n.createElement("div", { className: S.tSel, style: { top: c.a / 60 * Ye, height: (c.b - c.a) / 60 * Ye } }, Je(c.a), " – ", c.b === Se ? "24:00" : Je(c.b)),
      w.map((E) => {
        const D = E.item.ev, C = (E.bottom - E.top) / 60 * Ye, T = [
          S.tEv,
          In(D),
          C < 34 ? S.tEvShort : "",
          E.contTop ? S.contTop : "",
          E.contBottom ? S.contBottom : "",
          (s == null ? void 0 : s.id) === D.id ? S.ghost : "",
          sn(e, D) ? S.movable : ""
        ].filter(Boolean).join(" ");
        return /* @__PURE__ */ n.createElement(
          "button",
          {
            key: D.id,
            type: "button",
            className: T,
            style: {
              top: E.top / 60 * Ye,
              height: Math.max(18, C - 1),
              left: `calc(${E.col / E.cols * 100}% + 1px)`,
              width: `calc(${100 / E.cols}% - 4px)`,
              ...On(D)
            },
            "aria-label": Pr(E.item, e.L),
            onPointerDown: (M) => g(M, E.item, "move"),
            onClick: (M) => x(M.currentTarget, D)
          },
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTitle }, D.title),
          /* @__PURE__ */ n.createElement("span", { className: S.tEvTime }, ga(E.item, e.L.allDay)),
          sn(e, D) && !E.contBottom && /* @__PURE__ */ n.createElement("span", { className: S.resize, "aria-hidden": !0, onPointerDown: (M) => g(M, E.item, "resize") })
        );
      }),
      h === e.today && /* @__PURE__ */ n.createElement("div", { className: S.now, style: { top: (y - _e(h)) / 60 * Ye }, "aria-hidden": !0 })
    );
  })))));
}
function Pa(e, t, a) {
  return e.sDay === e.eDay ? ga(e, a) : e.allDay ? a : t === e.sDay ? `${Je(e.s - _e(t))} ~` : t === e.eDay ? `~ ${Je(e.e - _e(t))}` : a;
}
function df({ ctx: e }) {
  const { L: t } = e, { from: a, to: r } = ha("agenda", e.cursor, e.weekStartsOn), o = jn(e.events, a, r), s = Rn(a, r).filter((l) => e.showWeekends || !fn(l)).map((l) => {
    const c = _e(l), i = (m) => Pa(m, l, "") === "" ? -1 : Math.max(m.s, c), u = o.filter((m) => m.sDay <= l && m.eDay >= l);
    return { day: l, list: u.sort((m, _) => i(m) - i(_)) };
  }).filter((l) => l.list.length > 0);
  return s.length ? /* @__PURE__ */ n.createElement("div", { className: S.agenda }, s.map(({ day: l, list: c }) => {
    const i = de(l), u = e.holidays[l], m = je(i), _ = t.weekdays[m];
    return /* @__PURE__ */ n.createElement("section", { key: l, className: [S.aDay, l === e.today ? S.isToday : ""].join(" "), "aria-label": t.dayAria(l) }, /* @__PURE__ */ n.createElement("div", { className: [S.aDate, m === 0 || u ? S.sun : m === 6 ? S.sat : ""].join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.aDateBtn, onClick: () => e.goto("day", l) }, /* @__PURE__ */ n.createElement("span", { className: S.aDayNum }, i.d), /* @__PURE__ */ n.createElement("span", { className: S.aDayWd }, t.m(l), " · ", _)), u && /* @__PURE__ */ n.createElement("span", { className: S.holiday }, u)), /* @__PURE__ */ n.createElement("ul", { className: S.aList }, c.map((f) => {
      const p = f.ev, y = Gt(f.sDay, f.eDay) + 1;
      return /* @__PURE__ */ n.createElement("li", { key: p.id }, /* @__PURE__ */ n.createElement(
        "button",
        {
          type: "button",
          className: [S.aRow, In(p)].join(" "),
          style: On(p),
          onClick: (d) => {
            var b;
            return (b = e.onEventClick) == null ? void 0 : b.call(e, p, d.currentTarget);
          }
        },
        /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
        /* @__PURE__ */ n.createElement("span", { className: S.aTime }, Pa(f, l, t.allDay)),
        /* @__PURE__ */ n.createElement("span", { className: S.aTitle }, p.title, y > 1 && /* @__PURE__ */ n.createElement("em", { className: S.aSpan }, t.dayOfSpan(Gt(f.sDay, l) + 1, y))),
        p.location && /* @__PURE__ */ n.createElement("span", { className: S.aLoc }, p.location)
      ));
    })));
  })) : /* @__PURE__ */ n.createElement("div", { className: S.empty }, t.empty);
}
const Un = { KeyM: "month", KeyW: "week", KeyD: "day", KeyA: "agenda" };
function Xa(e, t, a) {
  const [r, o] = A(t), s = e !== void 0 ? e : r;
  return [s, (c) => {
    e === void 0 && o(c), c !== s && (a == null || a(c));
  }];
}
const za = ({ dir: e }) => /* @__PURE__ */ n.createElement("svg", { width: "15", height: "15", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": !0 }, /* @__PURE__ */ n.createElement("path", { d: e === "l" ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7" }));
function $0({
  events: e,
  view: t,
  defaultView: a,
  onViewChange: r,
  date: o,
  defaultDate: s,
  onDateChange: l,
  views: c = ["month", "week", "day", "agenda"],
  weekStartsOn: i = 0,
  defaultShowWeekends: u = !0,
  weekendToggle: m = !0,
  holidays: _,
  slotMinutes: f = 30,
  scrollToHour: p = 8,
  timeGrid: y = !0,
  onRangeChange: d,
  onEventClick: b,
  onCreate: N,
  onEventChange: $,
  locale: g = Or,
  loading: x,
  headerExtra: h,
  className: w = "",
  style: E,
  "aria-label": D
}) {
  var G;
  const C = qr(), [T, M] = Xa(t, (G = a != null ? a : c[0]) != null ? G : "month", r), [R, q] = Xa(o, s != null ? s : C, l), F = de(R) ? R : C, [Y, W] = A(u), [j, ne] = A(null), te = B(null), v = B(!1);
  U(() => {
    var H;
    if (!v.current) return;
    v.current = !1;
    const z = te.current;
    !z || z.contains(document.activeElement) || ((H = z.querySelector('[data-cal-day][tabindex="0"]')) != null ? H : z).focus();
  });
  const { from: P, to: V } = ha(T, F, i), Q = B(d);
  Q.current = d, U(() => {
    var z;
    (z = Q.current) == null || z.call(Q, { from: P, to: V, view: T });
  }, [P, V, T]);
  const se = (z, H) => {
    q(H), c.includes(z) && M(z);
  }, L = {
    events: e,
    L: g,
    cursor: F,
    today: C,
    weekStartsOn: i,
    showWeekends: Y,
    holidays: _ != null ? _ : {},
    slotMinutes: f,
    scrollToHour: p,
    timeGrid: y,
    setCursor: q,
    goto: se,
    openMore: (z, H) => ne({ day: z, anchor: H }),
    onEventClick: b,
    onCreate: N,
    onEventChange: $
  }, Z = (z) => q(vm(T, F, z, T === "day" && !Y)), I = (z) => {
    if (z.defaultPrevented || z.ctrlKey || z.metaKey || z.altKey || z.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const H = z.nativeEvent.code;
    if (H === "KeyT") q(C);
    else if (H === "KeyN" || H === "KeyJ" || z.key === "PageDown") Z(1);
    else if (H === "KeyP" || H === "KeyK" || z.key === "PageUp") Z(-1);
    else if (Un[H] && c.includes(Un[H])) M(Un[H]);
    else if (H === "KeyC" && N)
      N(T === "month" || T === "agenda" ? { start: F, end: F, allDay: !0 } : { start: `${F}T09:00`, end: `${F}T10:00`, allDay: !1 });
    else return;
    z.preventDefault(), v.current = !0;
  }, X = ke(
    () => Rn(P, V).filter((z) => Y || !fn(z)),
    [P, V, Y]
  );
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [S.cal, w].filter(Boolean).join(" "),
      style: E,
      role: "region",
      "aria-label": D != null ? D : g.region,
      "aria-busy": x || void 0,
      "aria-keyshortcuts": "T N P M W D A C",
      onKeyDown: I,
      ref: te,
      tabIndex: -1
    },
    /* @__PURE__ */ n.createElement("div", { className: S.toolbar }, /* @__PURE__ */ n.createElement(et, { onClick: () => q(C), title: `${g.today} (T)` }, g.today), /* @__PURE__ */ n.createElement("span", { className: S.navBtns }, /* @__PURE__ */ n.createElement(na, { label: g.prev(T), onClick: () => Z(-1) }, /* @__PURE__ */ n.createElement(za, { dir: "l" })), /* @__PURE__ */ n.createElement(na, { label: g.next(T), onClick: () => Z(1) }, /* @__PURE__ */ n.createElement(za, { dir: "r" }))), /* @__PURE__ */ n.createElement("h2", { className: S.title, "aria-live": "polite" }, km(T, F, i, g)), /* @__PURE__ */ n.createElement("span", { className: S.toolRight }, h, m && T !== "day" && /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: S.toggle,
        "aria-pressed": !Y,
        onClick: () => W((z) => !z)
      },
      g.hideWeekends
    ), c.length > 1 && /* @__PURE__ */ n.createElement(
      kr,
      {
        variant: "segmented",
        "aria-label": g.viewTabs,
        items: c.map((z) => ({ key: z, label: g.views[z] })),
        value: T,
        onChange: (z) => M(z)
      }
    ))),
    /* @__PURE__ */ n.createElement("div", { className: S.body }, x && /* @__PURE__ */ n.createElement("div", { className: S.busy, role: "progressbar", "aria-label": g.loading }), T === "month" && /* @__PURE__ */ n.createElement(uf, { ctx: L }), T === "week" && /* @__PURE__ */ n.createElement(Oa, { ctx: L, days: X }), T === "day" && /* @__PURE__ */ n.createElement(Oa, { ctx: L, days: [F] }), T === "agenda" && /* @__PURE__ */ n.createElement(df, { ctx: L })),
    j && /* @__PURE__ */ n.createElement(ff, { ctx: L, day: j.day, anchor: j.anchor, onClose: () => ne(null) })
  );
}
function ff({ ctx: e, day: t, anchor: a, onClose: r }) {
  const o = B(null), [s, l] = A({ top: -9999, left: -9999 }), c = de(t), i = jn(e.events, t, t);
  return $e(() => {
    var p;
    const u = o.current;
    if (!u) return;
    const m = a.getBoundingClientRect(), _ = u.offsetWidth, f = u.offsetHeight;
    l({
      left: Math.max(8, Math.min(m.left + m.width / 2 - _ / 2, window.innerWidth - _ - 8)),
      top: Math.max(8, Math.min(m.top - 60, window.innerHeight - f - 8))
    }), (p = u.querySelector("[data-cal-pop-item]")) == null || p.focus();
  }, [a]), U(() => {
    const u = () => {
      r(), a.isConnected && a.focus();
    }, m = (f) => {
      var p;
      (p = o.current) != null && p.contains(f.target) || r();
    }, _ = (f) => {
      f.key !== "Escape" || f.isComposing || (f.preventDefault(), f.stopPropagation(), u());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", _, !0);
    };
  }, [a, r]), /* @__PURE__ */ n.createElement(Vt, null, /* @__PURE__ */ n.createElement("div", { ref: o, className: S.pop, style: s, role: "dialog", "aria-label": `${e.L.md(t)} ${e.L.eventCount(i.length)}` }, /* @__PURE__ */ n.createElement("div", { className: S.popHead }, /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popDay, onClick: () => {
    r(), e.goto("day", t);
  } }, /* @__PURE__ */ n.createElement("span", null, e.L.weekdays[je(c)]), /* @__PURE__ */ n.createElement("b", null, c.d)), /* @__PURE__ */ n.createElement("button", { type: "button", className: S.popClose, "aria-label": e.L.close, onClick: r }, "✕")), /* @__PURE__ */ n.createElement("ul", { className: S.popList }, i.map((u) => {
    const m = u.ev, _ = u.allDay || u.sDay !== u.eDay;
    return /* @__PURE__ */ n.createElement("li", { key: m.id }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-cal-pop-item": !0,
        className: [S.popItem, _ ? S.bar : S.dotChip, In(m)].join(" "),
        style: On(m),
        onClick: () => {
          var f;
          r(), (f = e.onEventClick) == null || f.call(e, m, a);
        }
      },
      !_ && /* @__PURE__ */ n.createElement("i", { className: S.dot, "aria-hidden": !0 }),
      !u.allDay && /* @__PURE__ */ n.createElement("span", { className: S.chipTime }, Je(Math.max(u.s, _e(t)) - _e(t))),
      /* @__PURE__ */ n.createElement("span", { className: S.chipTitle }, m.title)
    ));
  }))));
}
const _f = "_mini_q7p5n_3", pf = "_nav_q7p5n_5", yf = "_navBtn_q7p5n_6", bf = "_todayBtn_q7p5n_6", Ef = "_title_q7p5n_6", hf = "_day_q7p5n_25", gf = "_mon_q7p5n_25", vf = "_grid_q7p5n_29", kf = "_wdRow_q7p5n_30", wf = "_row_q7p5n_30", Nf = "_sun_q7p5n_35", $f = "_sat_q7p5n_36", xf = "_num_q7p5n_45", Df = "_sel_q7p5n_46", Af = "_out_q7p5n_50", Cf = "_isToday_q7p5n_52", Sf = "_dots_q7p5n_55", Mf = "_months_q7p5n_59", le = {
  mini: _f,
  nav: pf,
  navBtn: yf,
  todayBtn: bf,
  title: Ef,
  day: hf,
  mon: gf,
  grid: vf,
  wdRow: kf,
  row: wf,
  sun: Nf,
  sat: $f,
  num: xf,
  sel: Df,
  out: Af,
  isToday: Cf,
  dots: Sf,
  months: Mf
}, Fa = (e, t) => `${String(e).padStart(4, "0")}-${String(t).padStart(2, "0")}`;
function x0({
  month: e,
  onMonthChange: t,
  value: a,
  onPick: r,
  marks: o = {},
  markLabel: s,
  holidays: l = {},
  weekStartsOn: c = 0,
  locale: i = Or,
  today: u,
  children: m,
  className: _ = "",
  "aria-label": f
}) {
  const p = u != null ? u : qr(), y = /^\d{4}-\d{2}$/.test(e) ? `${e}-01` : `${p.slice(0, 7)}-01`, d = de(y), b = Cn(y, c), N = Rn(b, ve(b, 41)), $ = s != null ? s : i.eventCount, [g, x] = A("day"), [h, w] = A(d.y), E = (W) => !!W && W.slice(0, 7) === y.slice(0, 7), [D, C] = A(() => E(a) ? a : E(p) ? p : y);
  U(() => {
    E(D) || C(E(a) ? a : E(p) ? p : y);
  }, [y]);
  const T = B(!1), M = B(null);
  U(() => {
    var W, j;
    T.current && (T.current = !1, (j = (W = M.current) == null ? void 0 : W.querySelector(`[data-day="${D}"]`)) == null || j.focus());
  }, [D, y]);
  const R = (W) => {
    T.current = !0, C(W), E(W) || t(W.slice(0, 7));
  }, q = (W) => {
    const j = kt(d, W);
    t(Fa(j.y, j.m));
  }, F = (W, j) => {
    const ne = de(j), te = (je(ne) - c + 7) % 7;
    let v = null;
    if (W.key === "ArrowLeft") v = ve(j, -1);
    else if (W.key === "ArrowRight") v = ve(j, 1);
    else if (W.key === "ArrowUp") v = ve(j, -7);
    else if (W.key === "ArrowDown") v = ve(j, 7);
    else if (W.key === "Home") v = ve(j, -te);
    else if (W.key === "End") v = ve(j, 6 - te);
    else if (W.key === "PageUp" || W.key === "PageDown") {
      const P = kt(ne, W.key === "PageUp" ? -1 : 1);
      v = tt(P.y, P.m, P.d);
    }
    v && (W.preventDefault(), R(v));
  }, Y = () => {
    w(d.y), x("month");
  };
  return /* @__PURE__ */ n.createElement("div", { className: [le.mini, _].filter(Boolean).join(" "), role: f ? "group" : void 0, "aria-label": f }, g === "day" ? /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevMonth, onClick: () => q(-1) }, "‹"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.title, "aria-label": `${i.ym(y)}, ${i.pickMonth}`, "aria-live": "polite", onClick: Y }, i.ym(y)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextMonth, onClick: () => q(1) }, "›"), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: le.todayBtn,
      disabled: E(p),
      onClick: () => {
        t(p.slice(0, 7)), R(p);
      }
    },
    i.today
  )) : /* @__PURE__ */ n.createElement("div", { className: le.nav }, /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.prevYear, onClick: () => w((W) => W - 1) }, "‹"), /* @__PURE__ */ n.createElement("span", { className: le.title, "aria-live": "polite" }, i.year(`${h}-12-31`)), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.navBtn, "aria-label": i.nextYear, onClick: () => w((W) => W + 1) }, "›"), /* @__PURE__ */ n.createElement("button", { type: "button", className: le.todayBtn, onClick: () => x("day"), "aria-label": i.close }, "✕")), g === "month" ? /* @__PURE__ */ n.createElement("div", { className: le.months, onKeyDown: (W) => {
    W.key === "Escape" && (W.preventDefault(), x("day"));
  } }, Array.from({ length: 12 }, (W, j) => {
    const ne = Fa(h, j + 1), te = ne === y.slice(0, 7);
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: ne,
        type: "button",
        className: [le.mon, te ? le.sel : "", ne === p.slice(0, 7) ? le.isToday : ""].filter(Boolean).join(" "),
        "aria-pressed": te,
        autoFocus: te,
        onClick: () => {
          t(ne), x("day");
        }
      },
      i.m(`${ne}-01`)
    );
  })) : /* @__PURE__ */ n.createElement("div", { className: le.grid, role: "grid", "aria-label": i.ym(y), ref: M }, /* @__PURE__ */ n.createElement("div", { className: le.wdRow, role: "row" }, N.slice(0, 7).map((W) => {
    const j = je(de(W));
    return /* @__PURE__ */ n.createElement("span", { key: W, role: "columnheader", className: j === 0 ? le.sun : j === 6 ? le.sat : "" }, i.weekdays[j]);
  })), [0, 1, 2, 3, 4, 5].map((W) => /* @__PURE__ */ n.createElement("div", { key: W, className: le.row, role: "row" }, N.slice(W * 7, W * 7 + 7).map((j) => {
    var V;
    const ne = je(de(j)), te = l[j], v = (V = o[j]) != null ? V : 0, P = [
      le.day,
      E(j) ? "" : le.out,
      ne === 0 || te ? le.sun : ne === 6 ? le.sat : "",
      j === p ? le.isToday : "",
      j === a ? le.sel : ""
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: j,
        type: "button",
        role: "gridcell",
        "data-day": j,
        className: P,
        tabIndex: j === D ? 0 : -1,
        "aria-selected": j === a,
        "aria-current": j === p ? "date" : void 0,
        "aria-label": [i.dayAria(j), te, v ? $(v) : ""].filter(Boolean).join(", "),
        onKeyDown: (Q) => F(Q, j),
        onFocus: () => C(j),
        onClick: () => r(j)
      },
      /* @__PURE__ */ n.createElement("span", { className: le.num }, +j.slice(8)),
      /* @__PURE__ */ n.createElement("span", { className: le.dots, "aria-hidden": !0 }, Array.from({ length: Math.min(v, 3) }, (Q, se) => /* @__PURE__ */ n.createElement("i", { key: se })))
    );
  })))), m);
}
function Tf(e) {
  const t = e.match(/\d/g);
  return t ? t.length : 0;
}
function D0({
  value: e,
  onChangeAm: t,
  allowNegative: a = !0,
  onReject: r,
  unit: o,
  className: s,
  ...l
}) {
  const c = B(null), i = B(null), [u, m] = A(!1), _ = e == null || e === "";
  $e(() => {
    const p = c.current, y = i.current;
    if (i.current = null, !p || y === null) return;
    let d = 0, b = 0;
    for (; d < p.value.length && b < y; )
      /\d/.test(p.value[d]) && (b += 1), d += 1;
    d === 0 && p.value[0] === "-" && (d = 1), p.setSelectionRange(d, d);
  });
  const f = /* @__PURE__ */ n.createElement(
    "input",
    {
      ...l,
      ref: c,
      type: "text",
      inputMode: "numeric",
      className: s,
      value: u && _ ? "-" : uo(e),
      onChange: (p) => {
        var b;
        const y = p.target;
        i.current = Tf(y.value.slice(0, (b = y.selectionStart) != null ? b : y.value.length));
        const d = co(y.value, a);
        if (r) {
          const N = Er(y.value);
          !a && /^\s*-/.test(N) ? r("sign") : (/\.\d/.test(N.replace(/^\s*-/, "")) || /\.$/.test(N)) && r("decimal");
        }
        m(d === "-"), t({ text: d, num: io(d) });
      }
    }
  );
  return o ? /* @__PURE__ */ n.createElement(n.Fragment, null, f, /* @__PURE__ */ n.createElement("span", { className: "axe-money-unit", style: { marginLeft: 6, fontSize: 12, color: "#334155", whiteSpace: "nowrap" } }, o)) : f;
}
function sa(e) {
  const t = Er(e).replace(/,/g, "").trim();
  if (t === "") return null;
  const a = Number(t);
  return Number.isFinite(a) ? a : null;
}
function Wa(e, t) {
  const a = sa(e), r = sa(t);
  return a == null || r == null ? null : Math.round(a * r);
}
function A0(e, t) {
  var s, l;
  const a = Wa(e.qty, e.unitAm), r = Wa((s = t.qty) != null ? s : e.qty, (l = t.unitAm) != null ? l : e.unitAm);
  if (r == null) return t;
  const o = sa(e.lineAm);
  return o == null || o === a ? { ...t, lineAm: String(r) } : t;
}
const qf = "_box_qzg36_3", Bf = "_banner_qzg36_9", Lf = "_verify_qzg36_10", jf = "_t_info_qzg36_15", Rf = "_t_warn_qzg36_16", If = "_t_danger_qzg36_17", Of = "_error_qzg36_22", Pf = "_note_qzg36_30", Xf = "_noteI_qzg36_42", zf = "_noteBody_qzg36_43", Ff = "_badge_qzg36_49", Wf = "_b_muted_qzg36_53", Hf = "_b_ok_qzg36_54", Kf = "_b_warn_qzg36_55", Uf = "_b_info_qzg36_56", Gf = "_b_off_qzg36_57", Xe = {
  box: qf,
  banner: Bf,
  verify: Lf,
  t_info: jf,
  t_warn: Rf,
  t_danger: If,
  error: Of,
  note: Pf,
  noteI: Xf,
  noteBody: zf,
  badge: Ff,
  b_muted: Wf,
  b_ok: Hf,
  b_warn: Kf,
  b_info: Uf,
  b_off: Gf
};
function Yf({ tone: e = "warn", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.banner, Xe[`t_${e}`], t].filter(Boolean).join(" ") }, a);
}
function C0({ tone: e = "ok", className: t = "", children: a }) {
  const r = e === "ok" ? "info" : e === "bad" ? "danger" : "warn";
  return /* @__PURE__ */ n.createElement("div", { className: [Xe.box, Xe.verify, Xe[`t_${r}`], t].filter(Boolean).join(" ") }, a);
}
function Fr({ className: e = "", children: t }) {
  return t == null || t === !1 || t === "" ? null : /* @__PURE__ */ n.createElement("p", { className: [Xe.error, e].filter(Boolean).join(" "), role: "alert" }, typeof t == "string" ? /* @__PURE__ */ n.createElement(Vf, { text: t }) : t);
}
function S0({ label: e = "안내", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("details", { className: [Xe.note, t].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("summary", null, /* @__PURE__ */ n.createElement("span", { className: Xe.noteI, "aria-hidden": "true" }, "ⓘ"), e), /* @__PURE__ */ n.createElement("div", { className: Xe.noteBody }, a));
}
function Ha({ tone: e = "muted", className: t = "", children: a }) {
  return /* @__PURE__ */ n.createElement("span", { className: ["axe-badge", Xe.badge, Xe[`b_${e}`], t].filter(Boolean).join(" ") }, a);
}
function Vf({ text: e }) {
  return e ? /* @__PURE__ */ n.createElement(n.Fragment, null, e.split(/\*\*(.+?)\*\*/g).map((t, a) => a % 2 ? /* @__PURE__ */ n.createElement("b", { key: a }, t) : /* @__PURE__ */ n.createElement(so, { key: a }, t))) : null;
}
const Qf = "저장하지 않은 변경이 있습니다. 버리고 이동할까요?";
function Jf(e, t = Qf) {
  const a = B(e);
  return a.current = e, U(() => {
    if (!e) return;
    const r = (o) => {
      o.preventDefault(), o.returnValue = "";
    };
    return window.addEventListener("beforeunload", r), () => window.removeEventListener("beforeunload", r);
  }, [e]), re(() => !a.current || window.confirm(t), [t]);
}
const Zf = "_overlay_1s8aj_2", e_ = "_modal_1s8aj_8", t_ = "_wide_1s8aj_15", n_ = "_head_1s8aj_16", a_ = "_title_1s8aj_20", r_ = "_close_1s8aj_21", o_ = "_body_1s8aj_25", s_ = "_flush_1s8aj_26", l_ = "_error_1s8aj_27", c_ = "_foot_1s8aj_29", i_ = "_overlayTop_1s8aj_35", Oe = {
  overlay: Zf,
  modal: e_,
  wide: t_,
  head: n_,
  title: a_,
  close: r_,
  body: o_,
  flush: s_,
  error: l_,
  foot: c_,
  overlayTop: i_
}, Tt = [];
function Ka(e) {
  const t = Tt[Tt.length - 1];
  e.key !== "Escape" || e.defaultPrevented || e.isComposing || !t || !t.esc || (e.preventDefault(), t.close());
}
const u_ = 'a[href],button:not(:disabled),input:not(:disabled):not([type=hidden]),select:not(:disabled),textarea:not(:disabled),[tabindex]:not([tabindex="-1"])';
function Ua(e) {
  return Array.from(e.querySelectorAll(u_)).filter((t) => t.getClientRects().length > 0 && getComputedStyle(t).visibility !== "hidden");
}
let Ga = 0, Ya = "";
function Pn({
  title: e,
  onClose: t,
  children: a,
  wide: r,
  footer: o,
  headerExtra: s,
  flush: l,
  closeOnBackdrop: c = !0,
  closeOnEsc: i = !1,
  error: u,
  confirmDiscard: m = !0,
  layer: _
}) {
  const [f, p] = A(!1), y = m ? () => {
    f || p(!0);
  } : void 0, d = Jf(m && f, "입력한 내용을 저장하지 않고 닫을까요?"), b = () => {
    d() && t();
  }, N = B(b);
  N.current = b;
  const $ = B({ close: () => N.current(), esc: i });
  $.current.esc = i, U(() => {
    const E = $.current;
    return Tt.push(E), Tt.length === 1 && window.addEventListener("keydown", Ka), () => {
      const D = Tt.lastIndexOf(E);
      D >= 0 && Tt.splice(D, 1), Tt.length === 0 && window.removeEventListener("keydown", Ka);
    };
  }, []);
  const g = B(null), x = B(null), h = B(void 0);
  h.current === void 0 && (h.current = typeof document == "undefined" ? null : document.activeElement), U(() => {
    var C;
    const E = g.current, D = (C = h.current) != null ? C : null;
    return E && !E.contains(document.activeElement) && (x.current && Ua(x.current)[0] || null || E).focus(), Ga++ === 0 && (Ya = document.body.style.overflow, document.body.style.overflow = "hidden"), () => {
      --Ga === 0 && (document.body.style.overflow = Ya), D && D.isConnected && typeof D.focus == "function" && D.focus();
    };
  }, []);
  const w = (E) => {
    const D = g.current;
    if (E.key !== "Tab" || !D || !D.contains(E.target)) return;
    const C = Ua(D);
    if (C.length === 0) {
      E.preventDefault(), D.focus();
      return;
    }
    const T = C[0], M = C[C.length - 1], R = document.activeElement;
    E.shiftKey && (R === T || R === D) ? (E.preventDefault(), M.focus()) : !E.shiftKey && R === M && (E.preventDefault(), T.focus());
  };
  return /* @__PURE__ */ n.createElement("div", { className: _ === "top" ? `${Oe.overlay} ${Oe.overlayTop}` : Oe.overlay, onClick: c ? b : void 0 }, /* @__PURE__ */ n.createElement(
    "div",
    {
      ref: g,
      tabIndex: -1,
      className: [Oe.modal, r ? Oe.wide : ""].filter(Boolean).join(" "),
      role: "dialog",
      "aria-modal": "true",
      "aria-label": e,
      onClick: (E) => E.stopPropagation(),
      onKeyDown: w
    },
    /* @__PURE__ */ n.createElement("header", { className: Oe.head }, /* @__PURE__ */ n.createElement("strong", { className: Oe.title }, e), s, /* @__PURE__ */ n.createElement("button", { type: "button", className: Oe.close, onClick: b, "aria-label": "닫기" }, "✕")),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: x,
        className: [Oe.body, l ? Oe.flush : ""].filter(Boolean).join(" "),
        onInputCapture: y,
        onChangeCapture: y
      },
      a
    ),
    u != null && u !== !1 && u !== "" && /* @__PURE__ */ n.createElement("div", { className: Oe.error }, /* @__PURE__ */ n.createElement(Fr, null, u)),
    o && /* @__PURE__ */ n.createElement("footer", { className: Oe.foot }, o)
  ));
}
function M0(e = 4e3) {
  const [t, a] = A(""), [r, o] = A(!1), s = B(void 0), l = re((u) => {
    window.clearTimeout(s.current), o(!1), a(u), s.current = window.setTimeout(() => a(""), e);
  }, [e]), c = re((u) => {
    window.clearTimeout(s.current), o(!0), a(u);
  }, []), i = re(() => {
    window.clearTimeout(s.current), o(!1), a("");
  }, []);
  return [t, l, c, r, i];
}
const m_ = "_message_psco6_1", d_ = "_details_psco6_2", f_ = "_warn_psco6_7", __ = "_field_psco6_8", gn = {
  message: m_,
  details: d_,
  warn: f_,
  field: __
};
function T0() {
  var p, y;
  const [e, t] = A(null), [a, r] = A(""), o = B(null), s = B(null), l = B(null), c = re((d) => new Promise((b) => {
    t({ kind: "confirm", opts: d, resolve: b });
  }), []), i = re((d) => new Promise((b) => {
    var N, $, g, x;
    r((x = (g = d.defaultValue) != null ? g : ($ = (N = d.choices) == null ? void 0 : N[0]) == null ? void 0 : $.value) != null ? x : ""), t({ kind: "prompt", opts: d, resolve: b });
  }), []);
  U(() => {
    var d, b, N;
    e && (e.kind === "prompt" ? (d = l.current) == null || d.focus() : e.opts.danger || e.opts.focusCancel ? (b = s.current) == null || b.focus() : (N = o.current) == null || N.focus());
  }, [e]);
  const u = (d) => {
    e && (e.kind === "confirm" ? e.resolve(d) : e.resolve(d ? a : null), t(null));
  }, m = e == null ? void 0 : e.opts, _ = (e == null ? void 0 : e.kind) === "prompt" && !!e.opts.required && !a.trim(), f = e && m ? /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: m.title,
      onClose: () => u(!1),
      closeOnBackdrop: !1,
      closeOnEsc: !0,
      confirmDiscard: !1,
      layer: "top",
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { ref: s, onClick: () => u(!1) }, (p = m.cancelLabel) != null ? p : "취소"), /* @__PURE__ */ n.createElement(
        et,
        {
          ref: o,
          variant: m.danger ? "danger" : "primary",
          disabled: _,
          onClick: () => u(!0)
        },
        (y = m.confirmLabel) != null ? y : "확인"
      ))
    },
    m.message && /* @__PURE__ */ n.createElement("div", { className: gn.message }, m.message),
    m.details && m.details.length > 0 && /* @__PURE__ */ n.createElement("ul", { className: gn.details }, m.details.map((d, b) => /* @__PURE__ */ n.createElement("li", { key: b }, d))),
    m.irreversible && /* @__PURE__ */ n.createElement("p", { className: gn.warn }, "이 작업은 되돌릴 수 없습니다."),
    e.kind === "prompt" && /* @__PURE__ */ n.createElement("label", { className: gn.field }, /* @__PURE__ */ n.createElement("span", null, e.opts.label), e.opts.choices ? /* @__PURE__ */ n.createElement("select", { ref: l, value: a, onChange: (d) => r(d.target.value) }, e.opts.choices.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.value, value: d.value }, d.label))) : /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: l,
        value: a,
        placeholder: e.opts.placeholder,
        maxLength: e.opts.maxLength,
        onChange: (d) => r(d.target.value),
        onKeyDown: (d) => {
          d.key === "Enter" && !_ && (d.preventDefault(), u(!0));
        }
      }
    ))
  ) : null;
  return { confirm: c, prompt: i, dialog: f };
}
function q0(e, t) {
  return (t ? `${t}에 실패했습니다 — ` : "") + p_(e);
}
function p_(e) {
  return e === 0 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : e === 400 || e === 422 ? "입력 내용을 처리할 수 없습니다. 입력값을 확인한 뒤 다시 시도하세요" : e === 401 ? "로그인이 만료되었습니다. 다시 로그인하세요" : e === 403 ? "이 작업을 할 권한이 없습니다" : e === 404 ? "대상을 찾을 수 없습니다" : e === 409 ? "다른 사용자가 먼저 수정했습니다. 다시 조회한 뒤 수정하세요" : e === 413 ? "보낸 자료가 너무 큽니다. 크기를 줄여 다시 시도하세요" : e === 429 ? "요청이 너무 많습니다. 잠시 후 다시 시도하세요" : e >= 500 ? "일시적인 문제로 처리하지 못했습니다. 잠시 후 다시 시도하세요" : "요청을 처리하지 못했습니다. 다시 시도하세요";
}
function B0() {
  const [e, t] = A(!1), a = B(!1), r = re(async (o) => {
    if (!a.current) {
      a.current = !0, t(!0);
      try {
        return await o();
      } finally {
        a.current = !1, t(!1);
      }
    }
  }, []);
  return [e, r];
}
function L0(e, t, a, r) {
  const [o, s] = A(null), [l, c] = A(a), [i, u] = A(null), [m, _] = A(!1), [f, p] = A(0), y = B(0), d = B(r);
  d.current = r;
  const b = re(() => p((N) => N + 1), []);
  return U(() => {
    if (!a) return;
    const N = ++y.current;
    return c(!0), e().then(($) => {
      N === y.current && (s($), u(null), _(!1));
    }).catch(($) => {
      var g, x, h;
      N === y.current && (u(d.current.errorText($)), _((h = (x = (g = d.current).isUnavailable) == null ? void 0 : x.call(g, $)) != null ? h : !1));
    }).finally(() => {
      N === y.current && c(!1);
    }), () => {
      y.current++;
    };
  }, [a, f, ...t]), { data: o, loading: l, error: i, unavailable: m, reload: b };
}
function j0(e) {
  const [t, a] = A(null), [r, o] = A(null), [s, l] = A(!1), [c, i] = A(1), u = B(0), m = B(e);
  m.current = e;
  const _ = re(async (p, y) => {
    const d = ++u.current;
    l(!0), o(null);
    try {
      const b = await y(p);
      if (d !== u.current) return;
      a(b), i(p);
    } catch (b) {
      if (d !== u.current) return;
      a(null), o(m.current.errorText(b));
    } finally {
      d === u.current && l(!1);
    }
  }, []), f = re(() => {
    u.current++, a(null), o(null), l(!1);
  }, []);
  return { data: t, err: r, loading: s, page: c, load: _, clear: f };
}
const y_ = "_section_dyrr7_3", b_ = "_row_dyrr7_10", E_ = "_label_dyrr7_15", h_ = "_value_dyrr7_21", g_ = "_invalid_dyrr7_43", v_ = "_help_dyrr7_45", k_ = "_err_dyrr7_45", w_ = "_req_dyrr7_49", N_ = "_opt_dyrr7_50", $_ = "_sr_dyrr7_51", x_ = "_ro_dyrr7_10", D_ = "_readonly_dyrr7_58", A_ = "_hint_dyrr7_65", C_ = "_toggle_dyrr7_73", S_ = "_table_dyrr7_80", M_ = "_isReq_dyrr7_95", Ce = {
  section: y_,
  row: b_,
  label: E_,
  value: h_,
  invalid: g_,
  help: v_,
  err: k_,
  req: w_,
  opt: N_,
  sr: $_,
  ro: x_,
  readonly: D_,
  hint: A_,
  toggle: C_,
  table: S_,
  isReq: M_
};
let T_ = 0;
const q_ = /* @__PURE__ */ new Set(["input", "select", "textarea"]);
function R0({
  label: e,
  children: t,
  hint: a,
  ro: r,
  htmlFor: o,
  required: s,
  optional: l,
  help: c,
  error: i,
  className: u = ""
}) {
  var h, w, E, D;
  const m = B(`axe-fr${++T_}`).current, _ = `${m}-lbl`, f = B(null), p = c ? `${m}-help` : void 0, y = i ? `${m}-err` : void 0, d = [p, y].filter(Boolean).join(" ") || void 0, b = a && a.replace(/\*\*(.+?)\*\*/g, "$1");
  let N = t;
  const $ = ta.count(t) === 1 ? ta.toArray(t)[0] : null, g = un($) && typeof $.type != "string" && !!$.type.axeFormControl;
  if (un($) && (typeof $.type == "string" && q_.has($.type) || g)) {
    const C = $, T = C.props;
    N = fa(C, {
      id: (h = T.id) != null ? h : o,
      "aria-describedby": (w = T["aria-describedby"]) != null ? w : d,
      "aria-invalid": (E = T["aria-invalid"]) != null ? E : i ? !0 : void 0,
      "aria-required": (D = T["aria-required"]) != null ? D : s ? !0 : void 0
    });
  }
  $e(() => {
    var R;
    const C = (R = f.current) == null ? void 0 : R.querySelector("input:not([type=hidden]):not([type=checkbox]):not([type=radio]), select, textarea");
    if (!C) return;
    const T = (q, F) => {
      const Y = `data-fr-${q}`;
      if (F == null) {
        C.hasAttribute(Y) && (C.removeAttribute(q), C.removeAttribute(Y));
        return;
      }
      C.hasAttribute(q) && !C.hasAttribute(Y) || (C.getAttribute(q) !== F && C.setAttribute(q, F), C.setAttribute(Y, ""));
    }, M = !!(C.id && document.querySelector(`label[for="${CSS.escape(C.id)}"]`));
    T("aria-labelledby", M ? null : _), T("aria-invalid", i ? "true" : null), T("aria-required", s ? "true" : null), T("aria-describedby", d != null ? d : null);
  });
  const x = /* @__PURE__ */ n.createElement(n.Fragment, null, e, s && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: Ce.req, "aria-hidden": "true" }, "*"), /* @__PURE__ */ n.createElement("span", { className: Ce.sr }, "필수")), l && /* @__PURE__ */ n.createElement("span", { className: Ce.opt }, "(선택)"));
  return /* @__PURE__ */ n.createElement("div", { className: ["axe-form-row", Ce.row, r ? Ce.ro : "", i ? Ce.invalid : "", s ? Ce.isReq : "", u].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-label ${Ce.label}` }, o ? /* @__PURE__ */ n.createElement("label", { htmlFor: o, id: _ }, x) : /* @__PURE__ */ n.createElement("span", { id: _ }, x), a && /* @__PURE__ */ n.createElement(jt, { content: b, describe: !1 }, /* @__PURE__ */ n.createElement("span", { className: `axe-form-hint ${Ce.hint}`, role: "img", "aria-label": `도움말: ${b}`, tabIndex: 0 }, "?"))), /* @__PURE__ */ n.createElement("span", { ref: f, className: `axe-form-value ${Ce.value}` }, N, c && /* @__PURE__ */ n.createElement("span", { id: p, className: Ce.help }, c), i && /* @__PURE__ */ n.createElement("span", { id: y, className: Ce.err }, i)));
}
function I0({ title: e, children: t, className: a = "", variant: r = "stack" }) {
  return /* @__PURE__ */ n.createElement("section", { className: ["axe-form-section", r === "table" ? `axe-form-table ${Ce.table}` : "", Ce.section, a].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), t);
}
function O0({ children: e }) {
  return /* @__PURE__ */ n.createElement("span", { className: Ce.readonly }, e);
}
function P0({ checked: e, onChange: t, disabled: a, label: r, className: o = "" }) {
  return /* @__PURE__ */ n.createElement("label", { className: [Ce.toggle, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: e, disabled: a, onChange: (s) => t(s.target.checked) }), /* @__PURE__ */ n.createElement("span", null, r));
}
const B_ = "_mono_6omzf_2", L_ = "_invalid_6omzf_3", j_ = "_qty_6omzf_6", R_ = "_qtyInput_6omzf_7", I_ = "_unit_6omzf_8", O_ = "_note_6omzf_9", P_ = "_qtyErr_6omzf_10", gt = {
  mono: B_,
  invalid: L_,
  qty: j_,
  qtyInput: R_,
  unit: I_,
  note: O_,
  qtyErr: P_
};
function X_({
  value: e,
  onChange: t,
  disabled: a,
  maxLength: r,
  placeholder: o,
  mono: s,
  invalid: l,
  multiline: c,
  rows: i = 4,
  label: u,
  id: m,
  "aria-describedby": _,
  "aria-invalid": f,
  "aria-required": p,
  className: y = ""
}) {
  const d = [s ? gt.mono : "", l ? gt.invalid : "", y].filter(Boolean).join(" ") || void 0, b = {
    id: m,
    className: d,
    value: e != null ? e : "",
    maxLength: r,
    placeholder: o,
    disabled: a,
    "aria-label": u,
    "aria-describedby": _,
    "aria-invalid": f != null ? f : l || void 0,
    "aria-required": p,
    onChange: (N) => t(N.target.value === "" ? null : N.target.value)
  };
  return c ? /* @__PURE__ */ n.createElement("textarea", { ...b, rows: i }) : /* @__PURE__ */ n.createElement("input", { type: "text", ...b });
}
X_.axeFormControl = !0;
function z_(e) {
  const {
    value: t,
    options: a,
    allLabel: r,
    disabled: o,
    label: s,
    id: l,
    "aria-describedby": c,
    "aria-invalid": i,
    "aria-required": u,
    className: m,
    title: _,
    style: f,
    onClick: p
  } = e, y = (b) => {
    e.codeType === "string" ? e.onChange(b === "" ? null : b) : e.onChange(b === "" ? null : Number(b));
  }, d = Array.isArray(a) ? a : Object.entries(a);
  return /* @__PURE__ */ n.createElement(
    "select",
    {
      id: l,
      className: m,
      title: _,
      style: f,
      onClick: p,
      value: t == null ? "" : String(t),
      disabled: o,
      "aria-label": s,
      "aria-describedby": c,
      "aria-invalid": i,
      "aria-required": u,
      onChange: (b) => y(b.target.value)
    },
    r != null && /* @__PURE__ */ n.createElement("option", { value: "" }, r),
    d.map(([b, N, $]) => /* @__PURE__ */ n.createElement("option", { key: b, value: String(b), disabled: $ || void 0 }, N))
  );
}
z_.axeFormControl = !0;
function F_(e) {
  return e.replace(/[０-９]/g, (t) => String.fromCharCode(t.charCodeAt(0) - 65248)).replace(/[．。]/g, ".").replace(/[－−ー]/g, "-").replace(/[，、]/g, ",");
}
const W_ = /^-?(\d+\.?\d*|\.\d+)$/;
function tn(e) {
  const t = F_(e).trim().replace(/,/g, "");
  if (t === "") return { kind: "empty" };
  if (t === "-" || t === "." || t === "-.") return { kind: "partial" };
  if (!W_.test(t)) return { kind: "bad" };
  const a = Number(t);
  return Number.isFinite(a) ? { kind: "num", value: a === 0 ? 0 : a } : { kind: "bad" };
}
function Mn(e) {
  if (!Number.isFinite(e)) return 0;
  const t = Math.abs(e).toString(), a = t.indexOf("e-");
  if (a >= 0) {
    const o = t.slice(0, a), s = o.indexOf(".");
    return (s >= 0 ? o.length - s - 1 : 0) + Number(t.slice(a + 2));
  }
  const r = t.indexOf(".");
  return r >= 0 ? t.length - r - 1 : 0;
}
function Wr(e, t) {
  if (!Number.isFinite(e)) return e;
  const a = Math.max(0, Math.floor(t));
  if (Mn(e) <= a) return e;
  const r = e < 0 ? -1 : 1, o = Math.abs(e).toFixed(Math.min(20, Mn(e))), s = Math.round(+`${o}e${a}`), l = r * +`${s}e-${a}`;
  return l === 0 ? 0 : l;
}
function zt(e) {
  return e == null || !Number.isFinite(e) ? "" : String(Number(e.toPrecision(12)));
}
function H_(e, t, a) {
  return t != null && e < t || a != null && e > a;
}
function K_(e, t, a, r, o, s) {
  let l = e == null ? o != null ? o : 0 : Wr(e + a * t, Math.max(r, Mn(t)));
  return o != null && l < o && (l = o), s != null && l > s && (l = s), l;
}
const U_ = 2500;
function G_({
  value: e,
  onChange: t,
  decimals: a = 1,
  min: r,
  max: o,
  step: s,
  unit: l,
  disabled: c,
  label: i,
  id: u,
  "aria-describedby": m,
  "aria-invalid": _,
  "aria-required": f,
  width: p,
  onEnter: y,
  onInvalidChange: d,
  placeholder: b,
  className: N = ""
}) {
  const [$, g] = A(() => zt(e)), [x, h] = A(!1), [w, E] = A(null), [D, C] = A(!1), T = B(null), M = B($);
  M.current = $, U(() => {
    const v = tn(M.current), P = v.kind === "num" ? v.value : v.kind === "empty" ? null : void 0;
    P !== void 0 && P === (e != null ? e : null) || g(zt(e));
  }, [e]), U(() => () => {
    T.current && clearTimeout(T.current);
  }, []);
  const R = tn($), q = R.kind === "bad" || R.kind === "partial";
  U(() => {
    q || C(!1);
  }, [q]);
  const F = B(d);
  F.current = d, U(() => {
    var v;
    (v = F.current) == null || v.call(F, q);
  }, [q]), U(() => () => {
    var v;
    (v = F.current) == null || v.call(F, !1);
  }, []);
  const Y = (v) => {
    T.current && clearTimeout(T.current), E(v), T.current = setTimeout(() => E(null), U_);
  }, W = (v) => {
    g(v);
    const P = tn(v);
    P.kind === "empty" ? t(null) : P.kind === "num" && t(P.value);
  }, j = () => {
    const v = tn($);
    if (v.kind !== "num") return;
    if (Mn(v.value) > a) {
      const V = Wr(v.value, a);
      g(zt(V)), t(V), Y(`반올림했습니다 → ${zt(V)}`);
      return;
    }
    const P = zt(v.value);
    P !== $ && g(P);
  }, ne = (v) => {
    if (!v.nativeEvent.isComposing) {
      if (v.key === "Enter") {
        if (q) {
          C(!0);
          return;
        }
        j(), y == null || y();
        return;
      }
      if (s && (v.key === "ArrowUp" || v.key === "ArrowDown")) {
        v.preventDefault();
        const P = tn($), V = P.kind === "num" ? P.value : P.kind === "empty" ? null : e, Q = K_(V, s, v.key === "ArrowUp" ? 1 : -1, a, r, o);
        g(zt(Q)), t(Q);
      }
    }
  }, te = R.kind === "bad" || R.kind === "partial" && (!x || D) || R.kind === "num" && H_(R.value, r, o);
  return /* @__PURE__ */ n.createElement("span", { className: [gt.qty, N].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      inputMode: "decimal",
      id: u,
      className: [gt.qtyInput, te ? gt.invalid : ""].filter(Boolean).join(" "),
      style: p != null ? { width: p, maxWidth: "none" } : void 0,
      value: $,
      placeholder: b,
      disabled: c,
      "aria-label": i,
      "aria-describedby": m,
      "aria-invalid": _ != null ? _ : te || void 0,
      "aria-required": f,
      onChange: (v) => W(v.target.value),
      onFocus: () => h(!0),
      onBlur: () => {
        h(!1), j();
      },
      onKeyDown: ne
    }
  ), l && /* @__PURE__ */ n.createElement("span", { className: gt.unit }, l), (R.kind === "bad" || R.kind === "partial" && (!x || D)) && /* @__PURE__ */ n.createElement("span", { className: gt.qtyErr, role: "alert" }, "숫자로 입력하세요"), /* @__PURE__ */ n.createElement("span", { className: gt.note, role: "status", "aria-live": "polite" }, w));
}
G_.axeFormControl = !0;
function Y_(e, t) {
  if (e === t || e == null && t == null) return !0;
  if (e == null || t == null) return !1;
  if (typeof e == "object" && typeof t == "object")
    try {
      return JSON.stringify(e) === JSON.stringify(t);
    } catch {
      return !1;
    }
  return typeof e == "number" && typeof t == "number" && Number.isNaN(e) && Number.isNaN(t);
}
function V_(e, t) {
  var o;
  if (e === t) return [];
  if (e === null || t === null) return e === null && t === null ? [] : Object.keys((o = e != null ? e : t) != null ? o : {});
  const a = /* @__PURE__ */ new Set([...Object.keys(e), ...Object.keys(t)]), r = [];
  return a.forEach((s) => {
    Y_(e[s], t[s]) || r.push(s);
  }), r;
}
function Q_(e, t) {
  return e === null || t === null ? e === t : V_(e, t).length === 0;
}
function X0() {
  const [e, t] = A(null), [a, r] = A(!1), [o, s] = A(null), l = ke(() => a || !Q_(o, e), [a, o, e]), c = re((p) => {
    t((y) => y === null ? y : { ...y, ...p });
  }, []), i = re((p, y) => {
    t((d) => d === null ? d : { ...d, [p]: y });
  }, []), u = B(null), m = re((p) => {
    u.current = p, t(p), s(p), r(!1);
  }, []), _ = re((p) => {
    u.current = p, t(p), s(p), r(!0);
  }, []), f = re(() => t(u.current), []);
  return ke(
    () => ({ draft: e, isNew: a, dirty: l, set: i, patch: c, load: m, start: _, reset: f, snapshot: o }),
    [e, a, l, i, c, m, _, f, o]
  );
}
function z0() {
  const e = B(!1), [t, a] = A(!1), r = re(async (o) => {
    if (!e.current) {
      e.current = !0, a(!0);
      try {
        await o();
      } finally {
        e.current = !1, a(!1);
      }
    }
  }, []);
  return [t, r];
}
const J_ = "_panel_1w7xx_2", Z_ = "_band_1w7xx_7", ep = "_chev_1w7xx_11", tp = "_title_1w7xx_17", np = "_note_1w7xx_19", ap = "_chip_1w7xx_21", rp = "_other_1w7xx_32", op = "_reset_1w7xx_33", sp = "_form_1w7xx_42", rt = {
  panel: J_,
  band: Z_,
  chev: ep,
  title: tp,
  note: np,
  chip: ap,
  other: rp,
  reset: op,
  form: sp
};
function F0({
  chips: e,
  onReset: t,
  open: a,
  onToggle: r,
  toggleLabel: o = "상세검색",
  title: s = "적용된 조건",
  note: l,
  children: c,
  hideWhenEmpty: i,
  ariaLabel: u = "상세검색",
  className: m = ""
}) {
  const _ = B(null);
  if (i && !a && e.length === 0) return null;
  const f = (y, d = 0) => {
    var x, h, w;
    const b = (x = document.querySelector(`section[aria-label="${CSS.escape(u)}"]`)) != null ? x : _.current, N = b == null ? void 0 : b.querySelectorAll("button[data-chip-clear]"), $ = (w = N && ((h = N[y]) != null ? h : N[y - 1])) != null ? w : b == null ? void 0 : b.querySelector("button[aria-expanded]"), g = !document.activeElement || document.activeElement === document.body;
    $ && $ !== document.activeElement && (d === 0 || g) && $.focus(), d < 4 && setTimeout(() => f(y, d + 1), 250);
  }, p = (y) => {
    e[y].onClear(), requestAnimationFrame(() => f(y));
  };
  return /* @__PURE__ */ n.createElement("section", { className: [rt.panel, m].filter(Boolean).join(" "), "aria-label": u }, /* @__PURE__ */ n.createElement("div", { className: rt.band, ref: _ }, r && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.chev, "aria-expanded": !!a, onClick: r }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, a ? "⌃" : "⌄"), " ", o), s !== null && /* @__PURE__ */ n.createElement("span", { className: rt.title, "aria-live": "polite" }, s, " ", /* @__PURE__ */ n.createElement("b", null, e.length), "개"), e.map((y, d) => {
    var b;
    return /* @__PURE__ */ n.createElement("span", { key: y.key, className: [rt.chip, y.tone === "other" ? rt.other : ""].filter(Boolean).join(" ") }, y.text, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        "data-chip-clear": !0,
        "aria-label": `${(b = y.label) != null ? b : typeof y.text == "string" ? y.text : "조건"} 해제`,
        onClick: () => p(d)
      },
      "✕"
    ));
  }), t && e.length > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", className: rt.reset, onClick: () => {
    t(), requestAnimationFrame(() => f(0));
  } }, "초기화"), l && /* @__PURE__ */ n.createElement("span", { className: rt.note }, l)), a && c && /* @__PURE__ */ n.createElement("div", { className: rt.form }, c));
}
const lp = "_zone_1y6sp_2", cp = "_drag_1y6sp_8", ip = "_busy_1y6sp_9", up = "_attached_1y6sp_10", mp = "_left_1y6sp_12", dp = "_icon_1y6sp_13", fp = "_title_1y6sp_18", _p = "_desc_1y6sp_19", pp = "_right_1y6sp_20", yp = "_count_1y6sp_21", bp = "_pick_1y6sp_22", Fe = {
  zone: lp,
  drag: cp,
  busy: ip,
  attached: up,
  left: mp,
  icon: dp,
  title: fp,
  desc: _p,
  right: pp,
  count: yp,
  pick: bp
};
function Ep({
  onFiles: e,
  title: t = "파일 업로드",
  desc: a,
  countText: r,
  accept: o,
  multiple: s = !0,
  disabled: l,
  attached: c,
  pickLabel: i = "파일 선택",
  className: u = ""
}) {
  const m = B(null), [_, f] = A(!1), p = (y) => {
    !y || y.length === 0 || l || e(Array.from(y));
  };
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [Fe.zone, _ ? Fe.drag : "", l ? Fe.busy : "", c ? Fe.attached : "", u].filter(Boolean).join(" "),
      onClick: () => {
        var y;
        l || (y = m.current) == null || y.click();
      },
      onDragOver: (y) => {
        y.preventDefault(), l || f(!0);
      },
      onDragLeave: () => f(!1),
      onDrop: (y) => {
        y.preventDefault(), f(!1), p(y.dataTransfer.files);
      }
    },
    /* @__PURE__ */ n.createElement("div", { className: Fe.left }, /* @__PURE__ */ n.createElement("div", { className: Fe.icon, "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("svg", { width: "22", height: "22", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" }, /* @__PURE__ */ n.createElement("polyline", { points: "16 16 12 12 8 16" }), /* @__PURE__ */ n.createElement("line", { x1: "12", y1: "12", x2: "12", y2: "21" }), /* @__PURE__ */ n.createElement("path", { d: "M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" }))), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: Fe.title }, t), a && /* @__PURE__ */ n.createElement("div", { className: Fe.desc }, a))),
    /* @__PURE__ */ n.createElement("div", { className: Fe.right }, r && /* @__PURE__ */ n.createElement("span", { className: Fe.count, "aria-live": "polite" }, r), /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: Fe.pick,
        disabled: l,
        onClick: (y) => {
          var d;
          y.stopPropagation(), (d = m.current) == null || d.click();
        }
      },
      i
    ), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: m,
        type: "file",
        accept: o,
        multiple: s,
        hidden: !0,
        onChange: (y) => {
          p(y.target.files), y.target.value = "";
        }
      }
    ))
  );
}
function hp(e, t) {
  var s, l;
  const a = (s = e.headers.get("Content-Disposition")) != null ? s : "", r = /filename\*=UTF-8''([^;]+)/i.exec(a);
  if (r)
    try {
      return decodeURIComponent(r[1]);
    } catch {
    }
  const o = /filename="?([^";]+)"?/i.exec(a);
  return (l = o == null ? void 0 : o[1]) != null ? l : t;
}
function Hr(e, t) {
  const a = URL.createObjectURL(e), r = document.createElement("a");
  r.href = a, r.download = t, document.body.appendChild(r), r.click(), r.remove(), setTimeout(() => URL.revokeObjectURL(a), 1e3);
}
async function W0(e, t, a) {
  Hr(await e.blob(), a != null ? a : hp(e, t));
}
const gp = /^([△▲\-−]?)\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?$/, vp = /^\(\s*[\u00a5\uffe5]?\s*(\d{1,3}(?:,\d{3})+|\d+)(\.\d+)?\s*\)$/;
function Kr(e, t = {}) {
  var o, s;
  const a = e.trim();
  if (t.parenNegative) {
    const l = vp.exec(a);
    if (l) return `-${l[1].replace(/,/g, "")}${(o = l[2]) != null ? o : ""}`;
  }
  const r = gp.exec(a);
  return r ? (r[1] ? "-" : "") + r[2].replace(/,/g, "") + ((s = r[3]) != null ? s : "") : null;
}
function Kt(e) {
  return e === "-" || e === "+" ? e : /^[=+\-@\t\r]/.test(e) ? `'${e}` : e;
}
function kp(e, t = {}) {
  const a = [];
  t.meta && t.meta.length && (t.meta.forEach((l) => a.push(l.map((c) => kn(Kt(String(c != null ? c : "")))).join(","))), a.push(""));
  const r = a.length;
  let o = null;
  const s = (l) => {
    var i;
    const c = wp(l, e);
    !c || c === o || (o = c, a.length > r && a.push(""), a.push(kn(Kt((i = c.getAttribute("data-csv-title")) != null ? i : ""))));
  };
  return e.querySelectorAll("table, [data-csv-kv]").forEach((l) => {
    var p;
    if (l.tagName !== "TABLE") {
      if ((p = l.parentElement) != null && p.closest("table") && e.contains(l.parentElement.closest("table"))) return;
      const y = Np(l, t);
      if (!y) return;
      s(l), a.push(y.map(kn).join(","));
      return;
    }
    const c = l;
    s(c);
    const i = c.querySelector("[data-tree-depth]"), u = i ? i.closest("td, th") : null, m = u ? u.cellIndex : -1, _ = m >= 0 && !!c.querySelector("[data-csv-path]"), f = [];
    Array.from(c.rows).forEach((y) => {
      if (y.hasAttribute("data-state") || y.getAttribute("aria-hidden") === "true") return;
      const d = [];
      let b = 0;
      const N = () => {
        for (; f[b] && f[b].n > 0; )
          f[b].n -= 1, f[b].skip || d.push(""), b += 1;
      };
      Array.from(y.cells).forEach(($) => {
        var E, D;
        N();
        const g = xp($), x = g ? "" : Dp($, t), h = Math.max(1, $.colSpan || 1), w = Math.max(1, $.rowSpan || 1);
        for (let C = 0; C < h; C += 1)
          g || d.push(C === 0 ? x : ""), f[b] = { n: w - 1, skip: g }, b += 1;
        if (m >= 0 && $.cellIndex === m) {
          const C = $.querySelector("[data-tree-depth]");
          C ? (d.push(String(Number(C.getAttribute("data-tree-depth")) + 1)), _ && d.push(Kt((E = C.getAttribute("data-csv-path")) != null ? E : ""))) : ((D = y.parentElement) == null ? void 0 : D.tagName) === "THEAD" ? (d.push("단계"), _ && d.push("상위 경로")) : (d.push(""), _ && d.push(""));
        }
      }), N(), d.some(($) => $ !== "") && a.push(d.map(kn).join(","));
    });
  }), a.join(`\r
`);
}
function wp(e, t) {
  let a = e.parentElement;
  for (; a; ) {
    if (a.hasAttribute("data-csv-title") && a.getAttribute("data-csv-title")) return a;
    if (a === t) return null;
    a = a.parentElement;
  }
  return null;
}
function Np(e, t) {
  var u, m;
  const a = e.querySelector("[data-csv-k]"), r = e.querySelector("[data-csv-v]"), o = e.querySelector("[data-csv-unit]"), s = o ? vn(o) : "";
  let c = ((u = e.getAttribute("data-csv-kv")) != null ? u : "") || (a ? vn(a) : "");
  if (!c) return null;
  s && (c = `${c} (${s})`);
  let i;
  if (r) {
    const _ = r.cloneNode(!0);
    _.querySelectorAll("[data-csv-unit], [data-csv-skip]").forEach((f) => f.remove()), i = vn(_);
  } else {
    const _ = e.cloneNode(!0);
    _.querySelectorAll("[data-csv-k], [data-csv-unit], [data-csv-skip]").forEach((f) => f.remove()), i = vn(_);
  }
  return (i === "—" || i === "-" || i === "–") && (i = ""), [Kt(c), (m = Kr(i, t)) != null ? m : Kt(i)];
}
function vn(e) {
  var t, a;
  return ((a = (t = e.innerText) != null ? t : e.textContent) != null ? a : "").replace(/\s+/g, " ").trim();
}
function $p(e, t) {
  const a = t.toLowerCase().endsWith(".csv") ? t : `${t}.csv`;
  Hr(new Blob(["\uFEFF", e], { type: "text/csv;charset=utf-8" }), a);
}
function xp(e) {
  var t;
  return ((t = e.textContent) != null ? t : "").trim() !== "" ? !1 : !!e.querySelector("input[type=checkbox], input[type=radio]");
}
function Dp(e, t) {
  var o, s, l;
  let a = e;
  e.querySelector("[data-csv-skip], [data-csv-sep]") && (a = e.cloneNode(!0), a.querySelectorAll("[data-csv-skip]").forEach((c) => c.remove()), a.querySelectorAll("[data-csv-sep]").forEach((c) => c.after(" ")));
  let r = ((s = (o = a.innerText) != null ? o : a.textContent) != null ? s : "").replace(/\s+/g, " ").trim();
  if (!r && a.textContent && (r = a.textContent.replace(/\s+/g, " ").trim()), !r) {
    const c = e.querySelector("input:not([type=checkbox]):not([type=radio]), select, textarea");
    c && (r = c.value.trim());
  }
  return r === "—" || r === "-" || r === "–" ? "" : (l = Kr(r, t)) != null ? l : Kt(r);
}
function kn(e) {
  return /[",\r\n]/.test(e) ? `"${e.replace(/"/g, '""')}"` : e;
}
const Ap = () => new Promise((e) => requestAnimationFrame(() => requestAnimationFrame(() => e())));
function H0({ target: e, fileName: t, label: a = "CSV 내려받기", disabled: r, parenNegative: o, prepare: s, meta: l }) {
  return /* @__PURE__ */ n.createElement(
    na,
    {
      label: a,
      disabled: r,
      style: { width: "auto", padding: "0 9px", gap: 4, border: "1px solid var(--axe-border, #d5dde9)", fontSize: 11, fontWeight: 700 },
      onClick: async () => {
        let c;
        s && (c = await s(), await Ap());
        try {
          const i = e.current;
          if (!i) return;
          $p(kp(i, { parenNegative: o, meta: l == null ? void 0 : l() }), typeof t == "function" ? t() : t);
        } finally {
          typeof c == "function" && c();
        }
      }
    },
    /* @__PURE__ */ n.createElement(mn, { name: "download", size: 14 }),
    "CSV"
  );
}
const Cp = "_root_kpw7f_1", Sp = "_guide_kpw7f_2", Mp = "_tpl_kpw7f_3", Gn = {
  root: Cp,
  guide: Sp,
  tpl: Mp
};
function K0({
  guide: e,
  onTemplate: t,
  templateLabel: a = "빈 양식 받기",
  file: r,
  onFile: o,
  maxBytes: s,
  onTooBig: l,
  fileInfo: c,
  accept: i = ".csv,text/csv",
  label: u = "CSV 파일",
  pickLabel: m = "파일 선택",
  busyReason: _,
  className: f = ""
}) {
  const p = (d) => {
    var N;
    const b = (N = d[0]) != null ? N : null;
    if (b && s !== void 0 && b.size > s) {
      l == null || l(b);
      return;
    }
    o(b);
  }, y = r ? `${r.name}${c != null ? c : r.size !== void 0 ? ` · ${(r.size / 1024).toFixed(1)}KB` : ""}` : void 0;
  return /* @__PURE__ */ n.createElement("div", { className: [Gn.root, f].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(Yf, { tone: "info" }, /* @__PURE__ */ n.createElement("div", { className: Gn.guide }, e), t && /* @__PURE__ */ n.createElement("div", { className: Gn.tpl }, /* @__PURE__ */ n.createElement(et, { size: "sm", onClick: t }, a))), /* @__PURE__ */ n.createElement(
    Ep,
    {
      title: u,
      desc: r ? void 0 : "선택된 파일 없음",
      countText: y,
      accept: i,
      multiple: !1,
      disabled: !!_,
      pickLabel: m,
      onFiles: p
    }
  ));
}
const Tp = { info: "info", ok: "ok", warn: "warn", danger: "off", muted: "muted", off: "off" };
function U0({ map: e, value: t, empty: a = "-" }) {
  if (t == null) return /* @__PURE__ */ n.createElement(n.Fragment, null, a);
  const r = e[t];
  return r ? /* @__PURE__ */ n.createElement(Ha, { tone: Tp[r.tone] }, r.label) : /* @__PURE__ */ n.createElement(Ha, null, String(t));
}
const Va = "axerp-form-modal";
function G0({
  title: e,
  onClose: t,
  onSubmit: a,
  busy: r = !1,
  error: o,
  submitLabel: s,
  submitBlocked: l,
  wide: c,
  labels: i,
  formClassName: u,
  children: m
}) {
  var f, p, y;
  const _ = (d) => {
    d.preventDefault(), !r && !l && a();
  };
  return /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: e,
      onClose: t,
      wide: c,
      closeOnBackdrop: !1,
      error: o,
      footer: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { onClick: t, disabled: r }, (f = i == null ? void 0 : i.cancel) != null ? f : "취소"), /* @__PURE__ */ n.createElement(et, { type: "submit", form: Va, variant: "primary", blockedReason: r ? (p = i == null ? void 0 : i.saving) != null ? p : "저장 중입니다" : l }, (y = s != null ? s : i == null ? void 0 : i.save) != null ? y : "저장"))
    },
    /* @__PURE__ */ n.createElement("form", { id: Va, className: u, onSubmit: _, noValidate: !0 }, m)
  );
}
const qp = { left: "axe-l", center: "axe-c", right: "axe-r" };
function Qa(e) {
  const t = e.currentTarget;
  t.scrollWidth > t.clientWidth + 1 && t.textContent ? t.title = t.textContent : t.removeAttribute("title");
}
const Ja = (e) => {
  var t;
  return qp[(t = e.align) != null ? t : e.num ? "right" : "left"];
};
function Y0({
  columns: e,
  rows: t,
  rowKey: a,
  loading: r = !1,
  error: o = null,
  emptyText: s = "표시할 행이 없습니다",
  selectedKey: l,
  onRowClick: c,
  rowClassName: i,
  title: u,
  grow: m = !1,
  growClassName: _,
  pagination: f,
  stickyCols: p
}) {
  const y = t != null ? t : [];
  return /* @__PURE__ */ n.createElement(qc, { grow: m, className: m ? _ : void 0, cols: e.map((d) => d.width), busy: r, title: u, pagination: f, stickyCols: p }, /* @__PURE__ */ n.createElement("thead", null, /* @__PURE__ */ n.createElement("tr", null, e.map((d) => /* @__PURE__ */ n.createElement("th", { key: d.key, className: Ja(d) === "axe-r" ? "axe-r" : "axe-c", onMouseEnter: Qa }, d.header)))), /* @__PURE__ */ n.createElement("tbody", null, /* @__PURE__ */ n.createElement(
    Gc,
    {
      colSpan: e.length,
      loading: r,
      error: o,
      count: t ? y.length : null,
      empty: s,
      idle: null
    }
  ), y.map((d, b) => {
    var g;
    const N = a(d), $ = [c ? "axe-clickable" : "", l === N ? "axe-sel" : "", (g = i == null ? void 0 : i(d)) != null ? g : ""].filter(Boolean).join(" ");
    return /* @__PURE__ */ n.createElement(
      "tr",
      {
        key: N,
        className: $ || void 0,
        onClick: c ? () => c(d) : void 0,
        ...c ? Yc(() => c(d), l === void 0 ? void 0 : l === N) : {}
      },
      e.map((x) => /* @__PURE__ */ n.createElement("td", { key: x.key, className: Ja(x), onMouseEnter: Qa }, x.render(d, b)))
    );
  })));
}
function V0({ title: e, info: t, badge: a, notice: r, actions: o, minWidth: s, bodyClassName: l, children: c }) {
  return /* @__PURE__ */ n.createElement(yo, { style: { height: "100%" }, minWidth: s }, /* @__PURE__ */ n.createElement(Io, { title: e, info: t, badge: a, notice: r }, o), /* @__PURE__ */ n.createElement("div", { className: l }, c));
}
const Bp = "_menu_1ow3k_1", Lp = "_heading_1ow3k_11", jp = "_section_1ow3k_18", Rp = "_item_1ow3k_23", wn = {
  menu: Bp,
  heading: Lp,
  section: jp,
  item: Rp
}, Nn = 8;
function Q0({ x: e, y: t, entries: a, onClose: r, ariaLabel: o, heading: s }) {
  const l = B(null), c = B(r);
  c.current = r;
  const [i, u] = A({ left: e, top: t });
  $e(() => {
    const f = l.current;
    if (!f) return;
    const p = Math.max(Nn, Math.min(e, window.innerWidth - f.offsetWidth - Nn)), y = Math.max(Nn, Math.min(t, window.innerHeight - f.offsetHeight - Nn));
    u({ left: p, top: y });
  }, [e, t]);
  const m = () => {
    var f, p;
    return Array.from((p = (f = l.current) == null ? void 0 : f.querySelectorAll("[role=menuitem]:not(:disabled)")) != null ? p : []);
  };
  U(() => {
    var f;
    (f = m()[0]) == null || f.focus();
  }, []), U(() => {
    const f = () => c.current(), p = (d) => {
      l.current && !l.current.contains(d.target) && f();
    }, y = (d) => {
      d.key !== "Escape" || d.isComposing || (d.preventDefault(), d.stopPropagation(), f());
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", y, !0), window.addEventListener("resize", f), window.addEventListener("scroll", f, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", y, !0), window.removeEventListener("resize", f), window.removeEventListener("scroll", f, !0);
    };
  }, []);
  const _ = (f) => {
    const p = m();
    if (p.length === 0) return;
    const y = p.indexOf(document.activeElement);
    let d = -1;
    if (f.key === "ArrowDown") d = (y + 1) % p.length;
    else if (f.key === "ArrowUp") d = (y - 1 + p.length) % p.length;
    else if (f.key === "Home") d = 0;
    else if (f.key === "End") d = p.length - 1;
    else if (f.key === "Tab") {
      c.current();
      return;
    }
    d >= 0 && (f.preventDefault(), p[d].focus());
  };
  return _a(
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: l,
        className: wn.menu,
        role: "menu",
        "aria-label": o,
        style: { left: i.left, top: i.top },
        onKeyDown: _,
        onContextMenu: (f) => f.preventDefault()
      },
      s && /* @__PURE__ */ n.createElement("div", { className: wn.heading }, s),
      a.map((f) => f.kind === "section" ? /* @__PURE__ */ n.createElement("div", { key: f.key, className: wn.section }, f.label) : /* @__PURE__ */ n.createElement(
        "button",
        {
          key: f.key,
          type: "button",
          role: "menuitem",
          className: wn.item,
          disabled: f.disabled,
          onClick: () => {
            c.current(), f.onClick();
          }
        },
        f.label
      ))
    ),
    document.body
  );
}
const Ip = "_sw_xhqlf_1", Op = "_on_xhqlf_10", Za = {
  sw: Ip,
  on: Op
};
function J0({ checked: e, onChange: t, label: a, onText: r = "ON", offText: o = "OFF", disabled: s, className: l = "" }) {
  return /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": e,
      "aria-label": a,
      disabled: s,
      className: [Za.sw, e ? Za.on : "", l].filter(Boolean).join(" "),
      onClick: () => t(!e)
    },
    /* @__PURE__ */ n.createElement("span", null, e ? r : o),
    /* @__PURE__ */ n.createElement("i", null)
  );
}
function Pp({ accept: e, multiple: t = !0, onFiles: a }) {
  const r = B(null), o = B(a);
  return o.current = a, { open: re(() => {
    var c;
    (c = r.current) == null || c.click();
  }, []), input: /* @__PURE__ */ n.createElement(
    "input",
    {
      ref: r,
      type: "file",
      accept: e,
      multiple: t,
      hidden: !0,
      onChange: (c) => {
        var u;
        const i = Array.from((u = c.target.files) != null ? u : []);
        c.target.value = "", i.length > 0 && o.current(i);
      }
    }
  ) };
}
function Z0({ accept: e, multiple: t = !0, onFiles: a, disabled: r, title: o, variant: s, size: l, children: c }) {
  const { open: i, input: u } = Pp({ accept: e, multiple: t, onFiles: a });
  return /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(et, { variant: s, size: l, onClick: i, disabled: r, title: o }, c), u);
}
const Xp = "_over_bhzlv_1", zp = "_thumbs_bhzlv_2", Fp = "_thumb_bhzlv_2", la = {
  over: Xp,
  thumbs: zp,
  thumb: Fp
};
function ek({ onFiles: e, accept: t, disabled: a, className: r = "", children: o }) {
  const [s, l] = A(!1), c = (u) => !t || t.some((m) => u.startsWith(m)), i = (u) => Array.from(u).some((m) => m.kind === "file" && c(m.type));
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [r, s ? la.over : ""].filter(Boolean).join(" "),
      onDragOver: (u) => {
        var m;
        a || (m = u.dataTransfer) != null && m.items && !i(u.dataTransfer.items) || (u.preventDefault(), l(!0));
      },
      onDragLeave: () => l(!1),
      onDrop: (u) => {
        if (u.preventDefault(), l(!1), a) return;
        const m = Array.from(u.dataTransfer.files).filter((_) => c(_.type));
        m.length > 0 && e(m);
      }
    },
    o
  );
}
function tk({ images: e, onRemove: t, removeLabel: a, disabled: r }) {
  return /* @__PURE__ */ n.createElement("div", { className: la.thumbs }, e.map((o) => {
    var s;
    return /* @__PURE__ */ n.createElement("figure", { key: o.uid, className: la.thumb, title: (s = o.title) != null ? s : o.name }, /* @__PURE__ */ n.createElement("img", { src: o.previewUrl, alt: o.name }), /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => t(o.uid), "aria-label": a(o.name), disabled: r }, "×"), o.caption !== void 0 && /* @__PURE__ */ n.createElement("figcaption", null, o.caption));
  }));
}
const Wp = "_box_lrwei_1", Hp = "_btn_lrwei_2", Kp = "_pop_lrwei_9", Yn = {
  box: Wp,
  btn: Hp,
  pop: Kp
};
function nk({ summary: e, items: t, onToggle: a, label: r, disabled: o, className: s = "" }) {
  const [l, c] = A(!1), i = B(null), u = B(null);
  return U(() => {
    if (!l) return;
    const m = (f) => {
      i.current && !i.current.contains(f.target) && c(!1);
    }, _ = (f) => {
      var p;
      f.key !== "Escape" || f.isComposing || (f.stopPropagation(), c(!1), (p = u.current) == null || p.focus());
    };
    return document.addEventListener("mousedown", m), document.addEventListener("keydown", _, !0), () => {
      document.removeEventListener("mousedown", m), document.removeEventListener("keydown", _, !0);
    };
  }, [l]), /* @__PURE__ */ n.createElement("div", { className: [Yn.box, s].filter(Boolean).join(" "), ref: i }, /* @__PURE__ */ n.createElement(
    "button",
    {
      ref: u,
      type: "button",
      className: Yn.btn,
      "aria-haspopup": "listbox",
      "aria-expanded": l,
      "aria-label": r,
      disabled: o,
      onClick: () => c((m) => !m)
    },
    e,
    " ▾"
  ), l && /* @__PURE__ */ n.createElement("div", { className: Yn.pop, role: "listbox", "aria-multiselectable": "true", "aria-label": r }, t.map((m) => /* @__PURE__ */ n.createElement("label", { key: m.key }, /* @__PURE__ */ n.createElement("input", { type: "checkbox", checked: m.checked, onChange: () => a(m.key) }), m.label))));
}
const Up = "_card_1adld_1", Gp = "_sub_1adld_2", Yp = "_state_1adld_3", Vp = "_list_1adld_7", Qp = "_row_1adld_8", Jp = "_warn_1adld_20", Zp = "_danger_1adld_21", Dt = {
  card: Up,
  sub: Gp,
  state: Yp,
  list: Vp,
  row: Qp,
  warn: Jp,
  danger: Zp
};
function ak({
  title: e,
  sub: t,
  trailing: a,
  state: r = "ready",
  error: o,
  onRetry: s,
  loadingText: l = "불러오는 중…",
  rows: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement(
    Sr,
    {
      flush: !0,
      className: [Dt.card, i].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(n.Fragment, null, e, t ? /* @__PURE__ */ n.createElement("small", { className: Dt.sub }, t) : null),
      trailing: a
    },
    r === "loading" && /* @__PURE__ */ n.createElement("div", { className: Dt.state }, l),
    r === "error" && /* @__PURE__ */ n.createElement("div", { className: Dt.state }, /* @__PURE__ */ n.createElement(Fr, null, o != null ? o : "불러오지 못했습니다"), s && /* @__PURE__ */ n.createElement(pa, { onClick: s }, "다시 시도")),
    r === "ready" && /* @__PURE__ */ n.createElement("div", { className: Dt.list }, c.map((u, m) => {
      var p, y;
      const _ = [Dt.row, u.tone ? Dt[u.tone] : ""].filter(Boolean).join(" "), f = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", null, u.label), /* @__PURE__ */ n.createElement("strong", null, u.value, u.unit ? /* @__PURE__ */ n.createElement("small", null, u.unit) : null));
      return u.onClick ? /* @__PURE__ */ n.createElement("button", { type: "button", key: (p = u.key) != null ? p : m, className: _, onClick: u.onClick }, f) : /* @__PURE__ */ n.createElement("div", { key: (y = u.key) != null ? y : m, className: _ }, f);
    }))
  );
}
function ey(e, t, a, r, o) {
  const s = Math.max(0, Math.floor(e));
  if (s === 0) return 1;
  const l = Math.max(1, Math.min(s, o != null && o > 0 ? Math.floor(o) : s)), c = Math.max(1, Math.min(l, Math.floor((t + r) / (a + r)))), i = Math.ceil(s / c);
  return Math.ceil(s / i);
}
const ty = "_group_44kzq_1", ny = "_tile_44kzq_2", ay = "_click_44kzq_9", ry = "_pressed_44kzq_13", oy = "_ok_44kzq_14", sy = "_warn_44kzq_15", ly = "_danger_44kzq_16", cy = "_info_44kzq_17", iy = "_accent_44kzq_18", uy = "_muted_44kzq_19", my = "_label_44kzq_20", dy = "_value_44kzq_22", fy = "_desc_44kzq_27", ht = {
  group: ty,
  tile: ny,
  click: ay,
  pressed: ry,
  ok: oy,
  warn: sy,
  danger: ly,
  info: cy,
  accent: iy,
  muted: uy,
  label: my,
  value: dy,
  desc: fy
};
function rk({
  label: e,
  value: t,
  unit: a,
  desc: r,
  tone: o = "info",
  onClick: s,
  pressed: l,
  title: c,
  className: i = ""
}) {
  const u = [ht.tile, ht[o], s ? ht.click : "", s && l ? ht.pressed : "", i].filter(Boolean).join(" "), m = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: ht.label, "data-csv-k": "" }, /* @__PURE__ */ n.createElement("i", { "aria-hidden": "true" }), e), /* @__PURE__ */ n.createElement("span", { className: ht.value, "data-csv-v": "" }, t, a ? /* @__PURE__ */ n.createElement("small", { "data-csv-unit": "" }, a) : null), r ? /* @__PURE__ */ n.createElement("span", { className: ht.desc, title: typeof r == "string" ? r : void 0 }, r) : null);
  return s ? /* @__PURE__ */ n.createElement("button", { type: "button", className: u, onClick: s, "aria-pressed": l, title: c, "data-csv-kv": "" }, m) : /* @__PURE__ */ n.createElement("div", { className: u, title: c, "data-csv-kv": "" }, m);
}
const _y = 150, py = 12, yy = 8;
function ok({ children: e, columns: t, className: a = "" }) {
  const r = B(null), o = ta.toArray(e).filter(un).length, s = t != null || o <= yy, [l, c] = A(null);
  $e(() => {
    const m = r.current;
    if (!s || !m || (c(m.clientWidth), typeof ResizeObserver == "undefined")) return;
    const _ = new ResizeObserver(() => c(m.clientWidth));
    return _.observe(m), () => _.disconnect();
  }, [s]);
  const i = s ? ey(o, l != null ? l : Number.MAX_SAFE_INTEGER, _y, py, t) : 0, u = s ? { gridTemplateColumns: `repeat(${i}, minmax(0, 1fr))` } : void 0;
  return /* @__PURE__ */ n.createElement("div", { ref: r, className: [ht.group, a].filter(Boolean).join(" "), style: u }, e);
}
const by = "_card_1lav2_1", Ey = "_n_1lav2_2", hy = "_list_1lav2_7", gy = "_row_1lav2_8", vy = "_go_1lav2_15", ky = "_name_1lav2_16", wy = "_empty_1lav2_17", Ny = "_star_1lav2_18", $y = "_clear_1lav2_27", Ge = {
  card: by,
  n: Ey,
  list: hy,
  row: gy,
  go: vy,
  name: ky,
  empty: wy,
  star: Ny,
  clear: $y
};
function sk({
  mine: e,
  recent: t,
  onOpen: a,
  onClearRecent: r,
  mineHint: o = "메뉴 목록에서 ☆ 를 누르면 여기에 담깁니다",
  className: s = ""
}) {
  const [l, c] = A("mine"), i = l === "mine" ? e : t;
  return /* @__PURE__ */ n.createElement(
    Sr,
    {
      flush: !0,
      className: [Ge.card, s].filter(Boolean).join(" "),
      title: /* @__PURE__ */ n.createElement(
        kr,
        {
          variant: "segmented",
          "aria-label": "빠른 메뉴",
          value: l,
          onChange: (u) => c(u),
          items: [
            { key: "mine", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "마이메뉴", e.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ge.n }, e.length)) },
            { key: "recent", label: /* @__PURE__ */ n.createElement(n.Fragment, null, "최근 사용", t.length > 0 && /* @__PURE__ */ n.createElement("em", { className: Ge.n }, t.length)) }
          ]
        }
      ),
      trailing: l === "recent" && t.length > 0 && r ? /* @__PURE__ */ n.createElement(pa, { className: Ge.clear, onClick: r }, "목록 비우기") : void 0
    },
    i.length > 0 ? /* @__PURE__ */ n.createElement("ul", { className: Ge.list }, i.map((u) => /* @__PURE__ */ n.createElement("li", { key: u.path }, /* @__PURE__ */ n.createElement("button", { type: "button", className: Ge.row, onClick: () => a(u) }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ge.go }, "↗"), /* @__PURE__ */ n.createElement("span", { className: Ge.name }, u.label))))) : /* @__PURE__ */ n.createElement("div", { className: Ge.empty }, /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true", className: Ge.star }, "★"), /* @__PURE__ */ n.createElement("strong", null, l === "mine" ? "아직 추가한 메뉴가 없습니다" : "최근 사용한 메뉴가 없습니다"), /* @__PURE__ */ n.createElement("p", null, l === "mine" ? o : "메뉴를 실행하면 최근 사용 목록에 표시됩니다"))
  );
}
function er(e) {
  var t;
  try {
    const a = JSON.parse((t = window.localStorage.getItem(e)) != null ? t : "[]");
    return Array.isArray(a) ? a.filter((r) => r && typeof r.path == "string" && typeof r.label == "string") : [];
  } catch {
    return [];
  }
}
function Vn(e, t) {
  try {
    window.localStorage.setItem(e, JSON.stringify(t));
  } catch {
  }
}
function lk({ mineKey: e, recentKey: t, recentMax: a = 6 }) {
  const [r, o] = A(() => er(e)), [s, l] = A(() => er(t)), c = re((_) => r.some((f) => f.path === _), [r]), i = re((_) => o((f) => {
    const p = f.some((y) => y.path === _.path) ? f.filter((y) => y.path !== _.path) : [...f, _];
    return Vn(e, p), p;
  }), [e]), u = re((_) => l((f) => {
    const p = [_, ...f.filter((y) => y.path !== _.path)].slice(0, a);
    return Vn(t, p), p;
  }), [t, a]), m = re(() => {
    l([]), Vn(t, []);
  }, [t]);
  return { mine: r, recent: s, isMine: c, toggleMine: i, remember: u, clearRecent: m };
}
const xy = "_banner_7tqhk_2", Dy = "_heading_7tqhk_7", Ay = "_sparkleBox_7tqhk_8", Cy = "_eyebrow_7tqhk_12", Sy = "_headline_7tqhk_13", My = "_desc_7tqhk_15", Ty = "_err_7tqhk_16", qy = "_chips_7tqhk_18", By = "_footer_7tqhk_28", Ly = "_kicker_7tqhk_35", jy = "_list_7tqhk_36", Ry = "_row_7tqhk_37", Iy = "_icon_7tqhk_39", Oy = "_text_7tqhk_40", Py = "_cap_7tqhk_41", Xy = "_body_7tqhk_43", zy = "_reason_7tqhk_44", Fy = "_empty_7tqhk_45", ye = {
  banner: xy,
  heading: Dy,
  sparkleBox: Ay,
  eyebrow: Cy,
  headline: Sy,
  desc: My,
  err: Ty,
  chips: qy,
  footer: By,
  kicker: Ly,
  list: jy,
  row: Ry,
  icon: Iy,
  text: Oy,
  cap: Py,
  body: Xy,
  reason: zy,
  empty: Fy
};
function tr({ size: e = 18 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
function ck({
  eyebrow: e,
  headline: t,
  desc: a,
  error: r,
  groups: o,
  maxChips: s = 4,
  onOpen: l,
  note: c,
  noteError: i,
  allLabel: u = "전체 업무 제안 보기",
  allDisabled: m,
  className: _ = ""
}) {
  const f = o.slice(0, s), p = o.length - f.length;
  return /* @__PURE__ */ n.createElement("section", { className: [ye.banner, _].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: ye.heading }, /* @__PURE__ */ n.createElement("span", { className: ye.sparkleBox }, /* @__PURE__ */ n.createElement(tr, { size: 22 })), /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: ye.eyebrow }, /* @__PURE__ */ n.createElement(tr, { size: 11 }), " ", e), /* @__PURE__ */ n.createElement("h2", { className: ye.headline }, t), a ? /* @__PURE__ */ n.createElement("p", { className: [ye.desc, r ? ye.err : ""].filter(Boolean).join(" ") }, a) : null)), o.length > 0 && /* @__PURE__ */ n.createElement("div", { className: ye.chips }, f.map((y) => /* @__PURE__ */ n.createElement("button", { type: "button", key: y.key, title: y.label, onClick: () => l(y.key) }, /* @__PURE__ */ n.createElement("i", { style: y.color ? { background: y.color } : void 0, "aria-hidden": "true" }), y.label, " ", /* @__PURE__ */ n.createElement("strong", { style: y.color ? { color: y.color } : void 0 }, y.count, "건"))), p > 0 && /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => l(null) }, "+", p, "종류 더")), /* @__PURE__ */ n.createElement("div", { className: ye.footer }, /* @__PURE__ */ n.createElement(
    "span",
    {
      className: i ? ye.err : void 0,
      role: i ? "alert" : void 0
    },
    c
  ), /* @__PURE__ */ n.createElement(pa, { onClick: () => l(null), disabled: m }, u, " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→"))));
}
function Wy({ items: e, onRun: t, onSkip: a, busy: r, emptyText: o = "남은 제안이 없습니다." }) {
  return e.length === 0 ? /* @__PURE__ */ n.createElement("div", { className: ye.empty }, o) : /* @__PURE__ */ n.createElement("ul", { className: ye.list }, e.map((s) => {
    var l, c;
    return /* @__PURE__ */ n.createElement("li", { key: s.id, className: ye.row }, /* @__PURE__ */ n.createElement("span", { className: ye.icon, "aria-hidden": "true" }, (l = s.icon) != null ? l : "💡"), /* @__PURE__ */ n.createElement("div", { className: ye.text }, /* @__PURE__ */ n.createElement("div", { className: ye.cap }, s.title, s.meta ? /* @__PURE__ */ n.createElement("small", null, " · ", s.meta) : null), /* @__PURE__ */ n.createElement("div", { className: ye.body }, s.body), s.reason ? /* @__PURE__ */ n.createElement("div", { className: ye.reason }, s.reason) : null), /* @__PURE__ */ n.createElement(et, { variant: "primary", disabled: r, onClick: () => t(s) }, (c = s.actionLabel) != null ? c : "실행"), /* @__PURE__ */ n.createElement(et, { disabled: r, onClick: () => a(s) }, "무시"));
  }));
}
function ik({ title: e, kicker: t = "ProActive AI 업무 제안", items: a, onClose: r, onRun: o, onSkip: s }) {
  const l = B(!1), [c, i] = A(!1), [u, m] = A(""), _ = async (f) => {
    if (!l.current) {
      l.current = !0, i(!0), m("");
      try {
        await f();
      } catch {
        m("처리하지 못했습니다. 잠시 후 다시 시도하세요.");
      } finally {
        l.current = !1, i(!1);
      }
    }
  };
  return /* @__PURE__ */ n.createElement(
    Pn,
    {
      title: e,
      onClose: r,
      closeOnEsc: !0,
      confirmDiscard: !1,
      headerExtra: /* @__PURE__ */ n.createElement("span", { className: ye.kicker }, "✦ ", t),
      error: u,
      footer: /* @__PURE__ */ n.createElement(et, { onClick: r }, "닫기")
    },
    /* @__PURE__ */ n.createElement(Wy, { items: a, busy: c, onRun: (f) => _(() => o(f)), onSkip: (f) => _(() => s(f)) })
  );
}
const Hy = "_wrap_1wvdc_2", Ky = "_header_1wvdc_7", Uy = "_iconBox_1wvdc_8", Gy = "_headText_1wvdc_12", Yy = "_eyebrow_1wvdc_13", Vy = "_headline_1wvdc_14", Qy = "_headerExtra_1wvdc_16", Jy = "_grid_1wvdc_19", Zy = "_card_1wvdc_20", eb = "_badge_1wvdc_29", tb = "_toneRed_1wvdc_33", nb = "_toneViolet_1wvdc_34", ab = "_toneGreen_1wvdc_35", rb = "_toneBlue_1wvdc_36", ob = "_title_1wvdc_38", sb = "_summary_1wvdc_42", lb = "_action_1wvdc_46", cb = "_notice_1wvdc_53", ib = "_err_1wvdc_56", fe = {
  wrap: Hy,
  header: Ky,
  iconBox: Uy,
  headText: Gy,
  eyebrow: Yy,
  headline: Vy,
  headerExtra: Qy,
  grid: Jy,
  card: Zy,
  badge: eb,
  toneRed: tb,
  toneViolet: nb,
  toneGreen: ab,
  toneBlue: rb,
  title: ob,
  summary: sb,
  action: lb,
  notice: cb,
  err: ib
};
function nr({ size: e = 16 }) {
  return /* @__PURE__ */ n.createElement("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" }, /* @__PURE__ */ n.createElement("path", { d: "M12 2.8c.72 5.16 2.85 7.3 8.02 8.02-5.17.72-7.3 2.86-8.02 8.02-.72-5.16-2.85-7.3-8.02-8.02C9.15 10.1 11.28 7.96 12 2.8Z", fill: "currentColor" }));
}
const ub = {
  red: fe.toneRed,
  violet: fe.toneViolet,
  green: fe.toneGreen,
  blue: fe.toneBlue
};
function uk({
  items: e,
  onOpen: t,
  eyebrow: a = "PROACTIVE AI",
  headline: r = "지금 처리할 수 있는 업무를 발견했습니다",
  error: o,
  loading: s,
  emptyText: l = "지금은 처리할 업무 제안이 없습니다.",
  headerExtra: c,
  className: i = ""
}) {
  return /* @__PURE__ */ n.createElement("section", { className: [fe.wrap, i].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: fe.header }, /* @__PURE__ */ n.createElement("span", { className: fe.iconBox }, /* @__PURE__ */ n.createElement(nr, { size: 18 })), /* @__PURE__ */ n.createElement("div", { className: fe.headText }, /* @__PURE__ */ n.createElement("div", { className: fe.eyebrow }, a), /* @__PURE__ */ n.createElement("h2", { className: fe.headline }, r)), c ? /* @__PURE__ */ n.createElement("div", { className: fe.headerExtra }, c) : null), o ? /* @__PURE__ */ n.createElement("div", { className: fe.notice + " " + fe.err, role: "alert" }, o) : null, e.length === 0 ? o ? null : s ? /* @__PURE__ */ n.createElement("div", { className: fe.notice, role: "status" }, "업무 제안을 확인하고 있습니다.") : /* @__PURE__ */ n.createElement("div", { className: fe.notice }, l) : /* @__PURE__ */ n.createElement("div", { className: fe.grid }, e.map((u) => {
    var m, _;
    return /* @__PURE__ */ n.createElement("button", { type: "button", key: u.id, className: fe.card, onClick: () => t(u) }, /* @__PURE__ */ n.createElement("span", { className: [fe.badge, ub[(m = u.tone) != null ? m : "violet"]].join(" ") }, /* @__PURE__ */ n.createElement(nr, { size: 9 }), u.badge), /* @__PURE__ */ n.createElement("span", { className: fe.title }, u.title), u.summary ? /* @__PURE__ */ n.createElement("span", { className: fe.summary, title: typeof u.summary == "string" ? u.summary : void 0 }, u.summary) : null, /* @__PURE__ */ n.createElement("span", { className: fe.action }, (_ = u.actionLabel) != null ? _ : "상세 보기", " ", /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "→")));
  })));
}
const mb = "_wrapper_1j5pd_1", db = "_searchIcon_1j5pd_17", fb = "_input_1j5pd_25", _b = "_clearButton_1j5pd_39", pb = "_hint_1j5pd_59", nn = {
  wrapper: mb,
  searchIcon: db,
  input: fb,
  clearButton: _b,
  hint: pb
}, yb = /* @__PURE__ */ n.createElement("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("circle", { cx: "11", cy: "11", r: "7" }), /* @__PURE__ */ n.createElement("path", { d: "M21 21l-4.35-4.35" }));
function bb({
  value: e,
  onChange: t,
  placeholder: a,
  hint: r,
  onSubmit: o,
  onClear: s
}) {
  const l = (c) => {
    c.key === "Enter" && (o == null || o());
  };
  return /* @__PURE__ */ n.createElement("div", { className: `${nn.wrapper} axe-focus-box` }, /* @__PURE__ */ n.createElement("span", { className: nn.searchIcon }, yb), /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "text",
      className: nn.input,
      value: e,
      placeholder: a,
      onChange: (c) => t(c.target.value),
      onKeyDown: l
    }
  ), s && e.length > 0 && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: nn.clearButton,
      onClick: s,
      "aria-label": "비우기"
    },
    /* @__PURE__ */ n.createElement("svg", { width: "14", height: "14", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M18 6L6 18" }), /* @__PURE__ */ n.createElement("path", { d: "M6 6l12 12" }))
  ), r && /* @__PURE__ */ n.createElement("span", { className: nn.hint }, r));
}
const Eb = "_screen_alw5b_1", hb = "_shell_alw5b_8", gb = "_command_alw5b_10", vb = "_body_alw5b_20", kb = "_overview_alw5b_22", wb = "_areaHead_alw5b_25", Wt = {
  screen: Eb,
  shell: hb,
  command: gb,
  body: vb,
  overview: kb,
  areaHead: wb
};
function mk({ search: e, panel: t, children: a, className: r = "" }) {
  var o;
  return /* @__PURE__ */ n.createElement("main", { className: [Wt.screen, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("div", { className: Wt.shell }, e && /* @__PURE__ */ n.createElement("div", { className: Wt.command }, /* @__PURE__ */ n.createElement(
    bb,
    {
      value: e.value,
      onChange: e.onChange,
      onClear: e.onClear,
      onSubmit: e.onSubmit,
      placeholder: e.placeholder,
      hint: (o = e.hint) != null ? o : /* @__PURE__ */ n.createElement("kbd", null, "F10")
    }
  ), t), /* @__PURE__ */ n.createElement("div", { className: Wt.body }, a)));
}
function dk({ children: e, className: t = "" }) {
  return /* @__PURE__ */ n.createElement("div", { className: [Wt.overview, t].filter(Boolean).join(" ") }, e);
}
function fk({ title: e, hint: t }) {
  return /* @__PURE__ */ n.createElement("div", { className: Wt.areaHead }, /* @__PURE__ */ n.createElement("h2", null, e), t && /* @__PURE__ */ n.createElement("span", null, t));
}
const Nb = "_group_oodts_1", $b = "_grid_oodts_7", xb = "_row_oodts_8", Db = "_item_oodts_9", Ab = "_launch_oodts_14", Cb = "_name_oodts_17", Sb = "_desc_oodts_18", Mb = "_badge_oodts_19", Tb = "_disabled_oodts_23", qb = "_tab_oodts_25", Bb = "_star_oodts_25", Lb = "_on_oodts_30", jb = "_empty_oodts_32", Re = {
  group: Nb,
  grid: $b,
  row: xb,
  item: Db,
  launch: Ab,
  name: Cb,
  desc: Sb,
  badge: Mb,
  disabled: Tb,
  tab: qb,
  star: Bb,
  on: Lb,
  empty: jb
};
function Rb() {
  return /* @__PURE__ */ n.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M3 1.5h4l2.5 2.5v6a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-8A.5.5 0 0 1 3 1.5Z" }), /* @__PURE__ */ n.createElement("path", { d: "M7 1.5V4h2.5M4.2 6.2h3.6M4.2 8.2h3.6" }));
}
function Ib() {
  return /* @__PURE__ */ n.createElement("svg", { width: "13", height: "13", viewBox: "0 0 12 12", "aria-hidden": "true", fill: "none", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }, /* @__PURE__ */ n.createElement("path", { d: "M5 2H2.5A.5.5 0 0 0 2 2.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V7M7.5 2H10v2.5M10 2 5.5 6.5" }));
}
function _k({ title: e, items: t, emptyText: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("section", { className: [Re.group, r].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("h3", null, e), /* @__PURE__ */ n.createElement("div", { className: Re.grid }, t.map((o) => /* @__PURE__ */ n.createElement("div", { className: Re.row, key: o.key }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.item, o.disabled ? Re.disabled : ""].filter(Boolean).join(" "),
      disabled: o.disabled,
      onClick: o.onOpen
    },
    /* @__PURE__ */ n.createElement("span", { className: Re.launch }, /* @__PURE__ */ n.createElement(Rb, null)),
    /* @__PURE__ */ n.createElement("span", { className: Re.name }, o.label),
    o.desc && /* @__PURE__ */ n.createElement("span", { className: Re.desc }, o.desc),
    o.badge != null && /* @__PURE__ */ n.createElement("em", { className: Re.badge }, o.badge)
  ), o.onOpenNewTab && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: Re.tab,
      "aria-label": `${o.label} 새 탭으로 열기`,
      title: "새 탭으로 열기",
      onClick: o.onOpenNewTab
    },
    /* @__PURE__ */ n.createElement(Ib, null)
  ), o.onToggleStar && !o.disabled && /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [Re.star, o.starred ? Re.on : ""].filter(Boolean).join(" "),
      "aria-pressed": !!o.starred,
      "aria-label": `${o.label} ${o.starred ? "마이메뉴에서 삭제" : "마이메뉴에 추가"}`,
      onClick: o.onToggleStar
    },
    o.starred ? "★" : "☆"
  ))), t.length === 0 && a != null && /* @__PURE__ */ n.createElement("p", { className: Re.empty }, a)));
}
const Ob = "_strip_8zhai_2", Pb = "_day_8zhai_9", Xb = "_total_8zhai_10", zb = "_sel_8zhai_31", Fb = "_today_8zhai_35", Wb = "_md_8zhai_35", Hb = "_off_8zhai_36", Kb = "_head_8zhai_45", Ub = "_wd_8zhai_46", Gb = "_sun_8zhai_47", Yb = "_sat_8zhai_48", Vb = "_lock_8zhai_50", Qb = "_value_8zhai_60", Jb = "_mark_8zhai_66", Zb = "_warn_8zhai_67", eE = "_danger_8zhai_68", tE = "_info_8zhai_69", we = {
  strip: Ob,
  day: Pb,
  total: Xb,
  sel: zb,
  today: Fb,
  md: Wb,
  off: Hb,
  head: Kb,
  wd: Ub,
  sun: Gb,
  sat: Yb,
  lock: Vb,
  value: Qb,
  mark: Jb,
  warn: Zb,
  danger: eE,
  info: tE
}, ar = ["일", "월", "화", "수", "목", "금", "토"];
function nE(e) {
  const [t, a, r] = e.split("-").map(Number), o = new Date(t, a - 1, r).getDay();
  return { md: `${a}/${r}`, wd: o };
}
function pk({
  days: e,
  selected: t,
  today: a,
  onSelect: r,
  total: o,
  totalLabel: s = "합계",
  "aria-label": l,
  className: c
}) {
  const i = B([]), u = (f) => {
    var y;
    const p = e.length;
    for (let d = 0; d < p; d++) {
      const b = (f + d + p) % p;
      if (!e[b].disabled) {
        (y = i.current[b]) == null || y.focus();
        return;
      }
    }
  }, m = (f, p) => {
    f.key === "ArrowRight" ? (f.preventDefault(), u(p + 1)) : f.key === "ArrowLeft" ? (f.preventDefault(), u(p - 1)) : f.key === "Home" ? (f.preventDefault(), u(0)) : f.key === "End" && (f.preventDefault(), u(e.length - 1));
  }, _ = Math.max(0, e.findIndex((f) => f.date === t));
  return /* @__PURE__ */ n.createElement("div", { className: `${we.strip}${c ? ` ${c}` : ""}`, role: "group", "aria-label": l }, e.map((f, p) => {
    var $, g, x, h;
    const { md: y, wd: d } = nE(f.date), b = [
      we.day,
      f.off ? we.off : "",
      f.date === t ? we.sel : "",
      f.date === a ? we.today : "",
      d === 0 ? we.sun : d === 6 ? we.sat : ""
    ].filter(Boolean).join(" "), N = [`${y}(${ar[d]})`, f.offLabel, f.locked ? "잠김" : null, ($ = f.mark) == null ? void 0 : $.text].filter(Boolean).join(" · ");
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: f.date,
        ref: (w) => {
          i.current[p] = w;
        },
        type: "button",
        className: b,
        disabled: f.disabled,
        tabIndex: p === _ ? 0 : -1,
        "aria-pressed": f.date === t,
        "aria-label": N,
        title: N,
        onClick: () => r == null ? void 0 : r(f.date),
        onKeyDown: (w) => m(w, p)
      },
      /* @__PURE__ */ n.createElement("span", { className: we.head }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, ar[d]), /* @__PURE__ */ n.createElement("span", { className: we.md }, y), f.locked && /* @__PURE__ */ n.createElement("span", { className: we.lock, "aria-hidden": "true" }, "잠김")),
      /* @__PURE__ */ n.createElement("span", { className: we.value }, f.value),
      /* @__PURE__ */ n.createElement("span", { className: `${we.mark}${f.mark ? ` ${we[f.mark.tone]}` : ""}` }, (h = (g = f.mark) == null ? void 0 : g.text) != null ? h : f.off && (x = f.offLabel) != null ? x : "")
    );
  }), o !== void 0 && /* @__PURE__ */ n.createElement("div", { className: we.total }, /* @__PURE__ */ n.createElement("span", { className: we.wd }, s), /* @__PURE__ */ n.createElement("span", { className: we.value }, o)));
}
const aE = "_stepper_1wbt2_1", rE = "_nav_1wbt2_2", oE = "_today_1wbt2_3", sE = "_range_1wbt2_14", an = {
  stepper: aE,
  nav: rE,
  today: oE,
  range: sE
};
function lE(e) {
  const t = Ea(e);
  return t === 0 ? 7 : t;
}
function cE(e, t = 1) {
  const a = (lE(e) - t + 7) % 7;
  return Ln(e, -a);
}
function Qn(e, t) {
  return Ln(e, t);
}
function yk({ value: e, onChange: t, weekStart: a = 1, today: r, disabled: o, label: s = "주" }) {
  const l = Qn(e, 6), c = cE(r, a), i = l.slice(0, 4) === e.slice(0, 4) ? l.slice(5) : l;
  return /* @__PURE__ */ n.createElement("span", { className: an.stepper, role: "group", "aria-label": s }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Qn(e, -7)),
      disabled: o,
      "aria-label": "이전 주"
    },
    "◀"
  ), /* @__PURE__ */ n.createElement("span", { className: an.range, "aria-live": "polite" }, e, " ~ ", i), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.nav,
      onClick: () => t(Qn(e, 7)),
      disabled: o,
      "aria-label": "다음 주"
    },
    "▶"
  ), /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: an.today,
      onClick: () => t(c),
      disabled: o || e === c
    },
    "이번 주"
  ));
}
const iE = "_wrap_1dtpy_1", uE = "_svg_1dtpy_2", mE = "_grid_1dtpy_3", dE = "_axis_1dtpy_4", fE = "_accent_1dtpy_5", _E = "_muted_1dtpy_6", pE = "_ok_1dtpy_7", yE = "_warn_1dtpy_8", bE = "_danger_1dtpy_9", EE = "_legend_1dtpy_10", hE = "_dot_accent_1dtpy_13", gE = "_dot_muted_1dtpy_14", vE = "_dot_ok_1dtpy_15", kE = "_dot_warn_1dtpy_16", wE = "_dot_danger_1dtpy_17", bt = {
  wrap: iE,
  svg: uE,
  grid: mE,
  axis: dE,
  accent: fE,
  muted: _E,
  ok: pE,
  warn: yE,
  danger: bE,
  legend: EE,
  dot_accent: hE,
  dot_muted: gE,
  dot_ok: vE,
  dot_warn: kE,
  dot_danger: wE
}, NE = 600;
function $E(e) {
  if (e <= 0) return 1;
  const t = Math.pow(10, Math.floor(Math.log10(e))), a = e / t;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * t;
}
const rr = (e) => e.toLocaleString("ko-KR", { maximumFractionDigits: 1 });
function bk({ categories: e, series: t, unit: a = "", height: r = 180, label: o, labelEvery: s }) {
  const l = B(null), [c, i] = A(NE);
  $e(() => {
    const E = l.current;
    if (!E) return;
    const D = () => {
      const T = E.clientWidth;
      T > 0 && i((M) => M === T ? M : T);
    };
    if (D(), typeof ResizeObserver == "undefined") return;
    const C = new ResizeObserver(D);
    return C.observe(E), () => C.disconnect();
  }, []);
  const u = r, m = 40, _ = 22, f = 8, p = c - m - 4, y = u - _ - f, d = t.flatMap((E) => E.values.filter((D) => D != null)), b = $E(Math.max(0, ...d)), N = Math.max(e.length, 1), $ = p / N, g = Math.min(8, $ * 0.2), x = Math.max(1, ($ - g) / Math.max(t.length, 1)), h = s != null ? s : Math.max(1, Math.ceil(N / 8)), w = [0, b / 2, b];
  return /* @__PURE__ */ n.createElement("div", { className: bt.wrap, ref: l }, /* @__PURE__ */ n.createElement(
    "svg",
    {
      className: bt.svg,
      viewBox: `0 0 ${c} ${u}`,
      role: "img",
      "aria-label": o,
      style: { height: r }
    },
    w.map((E) => {
      const D = f + y - E / b * y;
      return /* @__PURE__ */ n.createElement("g", { key: E }, /* @__PURE__ */ n.createElement("line", { className: bt.grid, x1: m, x2: c - 4, y1: D, y2: D }), /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: m - 4, y: D + 3, textAnchor: "end" }, rr(E)));
    }),
    e.map((E, D) => /* @__PURE__ */ n.createElement("g", { key: E }, t.map((C, T) => {
      var q;
      const M = C.values[D];
      if (M == null || M <= 0) return null;
      const R = M / b * y;
      return /* @__PURE__ */ n.createElement(
        "rect",
        {
          key: C.key,
          className: bt[(q = C.tone) != null ? q : "accent"],
          x: m + D * $ + g / 2 + T * x,
          y: f + y - R,
          width: x,
          height: R
        },
        /* @__PURE__ */ n.createElement("title", null, `${E} · ${C.label} ${rr(M)}${a}`)
      );
    }), D % h === 0 && /* @__PURE__ */ n.createElement("text", { className: bt.axis, x: m + D * $ + $ / 2, y: u - 6, textAnchor: "middle" }, E)))
  ), /* @__PURE__ */ n.createElement("ul", { className: bt.legend }, t.map((E) => {
    var D;
    return /* @__PURE__ */ n.createElement("li", { key: E.key }, /* @__PURE__ */ n.createElement("i", { className: bt[`dot_${(D = E.tone) != null ? D : "accent"}`], "aria-hidden": "true" }), E.label, a ? ` (${a})` : "");
  })));
}
const xE = "_wrap_85lir_1", DE = "_track_85lir_2", AE = "_accent_85lir_3", CE = "_muted_85lir_3", SE = "_ok_85lir_3", ME = "_warn_85lir_3", TE = "_danger_85lir_3", qE = "_center_85lir_9", BE = "_legend_85lir_10", LE = "_name_85lir_13", jE = "_val_85lir_14", RE = "_pct_85lir_15", IE = "_dot_accent_85lir_16", OE = "_dot_muted_85lir_17", PE = "_dot_ok_85lir_18", XE = "_dot_warn_85lir_19", zE = "_dot_danger_85lir_20", ot = {
  wrap: xE,
  track: DE,
  accent: AE,
  muted: CE,
  ok: SE,
  warn: ME,
  danger: TE,
  center: qE,
  legend: BE,
  name: LE,
  val: jE,
  pct: RE,
  dot_accent: IE,
  dot_muted: OE,
  dot_ok: PE,
  dot_warn: XE,
  dot_danger: zE
}, ca = 40, or = 2 * Math.PI * ca;
function Ek({ items: e, center: t, size: a = 120, label: r, emptyText: o = "자료 없음", unit: s = "" }) {
  const l = e.reduce((i, u) => i + Math.max(0, u.value), 0);
  let c = 0;
  return /* @__PURE__ */ n.createElement("div", { className: ot.wrap }, /* @__PURE__ */ n.createElement("svg", { viewBox: "0 0 100 100", width: a, height: a, role: "img", "aria-label": r }, /* @__PURE__ */ n.createElement("circle", { className: ot.track, cx: "50", cy: "50", r: ca }), l > 0 && e.map((i) => {
    var _;
    const u = Math.max(0, i.value) / l * or, m = c;
    return c += u, u <= 0 ? null : /* @__PURE__ */ n.createElement(
      "circle",
      {
        key: i.key,
        className: ot[(_ = i.tone) != null ? _ : "accent"],
        cx: "50",
        cy: "50",
        r: ca,
        strokeDasharray: `${u} ${or - u}`,
        strokeDashoffset: -m,
        transform: "rotate(-90 50 50)"
      },
      /* @__PURE__ */ n.createElement("title", null, `${i.label} ${i.value.toLocaleString("ko-KR")}${s}`)
    );
  }), /* @__PURE__ */ n.createElement("text", { className: ot.center, x: "50", y: "54", textAnchor: "middle" }, l > 0 ? t != null ? t : l.toLocaleString("ko-KR") : o)), /* @__PURE__ */ n.createElement("ul", { className: ot.legend }, e.map((i) => {
    var u;
    return /* @__PURE__ */ n.createElement("li", { key: i.key }, /* @__PURE__ */ n.createElement("i", { className: ot[`dot_${(u = i.tone) != null ? u : "accent"}`], "aria-hidden": "true" }), /* @__PURE__ */ n.createElement("span", { className: ot.name }, i.label), /* @__PURE__ */ n.createElement("span", { className: ot.val }, i.value.toLocaleString("ko-KR"), s), /* @__PURE__ */ n.createElement("span", { className: ot.pct }, l > 0 ? `${Math.round(i.value / l * 100)}%` : "-"));
  })));
}
const FE = "_wrap_1b8ll_1", WE = "_track_1b8ll_2", HE = "_compact_1b8ll_3", KE = "_fill_1b8ll_4", UE = "_accent_1b8ll_5", GE = "_muted_1b8ll_6", YE = "_ok_1b8ll_7", VE = "_warn_1b8ll_8", QE = "_danger_1b8ll_9", JE = "_num_1b8ll_10", ZE = "_none_1b8ll_12", At = {
  wrap: FE,
  track: WE,
  compact: HE,
  fill: KE,
  accent: UE,
  muted: GE,
  ok: YE,
  warn: VE,
  danger: QE,
  num: JE,
  none: ZE
};
function hk({ value: e, label: t, tone: a = "accent", compact: r }) {
  if (e == null)
    return /* @__PURE__ */ n.createElement("span", { className: At.none, "aria-label": `${t} 해당 없음` }, "-");
  const o = Math.max(0, Math.min(100, e));
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [At.wrap, r ? At.compact : ""].filter(Boolean).join(" "),
      role: "progressbar",
      "aria-label": t,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": o
    },
    /* @__PURE__ */ n.createElement("span", { className: At.track }, /* @__PURE__ */ n.createElement("span", { className: `${At.fill} ${At[a]}`, style: { width: `${o}%` } })),
    /* @__PURE__ */ n.createElement("span", { className: At.num }, o, "%")
  );
}
const e1 = { day: 28, week: 10, month: 3 };
function Bt(e, t) {
  return Ln(e, t);
}
function ia(e, t) {
  return vt(t) - vt(e) + 1;
}
function Ur(e) {
  return Ea(e);
}
const sr = (e) => {
  const t = Ur(e);
  return t === 0 || t === 6;
};
function Ft(e, t, a, r) {
  const o = [], s = ia(e, t);
  for (let l = 0; l < s; l++) {
    const c = Bt(e, l), i = a(c), u = o[o.length - 1];
    u && u.key === i ? u.days++ : o.push({ key: i, label: r(c), offset: l, days: 1 });
  }
  return o;
}
function t1(e, t, a) {
  const r = (s) => s.slice(0, 7), o = (s) => `${s.slice(0, 4)}.${s.slice(5, 7)}`;
  if (a === "month")
    return {
      top: Ft(e, t, (s) => s.slice(0, 4), (s) => `${s.slice(0, 4)}년`),
      bottom: Ft(e, t, r, (s) => `${Number(s.slice(5, 7))}월`)
    };
  if (a === "week") {
    const s = (l) => Bt(l, -((Ur(l) + 6) % 7));
    return {
      top: Ft(e, t, r, o),
      bottom: Ft(e, t, s, (l) => {
        const c = s(l);
        return `${Number(c.slice(5, 7))}/${Number(c.slice(8, 10))}`;
      })
    };
  }
  return {
    top: Ft(e, t, r, o),
    bottom: Ft(e, t, (s) => s, (s) => String(Number(s.slice(8, 10))))
  };
}
function Jn(e, t, a, r) {
  if (a === "move") return { start: Bt(e, r), end: Bt(t, r) };
  if (a === "start") {
    const s = Bt(e, r);
    return { start: s > t ? t : s, end: t };
  }
  const o = Bt(t, r);
  return { start: e, end: o < e ? e : o };
}
const n1 = "_gantt_1smka_3", a1 = "_scroll_1smka_15", r1 = "_canvas_1smka_21", o1 = "_head_1smka_24", s1 = "_headLabel_1smka_32", l1 = "_headTrack_1smka_43", c1 = "_band_1smka_44", i1 = "_seg_1smka_46", u1 = "_tick_1smka_59", m1 = "_tickOff_1smka_60", d1 = "_body_1smka_62", f1 = "_overlay_1smka_65", _1 = "_weekend_1smka_66", p1 = "_holiday_1smka_66", y1 = "_today_1smka_68", b1 = "_row_1smka_70", E1 = "_label_1smka_76", h1 = "_sel_1smka_77", g1 = "_track_1smka_77", v1 = "_dim_1smka_78", k1 = "_labelText_1smka_95", w1 = "_dot_1smka_96", N1 = "_warn_1smka_97", $1 = "_err_1smka_98", x1 = "_bar_1smka_113", D1 = "_can_1smka_21", A1 = "_dragging_1smka_126", C1 = "_fill_1smka_127", S1 = "_late_1smka_128", M1 = "_summary_1smka_130", T1 = "_handle_1smka_133", q1 = "_hL_1smka_134", B1 = "_hR_1smka_135", L1 = "_mark_1smka_137", j1 = "_barText_1smka_138", R1 = "_empty_1smka_147", I1 = "_srOnly_1smka_150", ee = {
  gantt: n1,
  scroll: a1,
  canvas: r1,
  head: o1,
  headLabel: s1,
  headTrack: l1,
  band: c1,
  seg: i1,
  tick: u1,
  tickOff: m1,
  body: d1,
  overlay: f1,
  weekend: _1,
  holiday: p1,
  today: y1,
  row: b1,
  label: E1,
  sel: h1,
  track: g1,
  dim: v1,
  labelText: k1,
  dot: w1,
  warn: N1,
  err: $1,
  bar: x1,
  can: D1,
  dragging: A1,
  fill: C1,
  late: S1,
  summary: M1,
  handle: T1,
  hL: q1,
  hR: B1,
  mark: L1,
  barText: j1,
  empty: R1,
  srOnly: I1
}, lr = 28, cr = "키보드: ←→ 옮기기 · Shift+←→ 끝 조절 · Alt+←→ 시작 조절 · Enter 열기";
let O1 = 0;
function gk({
  rows: e,
  from: t,
  to: a,
  scale: r = "day",
  holidays: o = {},
  today: s,
  scrollToToday: l = !0,
  onChange: c,
  onRowClick: i,
  selectedId: u,
  labelWidth: m = 280,
  labelHeader: _,
  lockedReason: f,
  scrollMemory: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = B("");
  N.current || (N.current = `axe-gantt-keys-${++O1}`);
  const $ = e1[r], g = Math.max(ia(t, a), 1), x = vt(t), h = g * $, w = ke(() => t1(t, a, r), [t, a, r]), E = ke(() => {
    const v = [];
    for (let P = 0; P < g; P++) {
      const V = Bt(t, P), Q = V in o;
      if (!Q && !sr(V)) continue;
      const se = v[v.length - 1];
      se && se.offset + se.days === P && se.holiday === Q ? se.days++ : v.push({ offset: P, days: 1, holiday: Q });
    }
    return v;
  }, [t, g, o]), [D, C] = A(null), T = B(null), M = (v) => !!c && !v.locked && !v.summary && !!v.start && !!v.end, R = (v, P, V) => {
    if (!M(P) || v.button !== 0) return;
    v.stopPropagation(), v.currentTarget.setPointerCapture(v.pointerId);
    const Q = { id: P.id, mode: V, x: v.clientX, delta: 0, moved: !1 };
    T.current = Q, C(Q);
  }, q = (v) => {
    const P = T.current;
    if (!P) return;
    const V = Math.round((v.clientX - P.x) / $), Q = P.moved || Math.abs(v.clientX - P.x) > 3;
    if (V !== P.delta || Q !== P.moved) {
      const se = { ...P, delta: V, moved: Q };
      T.current = se, C(se);
    }
  }, F = (v) => {
    const P = T.current;
    if (T.current = null, C(null), !!P) {
      if (!P.moved) {
        i == null || i(v);
        return;
      }
      P.delta !== 0 && v.start && v.end && (c == null || c(v, Jn(v.start, v.end, P.mode, P.delta), P.mode));
    }
  }, Y = () => {
    T.current = null, C(null);
  }, W = (v, P) => {
    if (v.key === "Escape" && T.current) {
      Y();
      return;
    }
    if (v.key === "Enter") {
      i == null || i(P);
      return;
    }
    if (!M(P) || v.key !== "ArrowLeft" && v.key !== "ArrowRight") return;
    v.preventDefault();
    const V = v.key === "ArrowLeft" ? -1 : 1, Q = v.shiftKey ? "end" : v.altKey ? "start" : "move";
    c == null || c(P, Jn(P.start, P.end, Q, V), Q);
  }, j = s ? vt(s) - x : -1, ne = B(null), te = B(null);
  return $e(() => {
    const v = ne.current;
    if (v && (p != null && p.current) && te.current === null) {
      te.current = r, v.scrollLeft = p.current.left, v.scrollTop = p.current.top;
      return;
    }
    if (!l || !v || j < 0 || j >= g || te.current === r) return;
    te.current = r;
    const P = Math.max(v.clientWidth - m, 0);
    v.scrollLeft = Math.max(0, j * $ + $ / 2 - P / 3);
  }, [l, r, j, g, $, m]), /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [ee.gantt, y].filter(Boolean).join(" "),
      style: d,
      role: "region",
      "aria-label": b != null ? b : "간트",
      onKeyDown: (v) => {
        v.key === "Escape" && T.current && Y();
      }
    },
    /* @__PURE__ */ n.createElement("span", { id: N.current, className: ee.srOnly }, cr),
    /* @__PURE__ */ n.createElement(
      "div",
      {
        ref: ne,
        className: ee.scroll,
        onScroll: p ? (v) => {
          p.current = { left: v.currentTarget.scrollLeft, top: v.currentTarget.scrollTop };
        } : void 0
      },
      /* @__PURE__ */ n.createElement("div", { className: ee.canvas, style: { width: m + h } }, /* @__PURE__ */ n.createElement("div", { className: ee.head, style: { gridTemplateColumns: `${m}px ${h}px` } }, /* @__PURE__ */ n.createElement("div", { className: ee.headLabel }, _), /* @__PURE__ */ n.createElement("div", { className: ee.headTrack }, /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.top.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.key, className: ee.seg, style: { left: v.offset * $, width: v.days * $ }, title: v.label }, v.label))), /* @__PURE__ */ n.createElement("div", { className: ee.band }, w.bottom.map((v) => {
        var V;
        const P = r === "day" && (v.key in o || sr(v.key));
        return /* @__PURE__ */ n.createElement(
          "span",
          {
            key: v.key,
            className: [ee.seg, ee.tick, P ? ee.tickOff : ""].filter(Boolean).join(" "),
            style: { left: v.offset * $, width: v.days * $ },
            title: (V = o[v.key]) != null ? V : v.key
          },
          v.days * $ >= 16 ? v.label : ""
        );
      })))), /* @__PURE__ */ n.createElement("div", { className: ee.body, style: { minHeight: lr } }, /* @__PURE__ */ n.createElement("div", { className: ee.overlay, style: { left: m, width: h }, "aria-hidden": "true" }, E.map((v) => /* @__PURE__ */ n.createElement("span", { key: v.offset, className: v.holiday ? ee.holiday : ee.weekend, style: { left: v.offset * $, width: v.days * $ } })), j >= 0 && j < g && /* @__PURE__ */ n.createElement("span", { className: ee.today, style: { left: j * $ + $ / 2 }, title: "오늘" })), e.map((v) => {
        var z, H, ie, Ie;
        const P = !!v.start && !!v.end && v.start <= v.end, V = D && D.id === v.id ? D : null, Q = P && V && V.delta !== 0 ? Jn(v.start, v.end, V.mode, V.delta) : P ? { start: v.start, end: v.end } : null, se = Q ? (vt(Q.start) - x) * $ : 0, L = Q ? ia(Q.start, Q.end) * $ : 0, Z = Math.max(0, Math.min(100, (z = v.progress) != null ? z : 0)), I = u != null && u === v.id, X = M(v), G = !X && c && Q ? f == null ? void 0 : f(v) : void 0;
        return /* @__PURE__ */ n.createElement(
          "div",
          {
            key: v.id,
            className: [ee.row, I ? ee.sel : "", v.dim ? ee.dim : ""].filter(Boolean).join(" "),
            style: { height: lr }
          },
          /* @__PURE__ */ n.createElement(
            "div",
            {
              className: ee.label,
              style: { width: m },
              title: v.name,
              onClick: () => i == null ? void 0 : i(v)
            },
            /* @__PURE__ */ n.createElement("span", { className: ee.labelText }, v.label),
            v.marked && /* @__PURE__ */ n.createElement("span", { className: ee.dot, title: "저장 대기", "aria-label": "저장 대기" }),
            v.warn && /* @__PURE__ */ n.createElement("span", { className: ee.warn, title: v.warn, "aria-label": v.warn }, "⚠"),
            v.error && /* @__PURE__ */ n.createElement("span", { className: ee.err, title: v.error, "aria-label": v.error }, "!")
          ),
          /* @__PURE__ */ n.createElement("div", { className: ee.track, style: { width: h }, onClick: () => !V && (i == null ? void 0 : i(v)) }, Q ? /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement(
            "div",
            {
              className: [ee.bar, v.summary ? ee.summary : "", v.late ? ee.late : "", X ? ee.can : "", V ? ee.dragging : ""].filter(Boolean).join(" "),
              style: { left: se, width: Math.max(L, 2) },
              role: "button",
              tabIndex: 0,
              "aria-label": `${(H = v.name) != null ? H : ""} ${Q.start} ~ ${Q.end}${v.progress != null ? ` ${Z}%` : ""}${v.late ? " 지연" : ""}${G ? ` 잠김: ${G}` : ""}`,
              "aria-describedby": X ? N.current : void 0,
              title: `${Q.start} ~ ${Q.end}${v.progress != null ? ` · ${Z}%` : ""}${v.late ? " · 지연" : ""}${X ? `
끌어 옮기기·양 끝 조절
${cr}` : ""}${G ? `
잠김: ${G}` : ""}`,
              onPointerDown: (xe) => R(xe, v, "move"),
              onPointerMove: q,
              onPointerUp: () => F(v),
              onPointerCancel: Y,
              onClick: (xe) => xe.stopPropagation(),
              onKeyDown: (xe) => W(xe, v)
            },
            v.progress != null && /* @__PURE__ */ n.createElement("span", { className: ee.fill, style: { width: `${Z}%` } }),
            X && /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hL}`, onPointerDown: (xe) => R(xe, v, "start") }), /* @__PURE__ */ n.createElement("span", { className: `${ee.handle} ${ee.hR}`, onPointerDown: (xe) => R(xe, v, "end") }))
          ), v.markDate && v.markDate >= t && v.markDate <= a && /* @__PURE__ */ n.createElement("span", { className: ee.mark, style: { left: (vt(v.markDate) - x + 1) * $ - 1 }, title: (ie = v.markLabel) != null ? ie : v.markDate }), v.barText && /* @__PURE__ */ n.createElement("span", { className: ee.barText, style: { left: se + Math.max(L, 2) + 4 } }, v.barText)) : /* @__PURE__ */ n.createElement("span", { className: ee.empty }, (Ie = v.emptyText) != null ? Ie : "기간 없음"))
        );
      })))
    )
  );
}
const P1 = "_board_192fl_3", X1 = "_col_192fl_15", z1 = "_over_192fl_23", F1 = "_head_192fl_25", W1 = "_title_192fl_33", H1 = "_count_192fl_34", K1 = "_hint_192fl_43", U1 = "_list_192fl_45", G1 = "_empty_192fl_54", Y1 = "_card_192fl_56", V1 = "_sel_192fl_68", Q1 = "_dragging_192fl_69", J1 = "_hasErr_192fl_70", Z1 = "_dot_192fl_71", eh = "_err_192fl_72", Te = {
  board: P1,
  col: X1,
  over: z1,
  head: F1,
  title: W1,
  count: H1,
  hint: K1,
  list: U1,
  empty: G1,
  card: Y1,
  sel: V1,
  dragging: Q1,
  hasErr: J1,
  dot: Z1,
  err: eh
}, Zn = "application/x-axerp-kanban";
function vk({
  columns: e,
  cards: t,
  cardKey: a,
  columnOf: r,
  renderCard: o,
  cardLabel: s,
  onMove: l,
  onCardClick: c,
  selectedKey: i,
  marked: u,
  error: m,
  lockedReason: _,
  emptyText: f = "카드가 없습니다",
  moveHint: p,
  className: y = "",
  style: d,
  "aria-label": b
}) {
  const N = Qt("axe-kb"), [$, g] = A(null), [x, h] = A(null), w = new Map(t.map((M) => [String(a(M)), M])), E = B(null), D = B(null);
  U(() => {
    var q, F;
    const M = D.current;
    if (!M) return;
    if (Date.now() > M.until) {
      D.current = null;
      return;
    }
    const R = Array.from((F = (q = E.current) == null ? void 0 : q.querySelectorAll("[data-kanban-key]")) != null ? F : []).find((Y) => Y.dataset.kanbanKey === M.key);
    R && document.activeElement !== R && R.focus(), D.current = null;
  });
  const C = (M, R) => {
    M.preventDefault(), g(null), h(null);
    const q = M.dataTransfer.getData(Zn), F = w.get(q);
    F && r(F) !== R && (l == null || l(F, R));
  }, T = (M, R) => {
    if (M.key === "Enter" || M.key === " ") {
      M.preventDefault(), c == null || c(R);
      return;
    }
    if (!l || !M.altKey || M.key !== "ArrowLeft" && M.key !== "ArrowRight" || _ != null && _(R)) return;
    M.preventDefault();
    const q = e.findIndex((Y) => Y.key === r(R)), F = q + (M.key === "ArrowLeft" ? -1 : 1);
    q >= 0 && F >= 0 && F < e.length && (D.current = { key: String(a(R)), until: Date.now() + 1500 }, l(R, e[F].key));
  };
  return /* @__PURE__ */ n.createElement("div", { ref: E, className: [Te.board, y].filter(Boolean).join(" "), style: d, role: "region", "aria-label": b != null ? b : "보드" }, e.map((M) => {
    const R = t.filter((q) => r(q) === M.key);
    return /* @__PURE__ */ n.createElement(
      "section",
      {
        key: M.key,
        className: [Te.col, $ === M.key ? Te.over : ""].filter(Boolean).join(" "),
        "aria-label": typeof M.title == "string" ? M.title : void 0,
        onDragOver: l ? (q) => {
          q.dataTransfer.types.includes(Zn) && (q.preventDefault(), g(M.key));
        } : void 0,
        onDragLeave: l ? (q) => {
          q.currentTarget.contains(q.relatedTarget) || g((F) => F === M.key ? null : F);
        } : void 0,
        onDrop: l ? (q) => C(q, M.key) : void 0
      },
      /* @__PURE__ */ n.createElement("header", { className: Te.head }, /* @__PURE__ */ n.createElement("span", { className: Te.title }, M.title), /* @__PURE__ */ n.createElement("span", { className: Te.count }, R.length), M.hint && /* @__PURE__ */ n.createElement("span", { className: Te.hint }, M.hint)),
      /* @__PURE__ */ n.createElement("div", { className: Te.list }, R.length === 0 && /* @__PURE__ */ n.createElement("p", { className: Te.empty }, f), R.map((q) => {
        const F = a(q), Y = _ == null ? void 0 : _(q), W = m == null ? void 0 : m(q), j = !!l && !Y, ne = Y != null ? Y : j ? p != null ? p : "끌어 다른 열로 옮길 수 있습니다 (Alt+←→)" : void 0;
        return /* @__PURE__ */ n.createElement(
          "article",
          {
            key: F,
            className: [Te.card, i === F ? Te.sel : "", x === F ? Te.dragging : "", W ? Te.hasErr : ""].filter(Boolean).join(" "),
            tabIndex: 0,
            "data-kanban-key": String(F),
            role: "button",
            "aria-label": s == null ? void 0 : s(q),
            "aria-keyshortcuts": j ? "Alt+ArrowLeft Alt+ArrowRight" : void 0,
            title: ne,
            "aria-describedby": ne ? `${N}-h-${String(F)}` : void 0,
            draggable: j,
            onDragStart: j ? (te) => {
              te.dataTransfer.setData(Zn, String(F)), te.dataTransfer.effectAllowed = "move", h(F);
            } : void 0,
            onDragEnd: () => {
              h(null), g(null);
            },
            onClick: () => c == null ? void 0 : c(q),
            onKeyDown: (te) => T(te, q)
          },
          ne && /* @__PURE__ */ n.createElement(Mr, { id: `${N}-h-${String(F)}` }, ne),
          (u == null ? void 0 : u(q)) && /* @__PURE__ */ n.createElement("span", { className: Te.dot, title: "저장 대기", "aria-label": "저장 대기" }),
          o(q),
          W && /* @__PURE__ */ n.createElement("p", { className: Te.err, role: "alert" }, W)
        );
      }))
    );
  }));
}
const th = "_list_1aqum_2", nh = "_empty_1aqum_3", ah = "_item_1aqum_5", rh = "_row_block_1aqum_6", oh = "_row_warn_1aqum_7", sh = "_head_1aqum_9", lh = "_mark_1aqum_16", ch = "_msg_1aqum_17", ih = "_count_1aqum_18", uh = "_aside_1aqum_19", mh = "_caret_1aqum_20", dh = "_block_1aqum_22", fh = "_warn_1aqum_23", _h = "_info_1aqum_24", ph = "_body_1aqum_29", yh = "_actions_1aqum_30", qe = {
  list: th,
  empty: nh,
  item: ah,
  row_block: rh,
  row_warn: oh,
  head: sh,
  mark: lh,
  msg: ch,
  count: ih,
  aside: uh,
  caret: mh,
  block: dh,
  warn: fh,
  info: _h,
  body: ph,
  actions: yh
}, bh = { block: "■", warn: "▲", info: "●" }, Eh = { block: "차단", warn: "경고", info: "정보" };
function kk({ items: e, empty: t = "점검할 항목이 없습니다", openTones: a = ["block"], className: r = "" }) {
  const [o, s] = A({}), [l, c] = A(e);
  return l !== e && (c(e), s({})), e.length ? /* @__PURE__ */ n.createElement("ul", { className: `${qe.list} ${r}` }, e.map((i) => {
    var f;
    const u = !!i.detail || !!i.actions, m = u && ((f = o[i.key]) != null ? f : a.includes(i.tone)), _ = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: `${qe.mark} ${qe[i.tone]}`, "aria-label": Eh[i.tone], role: "img" }, bh[i.tone]), /* @__PURE__ */ n.createElement("span", { className: qe.msg }, i.message), !!i.count && /* @__PURE__ */ n.createElement("span", { className: `${qe.count} ${qe[i.tone]}` }, i.count.toLocaleString("ko-KR"), "건"), i.aside != null && /* @__PURE__ */ n.createElement("span", { className: qe.aside }, i.aside), u && /* @__PURE__ */ n.createElement("span", { className: qe.caret, "aria-hidden": "true" }, m ? "▾" : "▸"));
    return /* @__PURE__ */ n.createElement("li", { key: i.key, className: `${qe.item} ${qe[`row_${i.tone}`]}` }, u ? /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        className: qe.head,
        "aria-expanded": m,
        onClick: () => s((p) => ({ ...p, [i.key]: !m }))
      },
      _
    ) : /* @__PURE__ */ n.createElement("div", { className: qe.head }, _), m && /* @__PURE__ */ n.createElement("div", { className: qe.body }, i.detail, i.actions && /* @__PURE__ */ n.createElement("div", { className: qe.actions }, i.actions)));
  })) : /* @__PURE__ */ n.createElement("p", { className: `${qe.empty} ${r}` }, t);
}
function hh(e, t) {
  const a = Math.max(1, Math.floor(t) || 1), r = Math.min(a, Math.max(1, Math.floor(e) || 1)), o = (s, l) => Array.from({ length: l - s + 1 }, (c, i) => s + i);
  return a <= 10 ? o(1, a) : r <= 5 ? [...o(1, 7), "…", a] : r >= a - 4 ? [1, "…", ...o(a - 6, a)] : [1, "…", ...o(r - 2, r + 2), "…", a];
}
function gh(e, t) {
  const a = parseInt(e.replace(/[^\d]/g, ""), 10);
  return Number.isFinite(a) ? Math.min(Math.max(1, t), Math.max(1, a)) : null;
}
function wk(e) {
  return e === "page" ? "쪽 합계" : "전체 합계";
}
function Nk(e, t) {
  return Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t)));
}
const vh = "_nav_1r2z8_1", kh = "_list_1r2z8_3", wh = "_btn_1r2z8_4", Nh = "_cur_1r2z8_13", $h = "_gap_1r2z8_15", xh = "_total_1r2z8_16", Dh = "_jump_1r2z8_17", Ah = "_go_1r2z8_20", Ch = "_size_1r2z8_22", Sh = "_more_1r2z8_24", Mh = "_moreBtn_1r2z8_25", Th = "_moreN_1r2z8_29", he = {
  nav: vh,
  list: kh,
  btn: wh,
  cur: Nh,
  gap: $h,
  total: xh,
  jump: Dh,
  in: "_in_1r2z8_18",
  go: Ah,
  size: Ch,
  more: Sh,
  moreBtn: Mh,
  moreN: Th
};
function $k({ page: e, pageCount: t, onPageChange: a, jump: r = !1, pageSizes: o, pageSize: s, onPageSizeChange: l, total: c, className: i = "" }) {
  const u = Math.max(1, t), m = Math.min(u, Math.max(1, e)), [_, f] = A(String(m));
  U(() => f(String(m)), [m]);
  const p = (d) => {
    d !== m && d >= 1 && d <= u && a(d);
  }, y = () => {
    const d = gh(_, u);
    if (d === null) {
      f(String(m));
      return;
    }
    f(String(d)), p(d);
  };
  return /* @__PURE__ */ n.createElement("nav", { className: [he.nav, i].filter(Boolean).join(" "), "aria-label": "쪽 이동" }, c !== void 0 && /* @__PURE__ */ n.createElement("span", { className: he.total }, "총 ", c.toLocaleString("ko-KR"), "건"), /* @__PURE__ */ n.createElement("ol", { className: he.list }, /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(1), disabled: m === 1, "aria-label": "첫 쪽" }, "«")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m - 1), disabled: m === 1, "aria-label": "이전 쪽" }, "‹")), hh(m, u).map((d, b) => d === "…" ? /* @__PURE__ */ n.createElement("li", { key: `e${b}`, className: he.gap, "aria-hidden": "true" }, "…") : /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: [he.btn, d === m ? he.cur : ""].filter(Boolean).join(" "),
      onClick: () => p(d),
      "aria-current": d === m ? "page" : void 0,
      "aria-label": `${d}쪽`
    },
    d
  ))), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(m + 1), disabled: m === u, "aria-label": "다음 쪽" }, "›")), /* @__PURE__ */ n.createElement("li", null, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.btn, onClick: () => p(u), disabled: m === u, "aria-label": "마지막 쪽" }, "»"))), /* @__PURE__ */ n.createElement("span", { className: he.total }, "전체 ", u, "쪽"), r && /* @__PURE__ */ n.createElement("span", { className: he.jump }, /* @__PURE__ */ n.createElement(
    "input",
    {
      className: he.in,
      inputMode: "numeric",
      value: _,
      "aria-label": "이동할 쪽 번호",
      onChange: (d) => f(d.target.value.replace(/[^\d]/g, "")),
      onKeyDown: (d) => {
        d.key === "Enter" && (d.preventDefault(), y());
      }
    }
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: he.go, onClick: y }, "이동")), o && s !== void 0 && l && /* @__PURE__ */ n.createElement("label", { className: he.size }, "쪽당", /* @__PURE__ */ n.createElement("select", { value: s, onChange: (d) => l(Number(d.target.value)) }, o.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d, "건")))));
}
function xk({ shown: e, total: t, onMore: a, busy: r = !1, className: o = "" }) {
  return e >= t ? null : /* @__PURE__ */ n.createElement("div", { className: [he.more, o].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement("button", { type: "button", className: he.moreBtn, onClick: a, disabled: r, "aria-busy": r }, "더보기 ", /* @__PURE__ */ n.createElement("span", { className: he.moreN }, "(", e.toLocaleString("ko-KR"), "/", t.toLocaleString("ko-KR"), ")")));
}
const qh = "_ol_fbatg_1", Bh = "_li_fbatg_2", Lh = "_done_fbatg_5", jh = "_now_fbatg_5", Rh = "_item_fbatg_6", Ih = "_dot_fbatg_12", Oh = "_label_fbatg_19", Ph = "_opt_fbatg_21", Xh = "_sr_fbatg_22", st = {
  ol: qh,
  li: Bh,
  done: Lh,
  now: jh,
  item: Rh,
  dot: Ih,
  label: Oh,
  opt: Ph,
  sr: Xh
};
function Dk({ steps: e, current: t, onStepClick: a, className: r = "" }) {
  return /* @__PURE__ */ n.createElement("ol", { className: [st.ol, r].filter(Boolean).join(" "), "aria-label": `${e.length}단계 중 ${Math.min(t + 1, e.length)}단계` }, e.map((o, s) => {
    const l = s < t ? "done" : s === t ? "now" : "todo", c = /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", { className: st.dot, "aria-hidden": "true" }, l === "done" ? "✓" : s + 1), /* @__PURE__ */ n.createElement("span", { className: st.label }, o.label, o.optional && /* @__PURE__ */ n.createElement("span", { className: st.opt }, " (선택)"), l === "done" && /* @__PURE__ */ n.createElement("span", { className: st.sr }, " 완료"))), i = !!a && s <= t;
    return /* @__PURE__ */ n.createElement("li", { key: o.key, className: [st.li, st[l]].join(" "), "aria-current": l === "now" ? "step" : void 0 }, i ? /* @__PURE__ */ n.createElement("button", { type: "button", className: st.item, onClick: () => a(s, o) }, c) : /* @__PURE__ */ n.createElement("span", { className: st.item }, c));
  }));
}
const zh = "_root_7y5bc_5", Fh = "_block_7y5bc_6", Wh = "_svg_7y5bc_7", Hh = "_sm_7y5bc_8", Kh = "_md_7y5bc_9", Uh = "_lg_7y5bc_10", Gh = "_track_7y5bc_11", Yh = "_bar_7y5bc_12", Vh = "_spin_7y5bc_13", Qh = "_txt_7y5bc_15", Et = {
  root: zh,
  "axe-sp-in": "_axe-sp-in_7y5bc_1",
  block: Fh,
  svg: Wh,
  sm: Hh,
  md: Kh,
  lg: Uh,
  track: Gh,
  bar: Yh,
  spin: Vh,
  "axe-sp-rot": "_axe-sp-rot_7y5bc_1",
  txt: Qh,
  "axe-sp-blink": "_axe-sp-blink_7y5bc_1"
};
function Ak({ size: e = "md", value: t, label: a = "불러오는 중", delay: r = 300, block: o = !1, className: s = "" }) {
  const l = typeof t == "number", c = l ? Math.min(100, Math.max(0, t)) : 0, i = 15.9155;
  return /* @__PURE__ */ n.createElement(
    "span",
    {
      className: [Et.root, o ? Et.block : "", s].filter(Boolean).join(" "),
      style: { "--sp-delay": `${r}ms` },
      role: "status",
      "aria-live": "polite",
      "aria-busy": "true"
    },
    /* @__PURE__ */ n.createElement("svg", { className: [Et.svg, Et[e], l ? "" : Et.spin].filter(Boolean).join(" "), viewBox: "0 0 36 36", "aria-hidden": "true", focusable: "false" }, /* @__PURE__ */ n.createElement("circle", { className: Et.track, cx: "18", cy: "18", r: i, fill: "none" }), /* @__PURE__ */ n.createElement(
      "circle",
      {
        className: Et.bar,
        cx: "18",
        cy: "18",
        r: i,
        fill: "none",
        strokeDasharray: l ? `${c} ${100 - c}` : "25 75",
        transform: "rotate(-90 18 18)"
      }
    )),
    /* @__PURE__ */ n.createElement("span", { className: Et.txt }, a, l ? ` ${Math.round(c)}%` : "")
  );
}
const Jh = "_group_vdqk6_1", Zh = "_legend_vdqk6_2", eg = "_req_vdqk6_3", tg = "_opts_vdqk6_4", ng = "_inline_vdqk6_5", ag = "_all_vdqk6_6", rg = "_opt_vdqk6_4", og = "_compact_vdqk6_11", sg = "_dis_vdqk6_13", lg = "_radio_vdqk6_14", cg = "_check_vdqk6_14", ig = "_text_vdqk6_16", ug = "_hint_vdqk6_17", mg = "_err_vdqk6_18", dg = "_srOnly_vdqk6_20", me = {
  group: Jh,
  legend: Zh,
  req: eg,
  opts: tg,
  inline: ng,
  all: ag,
  opt: rg,
  compact: og,
  dis: sg,
  radio: lg,
  check: cg,
  text: ig,
  hint: ug,
  err: mg,
  srOnly: dg
};
function Gr({ legend: e, required: t, hidden: a }) {
  return /* @__PURE__ */ n.createElement("legend", { className: [me.legend, a ? me.srOnly : ""].filter(Boolean).join(" ") }, e, t && /* @__PURE__ */ n.createElement("span", { className: me.req }, " (필수)"));
}
function Ck({ name: e, legend: t, options: a, value: r, onChange: o, required: s, disabled: l, error: c, inline: i = !1, className: u = "", legendHidden: m = !1 }) {
  const _ = Qt("axe-rg-err");
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, u].filter(Boolean).join(" "),
      disabled: l,
      "aria-describedby": c ? _ : void 0,
      "aria-invalid": c ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Gr, { legend: t, required: s, hidden: m }),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, i ? me.inline : ""].filter(Boolean).join(" "), role: "radiogroup" }, a.map((f) => /* @__PURE__ */ n.createElement("label", { key: f.value, className: [me.opt, f.disabled ? me.dis : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
      "input",
      {
        type: "radio",
        className: me.radio,
        name: e,
        value: f.value,
        checked: r === f.value,
        disabled: f.disabled,
        required: s,
        onChange: () => o(f.value)
      }
    ), /* @__PURE__ */ n.createElement("span", { className: me.text }, f.label, f.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, f.hint))))),
    c && /* @__PURE__ */ n.createElement("p", { id: _, className: me.err }, c)
  );
}
function ir({ checked: e, indeterminate: t = !1, onChange: a, disabled: r, children: o, className: s = "", compact: l = !1, title: c }) {
  return /* @__PURE__ */ n.createElement("label", { title: c, className: [me.opt, l ? me.compact : "", r ? me.dis : "", s].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(
    "input",
    {
      type: "checkbox",
      className: me.check,
      checked: e,
      disabled: r,
      ref: (i) => {
        i && (i.indeterminate = t && !e);
      },
      onChange: (i) => a(i.target.checked)
    }
  ), o !== void 0 && /* @__PURE__ */ n.createElement("span", { className: me.text }, o));
}
function Sk({ legend: e, options: t, value: a, onChange: r, required: o, disabled: s, error: l, inline: c = !1, selectAll: i, className: u = "" }) {
  const m = Qt("axe-cg-err"), _ = t.filter((d) => !d.disabled).map((d) => d.value), f = _.length > 0 && _.every((d) => a.includes(d)), p = _.some((d) => a.includes(d)), y = (d, b) => r(b ? [...a, d] : a.filter((N) => N !== d));
  return /* @__PURE__ */ n.createElement(
    "fieldset",
    {
      className: [me.group, u].filter(Boolean).join(" "),
      disabled: s,
      "aria-describedby": l ? m : void 0,
      "aria-invalid": l ? !0 : void 0
    },
    /* @__PURE__ */ n.createElement(Gr, { legend: e, required: o }),
    i && /* @__PURE__ */ n.createElement("div", { className: me.all }, /* @__PURE__ */ n.createElement(
      ir,
      {
        checked: f,
        indeterminate: p && !f,
        onChange: (d) => r(d ? Array.from(/* @__PURE__ */ new Set([...a, ..._])) : a.filter((b) => !_.includes(b)))
      },
      i
    )),
    /* @__PURE__ */ n.createElement("div", { className: [me.opts, c ? me.inline : ""].filter(Boolean).join(" ") }, t.map((d) => /* @__PURE__ */ n.createElement(ir, { key: d.value, checked: a.includes(d.value), disabled: d.disabled, onChange: (b) => y(d.value, b) }, d.label, d.hint && /* @__PURE__ */ n.createElement("span", { className: me.hint }, d.hint)))),
    l && /* @__PURE__ */ n.createElement("p", { id: m, className: me.err }, l)
  );
}
const fg = "_list_13vw7_1", _g = "_tag_13vw7_2", pg = "_main_13vw7_3", yg = "_x_13vw7_6", bg = "_t_muted_13vw7_10", Eg = "_t_accent_13vw7_11", hg = "_t_ok_13vw7_12", gg = "_t_warn_13vw7_13", vg = "_t_danger_13vw7_14", kg = "_sel_13vw7_16", Ct = {
  list: fg,
  tag: _g,
  main: pg,
  x: yg,
  t_muted: bg,
  t_accent: Eg,
  t_ok: hg,
  t_warn: gg,
  t_danger: vg,
  sel: kg
};
function Mk({ children: e, tone: t = "muted", selected: a, onClick: r, onRemove: o, removeLabel: s, disabled: l, className: c = "" }) {
  const i = [Ct.tag, Ct[`t_${t}`], a ? Ct.sel : "", c].filter(Boolean).join(" "), u = s != null ? s : typeof e == "string" ? `${e} 삭제` : "태그 삭제";
  return /* @__PURE__ */ n.createElement("span", { className: i }, r ? /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.main, onClick: r, disabled: l, "aria-pressed": a }, a && /* @__PURE__ */ n.createElement("span", { "aria-hidden": "true" }, "✓ "), e) : /* @__PURE__ */ n.createElement("span", { className: Ct.main }, e), o && /* @__PURE__ */ n.createElement("button", { type: "button", className: Ct.x, onClick: o, disabled: l, "aria-label": u }, "✕"));
}
function Tk({ label: e, children: t, className: a = "" }) {
  return /* @__PURE__ */ n.createElement("ul", { className: [Ct.list, a].filter(Boolean).join(" "), "aria-label": e }, (Array.isArray(t) ? t : [t]).filter(Boolean).map((r, o) => /* @__PURE__ */ n.createElement("li", { key: o }, r)));
}
const wg = "_acc_1lmty_1", Ng = "_item_1lmty_2", $g = "_h_1lmty_3", xg = "_btn_1lmty_4", Dg = "_title_1lmty_8", Ag = "_meta_1lmty_9", Cg = "_chev_1lmty_10", Sg = "_open_1lmty_11", Mg = "_body_1lmty_12", lt = {
  acc: wg,
  item: Ng,
  h: $g,
  btn: xg,
  title: Dg,
  meta: Ag,
  chev: Cg,
  open: Sg,
  body: Mg
};
function qk({ items: e, single: t = !1, defaultOpen: a = [], openKeys: r, onOpenChange: o, headingLevel: s = 3, className: l = "" }) {
  const [c, i] = A(a), u = r != null ? r : c, m = Qt("axe-acc"), _ = `h${s}`, f = (p) => {
    const y = u.includes(p) ? u.filter((d) => d !== p) : t ? [p] : [...u, p];
    r === void 0 && i(y), o == null || o(y);
  };
  return /* @__PURE__ */ n.createElement("div", { className: [lt.acc, l].filter(Boolean).join(" ") }, e.map((p) => {
    const y = u.includes(p.key), d = `${m}-b-${p.key}`, b = `${m}-p-${p.key}`;
    return /* @__PURE__ */ n.createElement("div", { key: p.key, className: [lt.item, y ? lt.open : ""].filter(Boolean).join(" ") }, /* @__PURE__ */ n.createElement(_, { className: lt.h }, /* @__PURE__ */ n.createElement(
      "button",
      {
        type: "button",
        id: d,
        className: lt.btn,
        "aria-expanded": y,
        "aria-controls": b,
        disabled: p.disabled,
        onClick: () => f(p.key)
      },
      /* @__PURE__ */ n.createElement("span", { className: lt.title }, p.title),
      p.meta && /* @__PURE__ */ n.createElement("span", { className: lt.meta }, p.meta),
      /* @__PURE__ */ n.createElement("span", { className: lt.chev, "aria-hidden": "true" }, "▾")
    )), /* @__PURE__ */ n.createElement("div", { id: b, role: "region", "aria-labelledby": d, hidden: !y, className: lt.body }, p.content));
  }));
}
const Tg = "_stack_1u83j_2", qg = "_toast_1u83j_3", Bg = "_t_danger_1u83j_9", Lg = "_ico_1u83j_10", jg = "_t_ok_1u83j_11", Rg = "_msg_1u83j_12", Ig = "_act_1u83j_13", Og = "_x_1u83j_15", St = {
  stack: Tg,
  toast: qg,
  "axe-toast-in": "_axe-toast-in_1u83j_1",
  t_danger: Bg,
  ico: Lg,
  t_ok: jg,
  msg: Rg,
  act: Ig,
  x: Og
}, Yr = Bn(null);
let Pg = 0;
function Bk() {
  const e = qn(Yr);
  if (!e) throw new Error("useAXErpToast 는 AXErpToastProvider 안에서만 쓴다");
  return e;
}
function Xg({ item: e, onClose: t }) {
  var l, c;
  const [a, r] = A(!1), o = (l = e.duration) != null ? l : e.action ? 8e3 : 4e3;
  U(() => {
    if (a || o === 0) return;
    const i = window.setTimeout(t, o);
    return () => window.clearTimeout(i);
  }, [a, o, t, e.message]);
  const s = (c = e.tone) != null ? c : "info";
  return /* @__PURE__ */ n.createElement(
    "div",
    {
      className: [St.toast, St[`t_${s}`]].join(" "),
      role: s === "danger" ? "alert" : void 0,
      onMouseEnter: () => r(!0),
      onMouseLeave: () => r(!1),
      onFocus: () => r(!0),
      onBlur: () => r(!1)
    },
    /* @__PURE__ */ n.createElement("span", { className: St.ico, "aria-hidden": "true" }, s === "ok" ? "✓" : s === "danger" ? "▲" : "ⓘ"),
    /* @__PURE__ */ n.createElement("span", { className: St.msg }, e.message),
    e.action && /* @__PURE__ */ n.createElement("button", { type: "button", className: St.act, onClick: () => {
      e.action.onAction(), t();
    } }, e.action.label),
    /* @__PURE__ */ n.createElement("button", { type: "button", className: St.x, onClick: t, "aria-label": "알림 닫기" }, "✕")
  );
}
function Lk({ children: e }) {
  const [t, a] = A([]), r = B(t);
  r.current = t;
  const o = re((c) => a((i) => i.filter((u) => u.id !== c)), []), s = re((c) => {
    const i = typeof c == "string" ? { message: c } : c, u = r.current.find((_) => _.message === i.message);
    if (u)
      return a((_) => _.map((f) => f.id === u.id ? { ...f, ...i } : f)), u.id;
    const m = ++Pg;
    return a((_) => [..._, { ...i, id: m }].slice(-3)), m;
  }, []), l = ke(() => ({ toast: s, dismiss: o }), [s, o]);
  return /* @__PURE__ */ n.createElement(Yr.Provider, { value: l }, e, /* @__PURE__ */ n.createElement("div", { className: St.stack, role: "status", "aria-live": "polite", "aria-atomic": "false" }, t.map((c) => /* @__PURE__ */ n.createElement(Xg, { key: c.id, item: c, onClose: () => o(c.id) }))));
}
const zg = [
  {
    title: "공통",
    items: [
      { keys: ["?"], text: "단축키 도움말 열기 (입력 칸 밖에서)" },
      { keys: ["Tab", "Shift+Tab"], text: "다음·이전 입력 칸 / 버튼으로 이동" },
      { keys: ["Esc"], text: "열린 달력·메뉴·대화상자 닫기, 입력 중이던 값 취소" },
      { keys: ["Ctrl+Enter"], text: "저장 (저장 버튼 옆에 표기된 화면)" }
    ]
  },
  {
    title: "날짜 입력 칸",
    items: [
      { keys: ["숫자만"], text: "20260930 · 260930 · 0930 처럼 구분 기호 없이 입력" },
      { keys: ["↑", "↓"], text: "하루 뒤·앞 (월 입력은 한 달)" },
      { keys: ["PageUp", "PageDown"], text: "한 달 앞·뒤 (월 입력은 한 해)" },
      { keys: ["T"], text: "오늘" },
      { keys: ["F2", "F4", "Alt+↓"], text: "달력 열기" }
    ]
  },
  {
    title: "코드 입력 칸",
    items: [
      { keys: ["코드·명칭 입력"], text: "입력하는 동안 후보 표시" },
      { keys: ["↑", "↓"], text: "후보 선택" },
      { keys: ["Enter"], text: "선택한 후보 확정" },
      { keys: ["F2"], text: "전체 검색 창 열기" }
    ]
  },
  {
    title: "표 (행·칸 이동)",
    items: [
      { keys: ["←", "→", "↑", "↓"], text: "칸 이동" },
      { keys: ["Home", "End"], text: "줄의 처음·끝 칸" },
      { keys: ["Ctrl+Home", "Ctrl+End"], text: "표의 처음·끝 칸" },
      { keys: ["Enter", "Space"], text: "행 열기 (행 클릭이 되는 표)" }
    ]
  },
  {
    title: "달력 (달력에 포커스가 있을 때)",
    items: [
      { keys: ["T"], text: "오늘로" },
      { keys: ["N", "PageDown"], text: "다음 기간" },
      { keys: ["P", "PageUp"], text: "이전 기간" },
      { keys: ["M", "W", "D", "A"], text: "월 · 주 · 일 · 목록 보기" },
      { keys: ["C"], text: "일정 추가" }
    ]
  },
  {
    title: "간트 · 칸반 (막대·카드에 포커스)",
    items: [
      { keys: ["←", "→"], text: "간트: 막대 옮기기" },
      { keys: ["Shift+←", "Shift+→"], text: "간트: 끝 날짜 조절" },
      { keys: ["Alt+←", "Alt+→"], text: "간트: 시작 날짜 조절 / 칸반: 옆 열로 옮기기" },
      { keys: ["Enter"], text: "열기" }
    ]
  },
  {
    title: "메뉴",
    items: [
      { keys: ["↓"], text: "메뉴 열기 · 다음 항목" },
      { keys: ["↑", "Home", "End"], text: "이전 · 처음 · 마지막 항목" },
      { keys: ["Esc"], text: "닫고 버튼으로 돌아가기" }
    ]
  }
];
function Fg(e, t, a) {
  return a || t.ctrl || t.alt || t.meta ? !1 : e === "?";
}
const Wg = "_grid_yplhe_1", Hg = "_group_yplhe_2", Kg = "_h_yplhe_3", Ug = "_list_yplhe_4", Gg = "_row_yplhe_5", Yg = "_keys_yplhe_6", Vg = "_text_yplhe_7", Qg = "_or_yplhe_8", Jg = "_kbd_yplhe_9", ct = {
  grid: Wg,
  group: Hg,
  h: Kg,
  list: Ug,
  row: Gg,
  keys: Yg,
  text: Vg,
  or: Qg,
  kbd: Jg
};
function Zg({ onClose: e, extra: t }) {
  const a = [...t != null ? t : [], ...zg];
  return /* @__PURE__ */ n.createElement(Pn, { title: "단축키", onClose: e, closeOnEsc: !0, confirmDiscard: !1, wide: !0 }, /* @__PURE__ */ n.createElement("div", { className: ct.grid }, a.map((r) => /* @__PURE__ */ n.createElement("section", { key: r.title, className: ct.group }, /* @__PURE__ */ n.createElement("h3", { className: ct.h }, r.title), /* @__PURE__ */ n.createElement("dl", { className: ct.list }, r.items.map((o, s) => /* @__PURE__ */ n.createElement("div", { key: s, className: ct.row }, /* @__PURE__ */ n.createElement("dt", { className: ct.keys }, o.keys.map((l, c) => /* @__PURE__ */ n.createElement("span", { key: l }, c > 0 && /* @__PURE__ */ n.createElement("span", { className: ct.or }, " 또는 "), /* @__PURE__ */ n.createElement("kbd", { className: ct.kbd }, l)))), /* @__PURE__ */ n.createElement("dd", { className: ct.text }, o.text))))))));
}
function ev(e) {
  const t = e;
  return !t || typeof t.closest != "function" ? !1 : !!t.closest('input, textarea, select, [contenteditable="true"], [role="combobox"], [role="textbox"]');
}
function jk(e = {}) {
  const { enabled: t = !0, extra: a } = e, [r, o] = A(!1);
  return U(() => {
    if (!t) return;
    const s = (l) => {
      Fg(l.key, { ctrl: l.ctrlKey, alt: l.altKey, meta: l.metaKey }, ev(l.target)) && (document.querySelector('[role="dialog"][aria-modal="true"]') || (l.preventDefault(), o(!0)));
    };
    return document.addEventListener("keydown", s), () => document.removeEventListener("keydown", s);
  }, [t]), { open: () => o(!0), dialog: r ? /* @__PURE__ */ n.createElement(Zg, { extra: a, onClose: () => o(!1) }) : null };
}
const ur = 30, tv = BigInt(10);
function Yt(e) {
  let t = BigInt(1);
  for (let a = 0; a < e; a += 1) t = t * tv;
  return t;
}
function ut(e, t = 0) {
  return { u: e, s: t };
}
const Vr = ut(BigInt(0));
function Qr(e, t) {
  if (e.s === t.s) return [e.u, t.u, e.s];
  const a = Math.max(e.s, t.s);
  return [e.u * Yt(a - e.s), t.u * Yt(a - t.s), a];
}
function pn(e, t) {
  const [a, r, o] = Qr(e, t);
  return ut(a + r, o);
}
function va(e, t) {
  const [a, r, o] = Qr(e, t);
  return ut(a - r, o);
}
function Ze(e, t) {
  return ut(e.u * t.u, e.s + t.s);
}
function Lt(e, t) {
  if (t.u === BigInt(0)) return null;
  const a = e.u * Yt(t.s + ur), r = t.u * Yt(e.s);
  return ut(a / r, ur);
}
function Jr(e) {
  return ut(-e.u, e.s);
}
function mt(e, t, a) {
  if (t >= e.s)
    return ut(e.u * Yt(t - e.s), t);
  const r = Yt(e.s - t), o = e.u < BigInt(0), s = o ? -e.u : e.u, l = s / r, c = s % r;
  let i;
  return c === BigInt(0) || a === "down" ? i = l : a === "up" ? i = l + BigInt(1) : i = c * BigInt(2) >= r ? l + BigInt(1) : l, ut(o ? -i : i, t);
}
function be(e) {
  const t = e.trim().replace(/,/g, "");
  if (!/^[+-]?(\d+(\.\d*)?|\.\d+)$/.test(t)) return null;
  const a = t.startsWith("-"), r = t.replace(/^[+-]/, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o) + r.slice(o + 1), l = o < 0 ? 0 : r.length - o - 1, c = BigInt(s === "" ? "0" : s);
  return ut(a ? -c : c, l);
}
function ka(e) {
  var a;
  const t = be(String(e));
  return t || ((a = be(e.toFixed(20))) != null ? a : Vr);
}
function He(e, t = e.s, a = !1) {
  const r = mt(e, Math.max(t, 0), "half"), o = r.u < BigInt(0), s = (o ? -r.u : r.u).toString().padStart(t + 1, "0"), l = s.length - t;
  let c = s.slice(0, l);
  const i = s.slice(l);
  return a && (c = c.replace(/\B(?=(\d{3})+(?!\d))/g, ",")), (o ? "-" : "") + c + (t > 0 ? "." + i : "");
}
function ua(e) {
  const t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(e.trim());
  if (!t) return null;
  const a = Number(t[1]), r = Number(t[2]), o = Number(t[3]);
  return r < 1 || r > 12 || o < 1 || o > Le(a, r) ? null : { y: a, m: r, d: o };
}
function Ht({ y: e, m: t, d: a }) {
  const r = Math.floor((14 - t) / 12), o = e + 4800 - r, s = t + 12 * r - 3;
  return a + Math.floor((153 * s + 2) / 5) + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) - 32045;
}
function Zr(e, t) {
  const a = Ht(e) + t + 32044, r = Math.floor((4 * a + 3) / 146097), o = a - Math.floor(146097 * r / 4), s = Math.floor((4 * o + 3) / 1461), l = o - Math.floor(1461 * s / 4), c = Math.floor((5 * l + 2) / 153);
  return {
    d: l - Math.floor((153 * c + 2) / 5) + 1,
    m: c + 3 - 12 * Math.floor(c / 10),
    y: 100 * r + s - 4800 + Math.floor(c / 10)
  };
}
function eo(e, t, a = "exclude-first") {
  const r = Ht(e) > Ht(t), o = r ? t : e, s = r ? e : t, l = a === "include-first", c = Ht(s) - Ht(o) + (l ? 1 : 0), i = l ? Zr(s, 1) : s;
  let u = i.y - o.y, m = i.m - o.m, _ = i.d - o.d;
  if (_ < 0) {
    m -= 1;
    const f = i.m === 1 ? 12 : i.m - 1, p = i.m === 1 ? i.y - 1 : i.y;
    _ += Le(p, f);
  }
  return m < 0 && (u -= 1, m += 12), { days: c, y: u, m, d: _, swapped: r };
}
function Tn(e, t) {
  return Zr(e, t);
}
function mr(e, t) {
  const a = e.y * 12 + (e.m - 1) + t, r = Math.floor(a / 12), o = a % 12 + 1;
  return { y: r, m: o, d: Math.min(e.d, Le(r, o)) };
}
const nv = ["월", "화", "수", "목", "금", "토", "일"];
function ma(e) {
  return nv[Ht(e) % 7];
}
function Pe(e) {
  return `${e.y}-${String(e.m).padStart(2, "0")}-${String(e.d).padStart(2, "0")}`;
}
const rn = [
  { code: "KRW", label: "원", per: 1, krw: "1" },
  { code: "JPY", label: "엔", per: 100, krw: "941.20" },
  { code: "USD", label: "달러", per: 1, krw: "1386.50" },
  { code: "EUR", label: "유로", per: 1, krw: "1501.30" },
  { code: "CNY", label: "위안", per: 1, krw: "190.40" },
  { code: "GBP", label: "파운드", per: 1, krw: "1752.80" }
], ea = {
  원: "KRW",
  엔: "JPY",
  달러: "USD",
  불: "USD",
  유로: "EUR",
  위안: "CNY",
  파운드: "GBP"
};
function dr(e) {
  var t;
  return (t = ea[e]) != null ? t : e in ea ? ea[e] : null;
}
function da(e, t) {
  return e.find((a) => a.code === t);
}
function to(e) {
  return e.code === "KRW" ? "KRW 기준" : `${e.code} ${e.per} = ${e.krw}원`;
}
function no(e, t, a, r) {
  const o = da(e, a), s = da(e, r);
  if (!o || !s) return null;
  const l = be(o.krw), c = be(s.krw), i = be(String(o.per)), u = be(String(s.per));
  if (!l || !c || !i || !u) return null;
  const m = Lt(Ze(t, l), i);
  if (!m) return null;
  const _ = Lt(Ze(m, u), c);
  return _ ? {
    value: mt(_, 2, "half"),
    notice: `${to(o)} · 참고용 환율`
  } : null;
}
function av(e, t) {
  let a = null;
  for (const o of e)
    if (o.value) {
      if (a === null) {
        a = o.sign === "-" ? Jr(o.value) : o.value;
        continue;
      }
      switch (o.sign) {
        case "+":
          a = pn(a, o.value);
          break;
        case "-":
          a = va(a, o.value);
          break;
        case "*":
          a = Ze(a, o.value);
          break;
        default: {
          const s = Lt(a, o.value);
          if (!s) return { ok: !1, error: "divide-by-zero" };
          a = s;
          break;
        }
      }
    }
  const r = a != null ? a : Vr;
  return { ok: !0, value: t ? mt(r, t.digits, t.mode) : r };
}
const fr = [
  { key: "+", label: "+", hot: "A" },
  { key: "-", label: "−", hot: "S" },
  { key: "*", label: "×", hot: "D" },
  { key: "/", label: "÷", hot: "F" }
];
function ln() {
  return { sign: "+", text: "" };
}
function rv(e) {
  const t = e.replace(/[^\d.-]/g, ""), a = t.startsWith("-"), r = t.replace(/-/g, ""), o = r.indexOf("."), s = o < 0 ? r : r.slice(0, o), l = o < 0 ? "" : "." + r.slice(o + 1).replace(/\./g, "");
  return (a ? "-" : "") + s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + l;
}
function ov(e) {
  return e.map((t) => ({ sign: t.sign, value: be(t.text) }));
}
function sv(e) {
  const { lines: t, onLines: a, active: r, onActive: o, digits: s, onDigits: l, mode: c, onMode: i } = e, u = B([]), m = Math.min(r, t.length - 1);
  U(() => {
    var g;
    (g = u.current[m]) == null || g.focus();
  }, [m, t.length]);
  const _ = av(ov(t), { digits: s, mode: c }), f = _.ok ? He(_.value, s, !0) : "0으로 나눌 수 없음", p = (g, x) => {
    a(t.map((h, w) => w === g ? { ...h, ...x } : h));
  }, y = (g = t.length, x = "") => {
    const h = [...t];
    h.splice(g, 0, { ...ln(), text: x }), a(h), o(g);
  }, d = (g) => {
    if (t.length === 1) {
      a([ln()]);
      return;
    }
    a(t.filter((x, h) => h !== g)), o(Math.max(0, g - 1));
  }, b = () => {
    _.ok && y(t.length, He(_.value, s, !0));
  }, N = (g, x) => {
    const h = g.key, w = lv(h);
    if (w && !(h === "-" && t[x].text === "")) {
      g.preventDefault(), p(x, { sign: w });
      return;
    }
    if (h === "v" || h === "V") {
      g.preventDefault(), b();
      return;
    }
    h === "Enter" ? (g.preventDefault(), x === t.length - 1 ? y() : o(x + 1)) : h === "ArrowDown" ? (g.preventDefault(), o(Math.min(x + 1, t.length - 1))) : h === "ArrowUp" ? (g.preventDefault(), o(Math.max(x - 1, 0))) : h === "Insert" ? (g.preventDefault(), y(x + 1)) : h === "Delete" && t[x].text === "" ? (g.preventDefault(), d(x)) : h === "F4" && (g.preventDefault(), $());
  }, $ = () => {
    a([ln()]), o(0);
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-general" }, /* @__PURE__ */ n.createElement("div", { className: "bical-side" }, /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => y(m + 1) }, "행 추가 (Ins)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: () => d(m) }, "행 삭제 (Del)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: b }, "현재금액추가 (V)"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-key", onClick: $ }, "초기화 (F4)")), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "부호"), /* @__PURE__ */ n.createElement("div", { className: "bical-keys" }, fr.map((g) => {
    var x;
    return /* @__PURE__ */ n.createElement(
      "button",
      {
        key: g.key,
        type: "button",
        className: "bical-key",
        "aria-pressed": ((x = t[m]) == null ? void 0 : x.sign) === g.key,
        onClick: () => p(m, { sign: g.key })
      },
      g.label,
      " (",
      g.hot,
      ")"
    );
  })), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "결과값 자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "결과값 자리수", className: "bical-select", value: s, onChange: (g) => l(Number(g.target.value)) }, [0, 1, 2, 3, 4].map((g) => /* @__PURE__ */ n.createElement("option", { key: g, value: g }, g))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "표기방법"), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기방법", className: "bical-select", value: c, onChange: (g) => i(g.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { style: { flex: 1 } }, /* @__PURE__ */ n.createElement("div", { className: "bical-grid" }, t.map((g, x) => {
    var h;
    return /* @__PURE__ */ n.createElement("div", { key: x, className: `bical-line${x === m ? " bical-line--active" : ""}` }, /* @__PURE__ */ n.createElement("span", { className: "bical-caret" }, x === m ? "❯" : ""), /* @__PURE__ */ n.createElement("span", { className: "bical-sign" }, (h = fr.find((w) => w.key === g.sign)) == null ? void 0 : h.label), /* @__PURE__ */ n.createElement(
      "input",
      {
        ref: (w) => {
          u.current[x] = w;
        },
        value: g.text,
        inputMode: "decimal",
        "aria-label": `${x + 1}번째 금액`,
        onFocus: () => o(x),
        onChange: (w) => p(x, { text: rv(w.target.value) }),
        onKeyDown: (w) => N(w, x)
      }
    ));
  })), /* @__PURE__ */ n.createElement("div", { className: `bical-result${_.ok ? "" : " bical-error"}` }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "결과값 · 좌→우 순차 계산(연산자 우선순위 없음)"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, f))));
}
function lv(e) {
  const t = e.toLowerCase();
  return t === "a" || e === "+" ? "+" : t === "s" || e === "-" ? "-" : t === "d" || e === "*" ? "*" : t === "f" || e === "/" ? "/" : null;
}
function cv(e) {
  const t = [];
  let a = 0;
  for (; a < e.length; ) {
    const r = e[a];
    if (r === " " || r === "	" || r === `
`)
      a += 1;
    else if (r >= "0" && r <= "9" || r === "." || r === ",") {
      let o = a;
      for (; o < e.length && (e[o] >= "0" && e[o] <= "9" || e[o] === "." || e[o] === ","); ) o += 1;
      const s = be(e.slice(a, o));
      if (!s) return null;
      t.push({ t: "num", v: s }), a = o;
    } else if (r === "+" || r === "-" || r === "*" || r === "/")
      t.push({ t: "op", v: r }), a += 1;
    else if (r === "(")
      t.push({ t: "(" }), a += 1;
    else if (r === ")")
      t.push({ t: ")" }), a += 1;
    else
      return null;
  }
  return t;
}
class iv {
  constructor(t) {
    this.tokens = t, this.at = 0;
  }
  parse() {
    const t = this.expr();
    return t.ok && this.at !== this.tokens.length ? { ok: !1, error: "syntax" } : t;
  }
  peek() {
    return this.tokens[this.at];
  }
  expr() {
    let t = this.term();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "+" && a.v !== "-") return t;
      this.at += 1;
      const r = this.term();
      if (!r.ok) return r;
      t = { ok: !0, value: a.v === "+" ? pn(t.value, r.value) : va(t.value, r.value) };
    }
  }
  term() {
    let t = this.unary();
    if (!t.ok) return t;
    for (; ; ) {
      const a = this.peek();
      if (!a || a.t !== "op" || a.v !== "*" && a.v !== "/") return t;
      this.at += 1;
      const r = this.unary();
      if (!r.ok) return r;
      if (a.v === "*")
        t = { ok: !0, value: Ze(t.value, r.value) };
      else {
        const o = Lt(t.value, r.value);
        if (!o) return { ok: !1, error: "divide-by-zero" };
        t = { ok: !0, value: o };
      }
    }
  }
  unary() {
    const t = this.peek();
    if (t && t.t === "op" && (t.v === "+" || t.v === "-")) {
      this.at += 1;
      const a = this.unary();
      return a.ok ? { ok: !0, value: t.v === "-" ? Jr(a.value) : a.value } : a;
    }
    return this.primary();
  }
  primary() {
    const t = this.peek();
    if (!t) return { ok: !1, error: "syntax" };
    if (t.t === "num")
      return this.at += 1, { ok: !0, value: t.v };
    if (t.t === "(") {
      this.at += 1;
      const a = this.expr();
      if (!a.ok) return a;
      const r = this.peek();
      return !r || r.t !== ")" ? { ok: !1, error: "syntax" } : (this.at += 1, a);
    }
    return { ok: !1, error: "syntax" };
  }
}
function uv(e) {
  const t = cv(e);
  return !t || t.length === 0 ? { ok: !1, error: "syntax" } : new iv(t).parse();
}
const cn = [
  "산술식 — 1,200만 + 350만 × 2",
  "비율 — 3,000,000의 15%",
  "기간 — 2026-01-01부터 2026-03-31까지 며칠",
  "날짜 가감 — 2026-07-17부터 90일 후",
  "환율 — 150만엔을 원화로 (참고용 환율)"
], mv = /(\d{4})\s*[.\-/년]\s*(\d{1,2})\s*[.\-/월]\s*(\d{1,2})\s*일?/g;
function dv(e, t) {
  return e.replace(/오늘/g, Pe(t)).replace(/내일/g, Pe(Tn(t, 1))).replace(/어제/g, Pe(Tn(t, -1)));
}
function fv(e) {
  const t = [];
  for (const a of e.matchAll(mv)) {
    const r = ua(`${a[1]}-${a[2].padStart(2, "0")}-${a[3].padStart(2, "0")}`);
    r && t.push(r);
  }
  return t;
}
const _v = /부터|까지|에서|일수|며칠|기간|차이|~/;
function pv(e, t) {
  if (t.length < 2 || !_v.test(e)) return null;
  const a = /초일\s*산입|양편넣기/.test(e), r = eo(t[0], t[1], a ? "include-first" : "exclude-first"), o = a ? "초일산입 말일산입" : "초일불산입 말일산입";
  return {
    ok: !0,
    explain: `${Pe(t[0])} ~ ${Pe(t[1])} 기간(${o})` + (r.swapped ? " · 역순 입력" : ""),
    value: `${r.days}일 (${r.y}년 ${r.m}개월 ${r.d}일)`
  };
}
const yv = /(\d+)\s*(일|주|개월|달|년)\s*(후|뒤|이후|전|이전)/;
function bv(e, t) {
  if (t.length !== 1) return null;
  const a = yv.exec(e);
  if (!a) return null;
  const r = Number(a[1]), o = a[3] === "전" || a[3] === "이전", s = o ? -r : r, l = t[0];
  let c;
  return a[2] === "일" ? c = Tn(l, s) : a[2] === "주" ? c = Tn(l, s * 7) : a[2] === "년" ? c = mr(l, s * 12) : c = mr(l, s), {
    ok: !0,
    explain: `${Pe(l)} 에서 ${r}${a[2]} ${o ? "전" : "후"}`,
    value: `${Pe(c)} (${ma(c)})`
  };
}
function Ev(e, t) {
  if (t.length === 0) return null;
  const a = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천)?\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  if (!a) return null;
  const r = a[2] ? ao(a[2]) : null, o = be(a[1]);
  if (!o) return null;
  const s = r ? Ze(o, r) : o, l = dr(a[3]);
  if (!l) return null;
  const i = l !== "KRW" ? "KRW" : dr(hv(e));
  if (!i || i === l) return null;
  const u = no(t, s, l, i);
  return u ? {
    ok: !0,
    explain: `${He(s, s.s, !0)} ${l} → ${i} · ${u.notice}`,
    value: `${He(u.value, 2, !0)} ${i}`
  } : null;
}
function hv(e) {
  const t = /(?:을|를|으로|로)\s*(엔|달러|불|유로|위안|파운드|원)/.exec(e);
  return t ? t[1] : "원";
}
const gv = {
  억: "100000000",
  천만: "10000000",
  백만: "1000000",
  십만: "100000",
  만: "10000",
  천: "1000",
  백: "100"
};
function ao(e) {
  var t;
  return (t = be(gv[e])) != null ? t : ka(1);
}
const vv = /((?:[\d,]+(?:\.\d+)?\s*(?:억|천만|백만|십만|만|천|백)\s*)+(?:[\d,]+(?:\.\d+)?)?)/g, kv = /([\d,]+(?:\.\d+)?)\s*(억|천만|백만|십만|만|천|백)?/g;
function wv(e) {
  return e.replace(vv, (t) => {
    let a = be("0"), r = !1;
    for (const o of t.matchAll(kv)) {
      const s = be(o[1]);
      s && (r = !0, a = pn(a, o[2] ? Ze(s, ao(o[2])) : s));
    }
    return r ? He(a, a.s) : t;
  });
}
const Nv = /원화|원|엔|씩|개월|개|명|건/g;
function $v(e) {
  return wv(e).replace(/(\d),(?=\d)/g, "$1").replace(/[×xX]/g, "*").replace(/÷/g, "/").replace(/더하기|플러스/g, "+").replace(/빼기|마이너스/g, "-").replace(/곱하기/g, "*").replace(/나누기/g, "/").replace(Nv, "").replace(/([\d.]+)\s*의\s*([\d.]+)\s*%/g, "($1*($2/100))").replace(/([\d.]+)\s*([+-])\s*([\d.]+)\s*%/g, "(($1)*(1$2$3/100))").trim();
}
const xv = /[+＋]?\s*(부가세|소비세|消費税)\s*(?:([\d.]+)\s*%)?\s*(가산|포함|税込|税抜)?\s*$/;
function Dv(e, t, a) {
  const r = be("1"), o = He(Ze(t, ka(100)), 0);
  if (a === "add")
    return {
      value: mt(Ze(e, pn(r, t)), 0, "half"),
      explain: `消費税 ${o}% 가산(税抜 기준)`
    };
  const s = Lt(Ze(e, t), pn(r, t));
  return {
    value: s ? mt(s, 0, "down") : e,
    explain: `消費税 ${o}% 역산(税込 기준 · 1円 미만 切捨て)`
  };
}
function Av(e, t) {
  var i;
  const a = e.trim();
  if (!a) return { ok: !1, supported: cn };
  const r = dv(a, t.today), o = fv(r), s = pv(r, o);
  if (s) return s;
  const l = bv(r, o);
  if (l) return l;
  const c = Ev(r, (i = t.rates) != null ? i : []);
  return c || Cv(r, t);
}
function Cv(e, t) {
  var u, m;
  const a = xv.exec(e), r = a ? e.slice(0, a.index) : e, o = $v(r);
  if (!o) return { ok: !1, supported: cn };
  const s = uv(o);
  if (!s.ok)
    return { ok: !1, supported: cn };
  if (!a)
    return { ok: !0, explain: o, value: _r(s.value), expr: o };
  const l = (m = (u = Sv(a[2])) != null ? u : t.taxRate) != null ? m : null;
  if (!l)
    return {
      ok: !1,
      supported: ["소비세율을 아직 받지 못했습니다 — 세제개정 기준값을 불러오면 계산합니다", ...cn]
    };
  const c = a[3] === "가산" || a[3] === "税抜" ? "add" : "extract", i = Dv(s.value, l, c);
  return {
    ok: !0,
    explain: `${o} · ${i.explain}`,
    value: _r(i.value),
    expr: o
  };
}
function Sv(e) {
  var a;
  if (!e) return null;
  const t = be(e);
  return t && (a = Lt(t, ka(100))) != null ? a : null;
}
function _r(e) {
  const t = mt(e, 2, "half"), a = mt(t, 0, "down");
  return va(t, a).u === BigInt(0) ? He(t, 0, !0) : He(t, 2, !0);
}
const We = {
  area: {
    label: "넓이",
    base: "㎡",
    units: [
      { key: "m2", label: "㎡", factor: "1" },
      { key: "are", label: "아르", factor: "100" },
      { key: "ha", label: "헥타르", factor: "10000" },
      { key: "km2", label: "㎢", factor: "1000000" },
      { key: "pyeong", label: "평", factor: "3.305785" },
      { key: "ft2", label: "ft²", factor: "0.09290304" },
      { key: "yd2", label: "yd²", factor: "0.83612736" },
      { key: "acre", label: "에이커", factor: "4046.8564224" }
    ]
  },
  mass: {
    label: "중량·질량",
    base: "g",
    units: [
      { key: "mg", label: "mg", factor: "0.001" },
      { key: "g", label: "g", factor: "1" },
      { key: "kg", label: "kg", factor: "1000" },
      { key: "t", label: "t", factor: "1000000" },
      { key: "don", label: "돈", factor: "3.75" },
      { key: "geun", label: "근", factor: "600" },
      { key: "oz", label: "oz", factor: "28.349523125" },
      { key: "lb", label: "lb", factor: "453.59237" }
    ]
  },
  length: {
    label: "길이",
    base: "m",
    units: [
      { key: "mm", label: "mm", factor: "0.001" },
      { key: "cm", label: "cm", factor: "0.01" },
      { key: "m", label: "m", factor: "1" },
      { key: "km", label: "km", factor: "1000" },
      { key: "in", label: "in", factor: "0.0254" },
      { key: "ft", label: "ft", factor: "0.3048" },
      { key: "yd", label: "yd", factor: "0.9144" },
      { key: "mile", label: "mile", factor: "1609.344" },
      { key: "shaku", label: "자(尺)", factor: "0.30303" }
    ]
  }
};
function pr(e, t) {
  const a = We[e].units.find((o) => o.key === t);
  if (!a) return null;
  const r = be(a.factor);
  if (!r) throw new Error("단위 변환 정보를 불러오지 못했습니다");
  return r;
}
function Mv(e, t, a, r, o = 4, s = "half") {
  const l = pr(e, t), c = pr(e, a);
  if (!l || !c) return null;
  const i = Lt(Ze(r, l), c);
  return i ? mt(i, o, s) : null;
}
const Tv = [0, 1, 2, 3, 4, 6], qv = [
  { key: "text", label: "AI 텍스트계산" },
  { key: "general", label: "일반계산" },
  { key: "date", label: "날짜계산" },
  { key: "unit", label: "단위계산" },
  { key: "fx", label: "환율계산" }
];
function Bv(e) {
  const { tab: t, onTab: a, seed: r, onClose: o, history: s, onHistory: l } = e, [c, i] = A(() => r == null ? [ln()] : [{ sign: "+", text: He(Xv(r), 0, !0) }]), [u, m] = A(0), [_, f] = A(0), [p, y] = A("half"), d = B(null);
  U(() => {
    const N = ($) => {
      $.key === "Escape" && ($.preventDefault(), o());
    };
    return document.addEventListener("keydown", N), () => document.removeEventListener("keydown", N);
  }, [o]), U(() => {
    var N, $;
    ($ = (N = d.current) == null ? void 0 : N.querySelector("[data-autofocus]")) == null || $.focus();
  }, [t]);
  const b = (N) => {
    const $ = [...c.filter((g) => g.text !== ""), { sign: "+", text: N }, ln()];
    i($), m($.length - 1), a("general");
  };
  return /* @__PURE__ */ n.createElement("div", { className: "bical-overlay", role: "presentation" }, /* @__PURE__ */ n.createElement("div", { className: "bical-modal", role: "dialog", "aria-modal": "true", "aria-label": "계산기", ref: d }, /* @__PURE__ */ n.createElement("div", { className: "bical-head" }, /* @__PURE__ */ n.createElement("span", { className: "bical-title" }, "계산기"), /* @__PURE__ */ n.createElement("span", { className: "bical-hint" }, "장부에 쓰지 않습니다 — 복사·일반계산 추가로만 내보냅니다"), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-x", "aria-label": "닫기", onClick: o }, "✕")), /* @__PURE__ */ n.createElement("div", { className: "bical-tabs", role: "tablist" }, qv.map((N) => /* @__PURE__ */ n.createElement(
    "button",
    {
      key: N.key,
      type: "button",
      role: "tab",
      className: "bical-tab",
      "aria-selected": N.key === t,
      onClick: () => a(N.key)
    },
    N.label
  ))), /* @__PURE__ */ n.createElement("div", { className: "bical-body" }, t === "text" && /* @__PURE__ */ n.createElement(Rv, { history: s, onHistory: l, onPush: b }), t === "general" && /* @__PURE__ */ n.createElement(
    sv,
    {
      lines: c,
      onLines: i,
      active: u,
      onActive: m,
      digits: _,
      onDigits: f,
      mode: p,
      onMode: y
    }
  ), t === "date" && /* @__PURE__ */ n.createElement(Iv, null), t === "unit" && /* @__PURE__ */ n.createElement(Ov, null), t === "fx" && /* @__PURE__ */ n.createElement(Pv, null)), /* @__PURE__ */ n.createElement("div", { className: "bical-foot" }, /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: o }, "닫기"))));
}
const Lv = [
  "1,200만 + 350만 × 2",
  "3,000,000의 15%",
  "2026-01-01부터 2026-03-31까지 며칠",
  "2026-07-17부터 90일 후",
  "150만엔을 원화로",
  "오늘부터 10일 후"
], jv = 20;
function Rv({ history: e, onHistory: t, onPush: a }) {
  var y;
  const [r, o] = A(""), [s, l] = A(null), [c, i] = A(!1), [u, m] = A(!1), _ = B(!1), f = ke(wa, []), p = (d) => {
    o(d), m(!1);
    const b = Av(d, { today: f, rates: rn, taxRate: null });
    l(b), d.trim() && t([d, ...e.filter((N) => N !== d)].slice(0, jv));
  };
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement(
    "textarea",
    {
      className: "bical-textarea",
      "aria-label": "계산할 문장",
      "data-autofocus": !0,
      value: r,
      placeholder: "문장으로 물어보세요 — Enter 계산 · Shift+Enter 줄바꿈",
      onChange: (d) => o(d.target.value),
      onCompositionStart: () => {
        _.current = !0;
      },
      onCompositionEnd: () => {
        _.current = !1;
      },
      onKeyDown: (d) => {
        d.key === "Enter" && !d.shiftKey && !_.current && !d.nativeEvent.isComposing && (d.preventDefault(), p(r));
      }
    }
  ), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, Lv.map((d) => /* @__PURE__ */ n.createElement("button", { key: d, type: "button", className: "bical-chip", onClick: () => p(d) }, d))), s && (s.ok ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, s.explain), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, s.value), /* @__PURE__ */ n.createElement("div", { className: "bical-chips" }, /* @__PURE__ */ n.createElement(
    "button",
    {
      type: "button",
      className: "bical-btn",
      onClick: () => {
        var d;
        (d = navigator.clipboard) == null || d.writeText(s.value).then(
          () => m(!0),
          () => m(!1)
        );
      }
    },
    u ? "복사함" : "결과복사"
  ), /* @__PURE__ */ n.createElement("button", { type: "button", className: "bical-btn", onClick: () => a(s.value) }, "일반계산에 추가"))) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, "읽지 못했습니다 — 지원하는 형식입니다"), /* @__PURE__ */ n.createElement("ul", { style: { margin: "4px 0 0", paddingLeft: 16 } }, ((y = s.supported) != null ? y : cn).map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, d))))), e.length > 0 && /* @__PURE__ */ n.createElement("div", { className: "bical-log" }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => i((d) => !d) }, "기록 ", e.length, "건 ", c ? "접기" : "펼치기"), c && /* @__PURE__ */ n.createElement("ol", null, e.map((d) => /* @__PURE__ */ n.createElement("li", { key: d }, /* @__PURE__ */ n.createElement("button", { type: "button", onClick: () => p(d) }, d))))), /* @__PURE__ */ n.createElement("div", { className: "bical-sub", style: { marginTop: 8 } }, "기록은 이 세션에만 남고 저장하지 않습니다."));
}
function Iv() {
  const e = ke(wa, []), [t, a] = A(Pe(e)), [r, o] = A(Pe(e)), [s, l] = A("exclude-first"), c = ua(t), i = ua(r), u = c && i ? eo(c, i, s) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "계산 방식"), /* @__PURE__ */ n.createElement("select", { "aria-label": "계산 방식", className: "bical-select", value: s, onChange: (m) => l(m.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "exclude-first" }, "초일불산입 말일산입"), /* @__PURE__ */ n.createElement("option", { value: "include-first" }, "초일산입 말일산입"))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기간"), /* @__PURE__ */ n.createElement("input", { "aria-label": "시작일", className: "bical-input", type: "date", "data-autofocus": !0, value: t, onChange: (m) => a(m.target.value) }), /* @__PURE__ */ n.createElement("span", null, "~"), /* @__PURE__ */ n.createElement("input", { "aria-label": "종료일", className: "bical-input", type: "date", value: r, onChange: (m) => o(m.target.value) })), u ? /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, Pe(c), "(", ma(c), ") ~ ", Pe(i), "(", ma(i), ")", u.swapped ? " · 역순 입력" : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, u.days.toLocaleString(), "일"), /* @__PURE__ */ n.createElement("div", { className: "bical-sub" }, "차이(년, 월, 일) — ", u.y, "년 ", u.m, "개월 ", u.d, "일")) : /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, "날짜를 두 개 모두 입력하세요."));
}
function Ov() {
  const [e, t] = A("area"), [a, r] = A(We.area.units[0].key), [o, s] = A(We.area.units[4].key), [l, c] = A(""), [i, u] = A(4), [m, _] = A("half"), f = (d) => {
    t(d), r(We[d].units[0].key), s(We[d].units[1].key), c("");
  }, p = be(l), y = p ? Mv(e, a, o, p, i, m) : null;
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "분류"), /* @__PURE__ */ n.createElement("select", { "aria-label": "분류", className: "bical-select", value: e, onChange: (d) => f(d.target.value) }, Object.keys(We).map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, We[d].label))), /* @__PURE__ */ n.createElement("span", { className: "bical-sub" }, "기준 ", We[e].base)), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "값"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "값",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: l,
      onChange: (d) => c(d.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 단위", className: "bical-select", value: a, onChange: (d) => r(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 단위", className: "bical-select", value: o, onChange: (d) => s(d.target.value) }, We[e].units.map((d) => /* @__PURE__ */ n.createElement("option", { key: d.key, value: d.key }, d.label)))), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "자리수"), /* @__PURE__ */ n.createElement("select", { "aria-label": "자리수", className: "bical-select", value: i, onChange: (d) => u(Number(d.target.value)) }, Tv.map((d) => /* @__PURE__ */ n.createElement("option", { key: d, value: d }, d))), /* @__PURE__ */ n.createElement("select", { "aria-label": "표기 방법", className: "bical-select", value: m, onChange: (d) => _(d.target.value) }, /* @__PURE__ */ n.createElement("option", { value: "half" }, "반올림"), /* @__PURE__ */ n.createElement("option", { value: "up" }, "올림"), /* @__PURE__ */ n.createElement("option", { value: "down" }, "버림"))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, yr(e, a), " → ", yr(e, o), " · 기준단위 1단계 환산"), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, y ? He(y, i, !0) : "—")));
}
function yr(e, t) {
  var a, r;
  return (r = (a = We[e].units.find((o) => o.key === t)) == null ? void 0 : a.label) != null ? r : t;
}
function Pv() {
  const e = ke(wa, []), [t, a] = A(Pe(e)), [r, o] = A("JPY"), [s, l] = A("KRW"), [c, i] = A(""), u = be(c), m = u ? no(rn, u, r, s) : null, _ = da(rn, r);
  return /* @__PURE__ */ n.createElement("div", null, /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "기준일자"), /* @__PURE__ */ n.createElement("input", { "aria-label": "기준일자", className: "bical-input", type: "date", value: t, onChange: (f) => a(f.target.value) })), /* @__PURE__ */ n.createElement("div", { className: "bical-row" }, /* @__PURE__ */ n.createElement("span", { className: "bical-label" }, "금액"), /* @__PURE__ */ n.createElement(
    "input",
    {
      className: "bical-input bical-num",
      "aria-label": "금액",
      "data-autofocus": !0,
      inputMode: "decimal",
      value: c,
      onChange: (f) => i(f.target.value.replace(/[^\d.-]/g, ""))
    }
  ), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 전 통화", className: "bical-select", value: r, onChange: (f) => o(f.target.value) }, rn.map((f) => /* @__PURE__ */ n.createElement("option", { key: f.code, value: f.code }, f.code, " (", f.label, ")"))), /* @__PURE__ */ n.createElement("span", null, "→"), /* @__PURE__ */ n.createElement("select", { "aria-label": "변환 후 통화", className: "bical-select", value: s, onChange: (f) => l(f.target.value) }, rn.map((f) => /* @__PURE__ */ n.createElement("option", { key: f.code, value: f.code }, f.code, " (", f.label, ")")))), /* @__PURE__ */ n.createElement("div", { className: "bical-result" }, /* @__PURE__ */ n.createElement("div", { className: "bical-explain" }, _ ? to(_) : ""), /* @__PURE__ */ n.createElement("div", { className: "bical-value" }, m ? He(m.value, 2, !0) : "—")), /* @__PURE__ */ n.createElement("div", { className: "bical-result bical-notice" }, /* @__PURE__ */ n.createElement("b", null, "참고용 환율입니다."), " 토·일·공휴일 데이터가 없고, 기준통화·전신환 구분(TTM/TTS/TTB)도 정해지지 않았습니다. 신고·장부 목적에 쓰지 마세요."));
}
function wa() {
  const e = /* @__PURE__ */ new Date();
  return { y: e.getFullYear(), m: e.getMonth() + 1, d: e.getDate() };
}
function Xv(e) {
  var t;
  return mt((t = be(String(e))) != null ? t : be("0"), 0, "half");
}
const ro = Bn(null);
function Rk({ children: e }) {
  const [t, a] = A(!1), [r, o] = A("text"), [s, l] = A(null), [c, i] = A([]), [u, m] = A(0), _ = ke(() => ({
    open: (f) => {
      var p, y;
      o((p = f == null ? void 0 : f.tab) != null ? p : "text"), l((y = f == null ? void 0 : f.seed) != null ? y : null), m((d) => d + 1), a(!0);
    },
    close: () => a(!1)
  }), []);
  return /* @__PURE__ */ n.createElement(ro.Provider, { value: _ }, e, t && /* @__PURE__ */ n.createElement(
    Bv,
    {
      key: u,
      tab: r,
      onTab: o,
      seed: s,
      onClose: _.close,
      history: c,
      onHistory: i
    }
  ));
}
function Ik() {
  var e;
  return (e = qn(ro)) != null ? e : { open: () => {
  }, close: () => {
  } };
}
class Ok extends br {
  constructor() {
    super(...arguments), this.rootRef = lo(), this.resizeSensor = null;
  }
  componentDidMount() {
    this.rootRef.current && (this.resizeSensor = new wr(this.rootRef.current, this.props.onResize));
  }
  componentWillUnmount() {
    this.resizeSensor && (this.resizeSensor.detach(), this.resizeSensor = null);
  }
  render() {
    const { onResize: t, children: a, ...r } = this.props;
    return /* @__PURE__ */ n.createElement("div", { ref: this.rootRef, ...r }, a);
  }
}
export {
  Vf as $,
  qk as A,
  Ep as B,
  Bv as C,
  F0 as D,
  G0 as E,
  R0 as F,
  I0 as G,
  gk as H,
  s0 as I,
  Xo as J,
  qc as K,
  Gc as L,
  o0 as M,
  mn as N,
  na as O,
  tk as P,
  vk as Q,
  rk as R,
  ok as S,
  pa as T,
  xk as U,
  mk as V,
  fk as W,
  _k as X,
  x0 as Y,
  Pn as Z,
  D0 as _,
  cs as a,
  ra as a$,
  nk as a0,
  S0 as a1,
  dk as a2,
  yo as a3,
  Hv as a4,
  V0 as a5,
  $k as a6,
  r0 as a7,
  Uv as a8,
  hk as a9,
  J0 as aA,
  kr as aB,
  Mk as aC,
  Tk as aD,
  X_ as aE,
  Io as aF,
  Lk as aG,
  P0 as aH,
  jt as aI,
  d0 as aJ,
  C0 as aK,
  l0 as aL,
  Mr as aM,
  yk as aN,
  pk as aO,
  Or as aP,
  Qf as aQ,
  zg as aR,
  Br as aS,
  Vt as aT,
  Ok as aU,
  wr as aV,
  Qn as aW,
  $r as aX,
  A0 as aY,
  xm as aZ,
  V_ as a_,
  ck as aa,
  uk as ab,
  Wy as ac,
  ik as ad,
  G_ as ae,
  sk as af,
  Ck as ag,
  O0 as ah,
  a0 as ai,
  Vv as aj,
  n0 as ak,
  z_ as al,
  Zg as am,
  Qv as an,
  Zv as ao,
  Jv as ap,
  b0 as aq,
  p0 as ar,
  _0 as as,
  Ak as at,
  e0 as au,
  ak as av,
  Ha as aw,
  Dk as ax,
  y0 as ay,
  t0 as az,
  Gv as b,
  Bk as b$,
  Bi as b0,
  Li as b1,
  Dr as b2,
  W0 as b3,
  hp as b4,
  Ol as b5,
  q0 as b6,
  Fg as b7,
  Fl as b8,
  ey as b9,
  cE as bA,
  Kt as bB,
  Kr as bC,
  Lr as bD,
  N0 as bE,
  bm as bF,
  v0 as bG,
  i0 as bH,
  c0 as bI,
  zc as bJ,
  u0 as bK,
  Uc as bL,
  qr as bM,
  z0 as bN,
  Ik as bO,
  T0 as bP,
  Jf as bQ,
  X0 as bR,
  Pp as bS,
  M0 as bT,
  j0 as bU,
  L0 as bV,
  lk as bW,
  f0 as bX,
  B0 as bY,
  jk as bZ,
  Yv as b_,
  ls as ba,
  Kv as bb,
  zl as bc,
  Nr as bd,
  Nk as be,
  hh as bf,
  gh as bg,
  Mn as bh,
  zt as bi,
  H_ as bj,
  tn as bk,
  Wr as bl,
  K_ as bm,
  Wa as bn,
  k0 as bo,
  ti as bp,
  Yc as bq,
  Q_ as br,
  Hr as bs,
  $p as bt,
  Xl as bu,
  xr as bv,
  Pl as bw,
  Ms as bx,
  kp as by,
  wk as bz,
  Yf as c,
  m0 as c0,
  Qt as c1,
  bb as c2,
  bk as d,
  et as e,
  Rk as f,
  $0 as g,
  Sr as h,
  Sk as i,
  kk as j,
  ir as k,
  U0 as l,
  g0 as m,
  h0 as n,
  Q0 as o,
  E0 as p,
  H0 as q,
  K0 as r,
  Y0 as s,
  La as t,
  w0 as u,
  Ek as v,
  ek as w,
  Fr as x,
  Il as y,
  Z0 as z
};
